{
  "translations": {
    "accessbility.clickSelect": "Hacer clic para seleccionar la calificación",
    "accessbility.continueButton": "Continuar",
    "accessbility.continueSurvey": "Continuar con la encuesta",
    "accessbility.goNext": "Haga clic para ir a la siguiente pregunta",
    "accessbility.means": "medios",
    "accessbility.skipQuestion": "Haga clic para omitir esta pregunta",
    "accessibility.skipToContent": "Ir al contenido",
    "admin.question.nps": "eNPS",
    "anon.convo.click.here": "Introduzca su código aquí",
    "anon.convo.enter.code.here": "Introduzca su código aquí",
    "anonymity-dialog.content.anonymized.one": "Esta encuesta es administrada por WorkTango, un proveedor externo seguro. Es posible que los resultados se comuniquen utilizando información de atributos que se rastrea con su respuesta a la encuesta. Esta información se recopila a través de las preguntas de la encuesta o de los datos proporcionados por su organización (por ejemplo, función, ubicación, departamento, antigüedad). ",
    "anonymity-dialog.content.anonymized.two": "Para proteger su confidencialidad, los resultados sólo se comunicarán cuando haya{{threshold}} o más respuestas enviadas dentro de cualquier grupo de atributos (o combinaciones de grupos de atributos)",
    "anonymity-dialog.content.not-anonymized.one": "Esta encuesta no es anónima.",
    "anonymity-dialog.content.not-anonymized.three": "Gracias por su participación.",
    "anonymity-dialog.content.not-anonymized.two": "Sus respuestas individuales serán identificables y se le podrán atribuir. Sus comentarios sinceros son esenciales para que podamos mejorar, y agradecemos su disposición a compartir abiertamente sus opiniones.",
    "anonymity-dialog.title": "Cómo se comunicarán las respuestas",
    "anonymous.convo.email.reaction.great.idea": "acusó recibo de su comentario y piensa que es una gran idea.",
    "anonymous.convo.email.reaction.like": "ha indicado que \"le gusta\" su comentario.",
    "anonymous.convo.email.reaction.working.on.it": "reaccionó a su comentario y quiere informarle que está trabajando en ello.",
    "button.dismiss": "Desestimar",
    "button.skip": "Omitir",
    "comment.placeholder": "Escriba su comentario aquí",
    "comment.title": "Comentarios",
    "copyright": "Copyright {{year}} WorkTango Inc. Todos los derechos reservados.",
    "courier.anon.convo.click.here": "Vea la conversación",
    "courier.email.anon.convo.employee.have.replied": "un empleado ha respondido a una conversación anónima de la que usted forma parte. Según la promesa del empleado de WorkTango, su respuesta es confidencial.",
    "courier.email.privacy.policy": "Política de privacidad",
    "courier.email.support": "Soporte",
    "courier.email.you.received.email.because": "Ha recibido este correo electrónico como usuario de WorkTango.",
    "courier.feedback.details": "De acuerdo con WorkTango’s Employee Promise (promesa al empleado de WorkTango), su respuesta es confidencial. Haga clic en el siguiente enlace e introduzca su código personal para ver más.",
    "courier.general.hard.link": "Si el botón no funciona, pegue el siguiente enlace en su navegador:",
    "dismiss": "Descartar",
    "docTitle.kioskList": "WorkTango: seleccione una encuesta para continuar",
    "docTitle.kioskLogin": "Quiosco WorkTango: pantalla de inicio de sesión",
    "docTitle.surveyName": "Encuesta {{name}}",
    "dropdown.ariaLabel": "Seleccione una opción para {{question}}",
    "enps.question.greatPlace": "",
    "eric-04-03-new-library-question-q1": "¿Cuánto tiempo lleva viviendo en su actual país de residencia?",
    "eric-04-03-new-library-question-q2": "¿Necesita ausentarse durante su horario habitual de trabajo para las siguientes situaciones? Seleccione todas las que correspondan. \na) Para atender responsabilidades de cuidado\nb) Para rezar\nc) Para meditar\nd) Para atender una necesidad médica\ne) Para cuidar de mi bienestar mental\nf) Para trabajar cuando sea más eficiente\ng) No tengo que atender ninguna necesidad personal durante mi horario de trabajo \nh) Otros (especifique en la casilla de comentarios) \ni) Prefiero no contestar",
    "error.submission": "Se ha producido un error al enviar su respuesta:",
    "error.unknow": "Se ha producido un error desconocido. Actualice la página e inténtelo de nuevo.",
    "feedback.code": "Código personal:",
    "feedback.details": "Haga clic en el siguiente enlace e introduzca su código personal para ver más.",
    "feedback.email.subject.anon": "Su comentario completamente anónimo tienen una respuesta.",
    "feedback.has.replied.to.you": "respondió a su comentario de la encuesta.",
    "feedback.placeholder": "Introduzca su respuesta",
    "footer.poweredby": "Con tecnología de WorkTango",
    "general.click.here": "Haga clic aquí",
    "general.greeting": "Hola",
    "general.hard.link": "Si el botón no funciona, pegue el siguiente enlace en su navegador:",
    "graph.notEnough.header": "No hay suficientes datos aún",
    "hardcoded - dei - q1": "¿Se identifica o se ha identificado alguna vez como transgénero? Transgénero es un término general que se utiliza para describir a las personas cuya identidad o expresión de género difiere del sexo biológico que se les ha asignado al nacer.",
    "hardcoded - dei - q2": "Creo que la organización tomará las medidas adecuadas en respuesta a los casos de acoso.",
    "hardcoded - dei - q3": "Creo que la organización tomará las medidas adecuadas en respuesta a los casos de discriminación.",
    "hardcoded - library question 1 - question text": "Me siento seguro/a y cómodo/a cuando vengo a trabajar.",
    "hardcoded - library question 2 - question text": "El entorno de la organización permite un equilibrio entre el trabajo y la vida personal.",
    "kiosk.enterPlaceholder": "Introduzca su {{kiosk_id}}",
    "kiosk.footer": "Copyright {{year}} WorkTango Inc. Todos los derechos reservados.",
    "kiosk.login.error": "ID de quiosco no válido, inténtelo de nuevo",
    "kiosk.selectSurvey": "Seleccione una encuesta para continuar:",
    "kiosk.welcome": "Vea las encuestas disponibles introduciendo su {{kiosk_id}}.",
    "logic.cleanup": "Si cambia su respuesta, es posible que tenga que volver a contestar a alguna de las siguientes preguntas.",
    "logic.cleanup.warning": "Advertencia",
    "no.active.surveys.for": "No se encontraron encuestas activas para",
    "or": "o",
    "peopleResponded": "personas que respondieron",
    "required": "requerido",
    "result.avg": "AVG",
    "result.comments": "Comentarios",
    "result.positive": "Favorable",
    "saved": "Se ha guardado",
    "saving": "Guardando",
    "screenReader.option": "Opción {{option}}",
    "screenReader.peopleSelected": "El {{percent}} de las personas ha seleccionado esta opción.",
    "showing.all": "Todos los encuestados",
    "survey.anonymity-text.anonymized": "Cómo se comunicarán las respuestas",
    "survey.anonymity-text.details-here": "Detalles aquí.",
    "survey.anonymity-text.not-anonymized": "Esta encuesta no es anónima.",
    "survey.clickButtonText": "Haga clic aquí",
    "survey.confirm": "Haga clic a continuación para enviar sus respuestas",
    "survey.error.title": "Lo siento, se ha producido un error",
    "survey.expired.greeting": "La encuesta ha finalizado",
    "survey.expired.message": "Ya no puede introducir respuestas para esta encuesta.",
    "survey.kiosk.copyright": "© {{year}} Todos los derechos reservados",
    "survey.kiosk.login.button": "Abrir Encuesta",
    "survey.kiosk.poweredby": "Con tecnología",
    "survey.language.sr-rs": "Srpski",
    "survey.linkNotWorking": "Si el enlace anterior no funciona, copie y pegue el siguiente enlace en su explorador:",
    "survey.navigation.next": "Siguiente",
    "survey.navigation.position": "{{questionIndex}} de {{questionCount}}",
    "survey.navigation.previous": "Anterior",
    "survey.navigation.progress": "{{questionIndex}} de {{questionCount}} respondidas",
    "survey.navigation.screen-reader-label": "Número de Pregunta {{questionIndex}} de {{questionCount}}",
    "survey.navigation.screen-reader-message": "Este es un mensaje",
    "survey.not-applicable.message": "Esta encuesta está dirigida a un grupo específico y, por lo que vemos, tú no formas parte de él en este momento. No es necesario hacer nada más, gracias por tomarte un momento para comprobarlo.",
    "survey.not-applicable.title": "Esta vez no hay preguntas para ti",
    "survey.not-found.message": "No se encontró la encuesta. Póngase en contacto con la persona que le proporcionó este enlace de encuesta para obtener más información.",
    "survey.not-found.title": "Lo siento, está enlace no es válido.",
    "survey.open-survey.error-invalid-submission": "Ha habido un problema con tu envío. Actualiza la página e inténtalo de nuevo.",
    "survey.open-survey.error-not-available": "Esta encuesta no está disponible.",
    "survey.open-survey.error-not-in-progress": "Esta encuesta no está aceptando respuestas en este momento.",
    "survey.open-survey.error-response-limit-reached": "Esta encuesta no está aceptando más respuestas este mes.",
    "survey.open-survey.error-too-soon": "Tu respuesta ya fue recibida. Si querías enviarla de nuevo, espera unos minutos e inténtalo otra vez.",
    "survey.open-survey.loading": "Cargando encuesta...",
    "survey.open-survey.passcode-heading": "Introduce el código de acceso de tu encuesta",
    "survey.open-survey.passcode-incorrect": "El código de acceso no es correcto. Compruébalo e inténtalo de nuevo.",
    "survey.open-survey.passcode-label": "Introduce tu código de acceso",
    "survey.return": "Volver a la encuesta",
    "survey.schedule.messaging.preset.slack.1.body": "",
    "survey.schedule.messaging.preset.sms.1.body": "{{companyName}} valora tu opinión. Dedica un momento a completar esta encuesta. Tus comentarios son personales, así que te rogamos que no compartas este enlace.\n\n{{surveyUrl}}\n\nPueden aplicarse tarifas por mensajes y datos. Responde STOP para darte de baja.",
    "survey.schedule.messaging.preset.sms.10.body": "{{companyName}} te invita a participar en una encuesta para empleados. Este enlace es personal. Por favor, no lo compartas.\n\n{{surveyUrl}}\n\nPueden aplicarse tarifas por mensajes y datos. Responde STOP para darte de baja.",
    "survey.schedule.messaging.preset.sms.2.body": "{{companyName}}: Tu opinión nos importa. Rellena aquí tu encuesta confidencial para empleados (el enlace es exclusivo para ti, por favor, no lo compartas):\n\n{{surveyUrl}}\n\nPueden aplicarse tarifas por mensajes y datos. Responde STOP para darte de baja.",
    "survey.schedule.messaging.preset.sms.3.body": "{{companyName}} está llevando a cabo su encuesta a los empleados. Agradecemos tu participación.\nTu enlace es único; por favor, no lo reenvíes.\n\n{{surveyUrl}}\n\nPueden aplicarse tarifas por mensajes y datos. Responde STOP para darte de baja.",
    "survey.schedule.messaging.preset.sms.4.body": "¡Hola! {{companyName}} quiere conocer tu opinión. Tus comentarios sinceros nos ayudan a crear un lugar de trabajo mejor para todos.\nEste enlace es solo para ti, así que, por favor, no lo compartas con nadie.\n\n{{surveyUrl}}\n\nPueden aplicarse tarifas por mensajes y datos. Responde STOP para darte de baja.",
    "survey.schedule.messaging.preset.sms.5.body": "Encuesta de {{companyName}}: te llevará 2 minutos. Tu enlace (no lo compartas):\n\n{{surveyUrl}}\n\nPueden aplicarse tarifas por mensajes y datos. Responde STOP para darte de baja.",
    "survey.schedule.messaging.preset.sms.6.body": "{{companyName}} necesita tu opinión; solo te llevará unos minutos. Tu opinión determina lo que vendrá después.\nPulsa en el enlace para empezar. Es exclusivo para ti, no lo compartas.\n\n{{surveyUrl}}\n\nPueden aplicarse tarifas por mensajes y datos. Responde STOP para darte de baja.",
    "survey.schedule.messaging.preset.sms.7.body": "En {{companyName}}, crecemos juntos. Eso significa escuchar todas las opiniones, incluida la tuya.\nPor favor, rellena esta breve encuesta. Este enlace es exclusivo para ti.\n\n{{surveyUrl}}\n\nPueden aplicarse tarifas por mensajes y datos. Responde STOP para darte de baja.",
    "survey.schedule.messaging.preset.sms.8.body": "Gracias por todo lo que aportas a {{companyName}}. ¡Nos encantaría saber cómo te va! Esta breve encuesta te ofrece la oportunidad de compartir tu opinión sincera.\nTu enlace es único, por favor, no lo compartas.\n\n{{surveyUrl}}\n\nPueden aplicarse tarifas por mensajes y datos. Responde STOP para darte de baja.",
    "survey.schedule.messaging.preset.sms.9.body": "¡Hola, equipo! {{companyName}} quiere saber tu opinión. Solo te llevará unos minutos. Aquí tienes el enlace a la encuesta (es único para ti, por favor, no lo compartas):\n\n{{surveyUrl}}\n\nPueden aplicarse tarifas por mensajes y datos. Responde STOP para darte de baja.",
    "survey.submit": "Enviar",
    "survey.thanks.greeting": "Gracias.",
    "survey.thanks.message": "Sus respuestas se han enviado correctamente.",
    "survey.timeout-warning": "Su sesión se cerrará de manera automática en {{timeout}} segundos si no se detecta interacción de usuarios.",
    "survey.tryagain": "Intentar de nuevo",
    "survey.type.attributebased": "Basado en atributos",
    "surveyEmail.defaultContent": "<p>La única forma en que podemos mejorar como organización es oír la voz de nuestros empleados.</p><br /><p>Por favor rellene la encuesta haciendo clic en el siguiente enlace y háganos llegar sus sinceros comentarios. Sus comentarios son siempre anónimos.</p>",
    "surveyEmail.defaultTitle": "Necesitamos sus comentarios",
    "swal.button.ok": "Aceptar",
    "swal.confirm.cancel": "Cancelar",
    "swal.confirm.yes": "Sí",
    "swal.timeout.header": "¿Aún se encuentra allí?",
    "tableview.outof": "De",
    "text.ariaLabel": "Introduzca su comentario para {{question}}",
    "user.notice": "Aviso de privacidad",
    "user.policy": "Política de privacidad",
    "user.terms": "Condiciones de uso",
    "warning.anonymous": "Esta conversación es completamente anónima",
    "404.description": "No hemos podido encontrar la página que busca.",
    "404.title": "Parece que hay algún problema.",
    "ANONYMOUS_CONVERSATIONS": "Conversaciones anónimas",
    "Action": "Acción",
    "Africa/Cairo": "({{timezoneOffset}}) Cairo",
    "Africa/Harare": "({{timezoneOffset}}) Harare, Pretoria",
    "Africa/Lagos": "({{timezoneOffset}}) África Central Occidental",
    "Africa/Monrovia": "({{timezoneOffset}}) Casablanca, Monrovia",
    "Africa/Nairobi": "({{timezoneOffset}}) Nairobi",
    "America/Anchorage": "({{timezoneOffset}}) Alaska",
    "America/Argentina/Buenos_Aires": "({{timezoneOffset}}) Buenos Aires, Georgetown",
    "America/Bogota": "({{timezoneOffset}}) Bogotá, Lima, Quito",
    "America/Chihuahua": "({{timezoneOffset}}) Chihuahua, La Paz, Mazatlán",
    "America/Costa_Rica": "({{timezoneOffset}}) América Central",
    "America/Edmonton": "({{timezoneOffset}}) Hora de la montaña (EE. UU. y Canadá)",
    "America/Godthab": "({{timezoneOffset}}) Groenlandia",
    "America/Halifax": "({{timezoneOffset}}) Horario del Atlántico (Canadá)",
    "America/Indiana/Indianapolis": "({{timezoneOffset}}) Indiana (Este)",
    "America/La_Paz": "({{timezoneOffset}}) Caracas, La Paz",
    "America/Monterrey": "({{timezoneOffset}}) Guadalajara, Ciudad de México, Monterrey",
    "America/Phoenix": "({{timezoneOffset}}) Arizona",
    "America/Regina": "({{timezoneOffset}}) Saskatchewan",
    "America/Santiago": "({{timezoneOffset}}) Santiago",
    "America/Sao_Paulo": "({{timezoneOffset}}) Brasilia",
    "America/St_Johns": "({{timezoneOffset}}) Newfoundland y Labrador",
    "America/Toronto": "({{timezoneOffset}}) Horario del este (EE. UU. y Canadá)",
    "America/Vancouver": "({{timezoneOffset}}) Hora del Pacífico (EE. UU. y Canadá); Tijuana",
    "America/Winnipeg": "({{timezoneOffset}}) Horario central (EE. UU. y Canadá))",
    "Asia/Almaty": "({{timezoneOffset}}) Astaná, Dacca",
    "Asia/Baghdad": "({{timezoneOffset}}) Bagdad",
    "Asia/Baku": "({{timezoneOffset}}) Bakú, Tiflis, Ereván",
    "Asia/Bangkok": "({{timezoneOffset}}) Bangkok, Hanói, Yakarta",
    "Asia/Calcutta": "({{timezoneOffset}}) Chennai, Calcuta, Bombay, Nueva Deli",
    "Asia/Colombo": "({{timezoneOffset}}) Sri Jayawardenepura",
    "Asia/Irkutsk": "({{timezoneOffset}}) Irkutsk, Ulán Bator",
    "Asia/Jerusalem": "({{timezoneOffset}}) Jerusalén",
    "Asia/Kabul": "({{timezoneOffset}}) Kabul",
    "Asia/Kathmandu": "({{timezoneOffset}}) Katmandú",
    "Asia/Krasnoyarsk": "({{timezoneOffset}}) Krasnoiarsk",
    "Asia/Kuwait": "({{timezoneOffset}}) Kuwait, Riad",
    "Asia/Muscat": "({{timezoneOffset}}) Abu Dabi, Muscat",
    "Asia/Novosibirsk": "({{timezoneOffset}}) Almaty, Novosibirsk",
    "Asia/Rangoon": "({{timezoneOffset}}) Yangón Rangún",
    "Asia/Seoul": "({{timezoneOffset}}) Seúl",
    "Asia/Shanghai": "({{timezoneOffset}}) Pekín, Chongqing, Hong Kong SAR, Urumchi",
    "Asia/Singapore": "({{timezoneOffset}}) Kuala Lumpur, Singapur",
    "Asia/Taipei": "({{timezoneOffset}}) Taipéi",
    "Asia/Tashkent": "({{timezoneOffset}}) Islamabad, Karachi, Taskent",
    "Asia/Tehran": "({{timezoneOffset}}) Teherán",
    "Asia/Tokyo": "({{timezoneOffset}}) Osaka, Sapporo, Tokio",
    "Asia/Vladivostok": "({{timezoneOffset}}) Vladivostok",
    "Asia/Yakutsk": "({{timezoneOffset}}) Yakutsk",
    "Asia/Yekaterinburg": "({{timezoneOffset}}) Ekaterimburgo",
    "Atlantic/Azores": "({{timezoneOffset}}) Azores",
    "Atlantic/Cape_Verde": "({{timezoneOffset}}) Islas del Cabo Verde",
    "Atlantic/South_Georgia": "({{timezoneOffset}}) Atlántico central",
    "Australia/Adelaide": "({{timezoneOffset}}) Adelaida",
    "Australia/Brisbane": "({{timezoneOffset}}) Brisbane",
    "Australia/Darwin": "({{timezoneOffset}}) Darwin",
    "Australia/Hobart": "({{timezoneOffset}}) Hobart",
    "Australia/Perth": "({{timezoneOffset}}) Perth",
    "Australia/Sydney": "({{timezoneOffset}}) Canberra, Melbourne, Sídney",
    "Europe/Belgrade": "({{timezoneOffset}}) Sarajevo, Skopie, Varsovia, Zágreb",
    "Europe/Berlin": "({{timezoneOffset}}) Ámsterdam, Berlín, Berna, Roma, Estocolmo, Viena",
    "Europe/Istanbul": "({{timezoneOffset}}) Bucarest",
    "Europe/London": "({{timezoneOffset}}) Hora del meridiano de Greenwich: Dublín, Edimburgo, Lisboa, Londres",
    "Europe/Minsk": "({{timezoneOffset}}) Atenas, Estambul, Minsk",
    "Europe/Moscow": "({{timezoneOffset}}) Moscú, San Petersburgo, Volgogrado",
    "Europe/Paris": "({{timezoneOffset}}) Bruselas, Copenhague, Madrid, París",
    "Europe/Riga": "({{timezoneOffset}}) Helsinki, Kiev, Riga, Sofía, Tallin, Vilna",
    "Learning": "Aprendizaje",
    "MANAGE_SURVEYS": "Administrar encuestas",
    "Pacific/Apia": "({{timezoneOffset}}) Isla Midway, Samoa",
    "Pacific/Auckland": "({{timezoneOffset}}) Auckland, Wellington",
    "Pacific/Fiji": "({{timezoneOffset}}) Islas Fiyi, Kamchatka, Islas Marshall",
    "Pacific/Guadalcanal": "({{timezoneOffset}}) Magadán, Islas Salomón, Nueva Caledonia",
    "Pacific/Guam": "({{timezoneOffset}}) Guam, Port Moresby",
    "Pacific/Honolulu": "({{timezoneOffset}}) Hawái",
    "Pacific/Kiritimati": "({{timezoneOffset}}) Línea de Fecha Internacional Oeste",
    "Pacific/Tongatapu": "({{timezoneOffset}}) Nuku'alofa",
    "Survey.duplicateName": "Nombre de la encuesta:",
    "VIEW_OPEN_ENDED_COMMENTS": "Ver comentarios abiertos",
    "VIEW_REPORTING": "Ver informe",
    "access.all": "Todos los empleados",
    "access.attribute": "Atributos personalizados",
    "access.hierarchy": "Su jerarquía",
    "access.otherHierarchy": "Otras jerarquías",
    "account.email": "Dirección de correo electrónico",
    "account.password": "Contraseña",
    "action": "Acción",
    "action.added": "Acción agregada",
    "action.added.description": "Se agregó correctamente \"{{title}}\".",
    "action.created.assigned.message": "%actionOwnerName% le acaba de asignar la acción “%actionTitle%” en WorkTango.",
    "action.created.button.message": "Ver la acción",
    "action.created.link.message": "Si el enlace anterior no funciona, copie y pegue el siguiente enlace en su explorador: %baseUrl%/action-planning/actions/%actionId%",
    "action.created.sending.greetings": "Hola",
    "action.created.sending.subject": "Se le asignó una nueva acción en WorkTango.",
    "action.updated.button.message": "Ver acción",
    "action.updated.changes.message": "%actionOwnerName% realizó uno o más cambios en la acción “%actionTitle%”.",
    "action.updated.changes.warning": " Tenga en cuenta que no podrá ver la acción si dejó de ser la persona a la que se le asignó dicha acción.",
    "action.updated.fields.categoryIds": "Categorías",
    "action.updated.fields.description": "Descripción",
    "action.updated.fields.dueAt": "Finalizado el",
    "action.updated.fields.isComplete": "Se completó",
    "action.updated.fields.languageId": "Idioma",
    "action.updated.fields.libraryActionId": "Acción de biblioteca",
    "action.updated.fields.status": "Estado",
    "action.updated.fields.surveyIds": "Encuestas",
    "action.updated.fields.title": "Título",
    "action.updated.fields.userIds": "Asignados",
    "action.updated.link.message": "Si el enlace anterior no funciona, copie y pegue el siguiente enlace en su explorador: %baseUrl%/action-planning/actions/%actionId%",
    "action.updated.sending.greetings": "Hola",
    "action.updated.sending.subject": "Se actualizó una de las tareas en WorkTango",
    "actions": "Acciones",
    "actions.additional": "Permisos de informe adicionales",
    "active": "Activo",
    "add.action": "Agregar acción",
    "add.factor": "Agregar factor",
    "addCompanyDialog.errors.duplicateName": "Este nombre ya existe, elija un nombre único",
    "addCompanyDialog.errors.invalidSalesforceId": "Un ID de Salesforce válido debe tener entre 15 y 18 caracteres",
    "addCompanyDialog.name.label": "Nombre de la empresa",
    "addCompanyDialog.salesforce.helperText": "",
    "addCompanyDialog.salesforce.label": "ID de Salesforce",
    "addCompanyDialog.testDemo.label": "Se trata de una empresa de prueba/demo",
    "addCompanyDialog.title": "Crear una nueva empresa",
    "addQuestion": "Añadir pregunta",
    "admin.ai-prompts.header": "Avisos de IA",
    "admin.ai-prompts.sub-title": "Estos avisos se utilizan para generar resúmenes de preguntas, análisis, temas clave y opiniones para todas las encuestas de la plataforma. Tenga cuidado al actualizarlos, ya que afectan a todos los clientes.",
    "admin.ai-prompts.title": "Avisos de IA generativa",
    "admin.allowFrench": "Activar idioma francés",
    "admin.appPermissions": "Permisos de la aplicación",
    "admin.benchmarks.associate-attribute": "Asociar atributo",
    "admin.benchmarks.associate-attributes": "Asociar atributos",
    "admin.benchmarks.associate.filter": "Filtrar por nombre de la empresa",
    "admin.benchmarks.associate.subtitle": "Asociar los atributos del empleado al atributo de referencia",
    "admin.benchmarks.benchmark-attributes": "Atributos de referencia",
    "admin.benchmarks.button.go-association": "Ir a la asociación de atributos para",
    "admin.benchmarks.button.go-mapping": "Ir a la asignación de valores de atributos para",
    "admin.benchmarks.button.map-selected-to": "Asignar seleccionado a",
    "admin.benchmarks.button.map-to": "Asignar a",
    "admin.benchmarks.button.return-attributes": "Volver a los atributos de referencia",
    "admin.benchmarks.check-new-values": "Comprobar nuevos valores",
    "admin.benchmarks.default-benchmark-value": "Valor predeterminado del atributo de referencia",
    "admin.benchmarks.default-value": "Valor por defecto",
    "admin.benchmarks.header": "Puntos de referencia",
    "admin.benchmarks.last-refreshed": "Última actualización",
    "admin.benchmarks.map-values": "Asignar valores",
    "admin.benchmarks.number-of-values": "N.º de valores",
    "admin.benchmarks.sample-values": "Valores de muestra",
    "admin.benchmarks.value-mapping.alert": "Ha seleccionado valores y aún no ha finalizado la asignación",
    "admin.benchmarks.value-mapping.filter": "Filtrar por valor",
    "admin.benchmarks.value-mapping.subtitle": "Asigne los valores de los atributos de los empleados al valor de los atributos de referencia",
    "admin.bulk.generate": "Generar archivo de muestra",
    "admin.bulk.sampleFile": "archivo de muestra",
    "admin.bulk.selectFile": "Seleccionar un archivo CSV/Excel",
    "admin.company.colour2": "Color de la barra de navegación superior",
    "admin.company.cprofile": "Logotipo de la empresa",
    "admin.company.delete.alert": "Todos los datos relacionados con la empresa {{companyName}} se ELIMINARÁN y NO ES POSIBLE recuperarlos luego",
    "admin.company.delete.confirmation": "Ingresa el correo electrónico de tu cuenta para confirmar la eliminación",
    "admin.company.industry": "Seleccionar industria",
    "admin.company.manageCompany": "Compañías",
    "admin.company.name": "Nombre de la empresa",
    "admin.company.public": "Público",
    "admin.company.region": "Seleccionar región",
    "admin.company.saved": "¡Guardado!",
    "admin.company.sector": "Sector",
    "admin.companyData.header": "Configuración",
    "admin.companyData.kiosk": "Quiosco",
    "admin.companyData.learning.coach": "Tutor de aprendizaje",
    "admin.companyData.learning.coach.notifications.enabled": "Notificaciones activadas",
    "admin.editPermissions": "Editar permisos",
    "admin.egroup.noemployees": "No seleccionó ningún empleado",
    "admin.email.languagesNote": "Nota: Todos los idiomas activados son obligatorios",
    "admin.employee.addTagline": "Agregar nuevo empleado",
    "admin.employee.customcategory": "Crear un factor",
    "admin.employee.disableAll": "Desactivar",
    "admin.employee.edit.custom.category": "Actualizar un factor",
    "admin.employee.enableAll": "Activar",
    "admin.employee.status": "Estado",
    "admin.employee.tagline": "Actualizar la información del empleado",
    "admin.employees.header": "Empleados",
    "admin.employees.tabs.employeeList": "Lista de empleados",
    "admin.employees.tabs.importHistory": "Historial de importaciones",
    "admin.enable.sso": "Activar SSO",
    "admin.fields.enName": "Nombre del campo (En)",
    "admin.fields.frName": "Nombre del campo (Fr)",
    "admin.fields.header": "Crear un nuevo campo",
    "admin.fields.isPrivateAttribute": "Oculto en la lista de empleados",
    "admin.fields.isReportingAttribute": "Atributo primario (se muestra siempre de manera predeterminada; se permiten hasta 10)",
    "admin.fields.name": "Nombre del campo",
    "admin.fields.required": "Obligatorio",
    "admin.fields.systemHeader": "Campo de sistema",
    "admin.fields.type": "Tipo",
    "admin.fields.unique": "Único",
    "admin.fields.update": "Actualizar campo",
    "admin.kiosk.field": "Campo de quiosco",
    "admin.kiosk.url": "Los empleados pueden acceder a la función \"Quiosco\" usando la siguiente URL:",
    "admin.library.header": "Biblioteca de preguntas",
    "admin.managePermissions": "Administrar permisos",
    "admin.notify.completion.button": "Ver mi resumen de encuestas",
    "admin.notify.completion.closed": "finalizó.",
    "admin.notify.completion.overview": "Está disponible el resumen de encuestas en WorkTango",
    "admin.notify.expired.click": "Hacer clic",
    "admin.notify.expired.extend": "Si desea extender la encuesta, solo debe actualizar la fecha de finalización en la configuración de la encuesta.",
    "admin.notify.expired.see.results": "para ver los resultados",
    "admin.notify.expired.submitted": "de personas enviaron las encuestas",
    "admin.notify.expired.warn": "finalizó",
    "admin.notify.reminder.opening": "La encuesta",
    "admin.notify.reminder.scheduled": "debe enviarse en",
    "admin.notify.reminder.subject": "Recordatorio: se está por enviar la encuesta de WorkTango",
    "admin.notify.sending.completed.happy.response.rate": "Deseamos que obtenga una tasa de respuesta del 100 % :)",
    "admin.notify.sending.completed.senttox": "Se envió la encuesta Pulse con el título %surveyname% a %sendto% personas.",
    "admin.notify.sending.completed.subject": "Se completó el proceso de envío de %surveyname%",
    "admin.notify.sending.greetings": "La encuesta con el título",
    "admin.notify.sending.notify.when.complete": "Le enviaremos un correo electrónico cuando haya finalizado el proceso.",
    "admin.notify.sending.status": "se procesó y se enviará a",
    "admin.notify.sending.subject": "Se está enviando %surveyname%",
    "admin.notify.sending.thanks": "Gracias",
    "admin.notify.sending.time": "en el próximo/en los próximos",
    "admin.permission.createSuccessMsg": "Invitaste correctamente a {{num}} usuarios nuevos.",
    "admin.permission.self": "Usted mismo",
    "admin.permission.updateSuccessMsg": "Permiso actualizado.",
    "admin.permission.userEmailsTitle": "Ingresar los correos electrónicos de los usuarios separados por comas",
    "admin.previous.header": "Preguntas frecuentes",
    "admin.question.addlabels": "Agregar etiquetas",
    "admin.question.allowMultiple": "Permitir múltiples selecciones",
    "admin.question.category": "Factor",
    "admin.question.commentsRequired": "Permitir los comentarios",
    "admin.question.description": "Agregar descripción",
    "admin.question.emailContent": "Contenido del correo electrónico",
    "admin.question.emailSubject": "Asunto del correo electrónico",
    "admin.question.fixed": "Icono",
    "admin.question.fromEmailName": "Nombre del remitente",
    "admin.question.hideReporting": "Ocultar del informe",
    "admin.question.labelAfter": "Ingresar el contenido de la etiqueta derecha aquí",
    "admin.question.labelBefore": "Ingresar el contenido de la etiqueta izquierda aquí",
    "admin.question.languagesNote": "Nota: Todos los idiomas son obligatorios",
    "admin.question.library": "Biblioteca de preguntas",
    "admin.question.multiple": "Opciones múltiples",
    "admin.question.name": "Pregunta",
    "admin.question.newmessage": "Nuevo mensaje",
    "admin.question.numratings": "Escala",
    "admin.question.open": "Texto",
    "admin.question.openSurveyAttribute": "",
    "admin.question.openSurveyAttribute.loadError": "",
    "admin.question.openSurveyAttribute.name": "",
    "admin.question.openSurveyAttribute.noSourceAttribute": "",
    "admin.question.openSurveyAttribute.sourceAttribute": "",
    "admin.question.openSurveyAttribute.sourceAttributePlaceholder": "",
    "admin.question.options": "Opciones de respuesta",
    "admin.question.optionsAllowed": "Opciones permitidas",
    "admin.question.optionsEditor.actions": "Acciones",
    "admin.question.optionsEditor.addOption": "Añadir una opción",
    "admin.question.optionsEditor.importAttributeLabel": "Atributo de empleado del que obtener opciones",
    "admin.question.optionsEditor.importAttributePlaceholder": "Elegir un atributo",
    "admin.question.optionsEditor.importButton": "Importar",
    "admin.question.optionsEditor.importDescription": "Los valores de atributo importados se ordenan alfabéticamente y se añaden a la lista de opciones existentes.",
    "admin.question.optionsEditor.importEmpty": "Este atributo no tiene nuevos valores para importar.",
    "admin.question.optionsEditor.importError": "No se pudieron cargar los valores del atributo. Inténtalo de nuevo.",
    "admin.question.optionsEditor.importFromAttribute": "Importar opciones desde el atributo...",
    "admin.question.optionsEditor.importTitle": "Importar opciones desde un atributo",
    "admin.question.optionsEditor.removeAll": "Eliminar todas las opciones",
    "admin.question.previous": "Preguntas frecuentes (para tendencias)",
    "admin.question.reportingFilter": "Opciones de filtrado de informes",
    "admin.question.reportingFilter.attribute": "Filtro de atributo",
    "admin.question.reportingFilter.attributePlaceholder": "Elige un atributo",
    "admin.question.reportingFilter.loadError": "No se ha podido cargar el filtro de informes guardado. Actualiza la página e inténtalo de nuevo.",
    "admin.question.reportingFilter.none": "No usar las respuestas como filtro",
    "admin.question.reportingFilter.questionLabel": "Etiqueta del filtro de pregunta",
    "admin.question.reportingFilter.useAsAttributeFilter": "Usar las respuestas como filtro de atributo",
    "admin.question.reportingFilter.useAsQuestionFilter": "Usar las respuestas como filtro de pregunta",
    "admin.question.required": "Obligatorio",
    "admin.question.select": "Menú desplegable",
    "admin.question.shapetype": "Tipo de icono",
    "admin.question.showSkipButton": "Mostrar el botón \"Saltear\"",
    "admin.question.sliding": "Puntuación",
    "admin.question.subject": "Referencia",
    "admin.question.yes_no": "Sí/No",
    "admin.reminders.tagline": "Se enviará un correo electrónico a todos los empleados que no completaron aún la encuesta.",
    "admin.resendInvites": "Reenviar invitaciones",
    "admin.selectedUsers": "Usuarios seleccionados",
    "admin.setAllPermissions": "Establezca todos los permisos en la configuración actual de un usuario específico haciendo clic en su nombre.",
    "admin.step4.recipients.header": "Elija los destinatarios de la encuesta",
    "admin.step4.schedule.header": "Programar",
    "admin.survey-template.activate": "Activar plantilla",
    "admin.survey-template.build.empty-questions.description": "Empiece añadiendo una pregunta a esta encuesta de la biblioteca.",
    "admin.survey-template.build.empty-questions.title": "¡Añada su primera pregunta!",
    "admin.survey-template.build.question-library.addQuestionsButton": "Añadir las preguntas seleccionadas y volver al editor",
    "admin.survey-template.build.question-library.cancelButton": "Cancelar y volver al editor",
    "admin.survey-template.build.question-library.searchQuestion": "Buscar una pregunta...",
    "admin.survey-template.build.question-library.selectFactor": "Seleccionar factor",
    "admin.survey-template.build.survey-questions.add-button": "Añadir preguntas de la biblioteca",
    "admin.survey-template.build.survey-questions.description": "En este momento no hay preguntas configuradas para esta encuesta.",
    "admin.survey-template.build.survey-questions.remove-button": "Eliminar",
    "admin.survey-template.build.survey-questions.title": "Preguntas de la encuesta",
    "admin.survey-template.build.title": "Creador de encuestas",
    "admin.survey-template.config.style.helper-text": "Las encuestas creadas a partir de esta plantilla utilizan este estilo. No se puede cambiar una vez que se ha creado una encuesta.",
    "admin.survey-template.config.title": "Configuración de las encuestas",
    "admin.survey-template.error-message.unique-name": "El nombre de la plantilla de encuesta no es válido: ya existe una plantilla de encuesta con el mismo nombre e idioma.",
    "admin.survey-template.new-template-title": "Nueva plantilla de encuesta",
    "admin.survey-template.share.note": "Nota: se requieren todos los idiomas habilitados",
    "admin.survey-template.share.title": "Correo electrónico de invitación a la encuesta",
    "admin.survey-template.title-details": "Detalles de su encuesta",
    "admin.survey-template.unsaved-changes": "Tiene cambios sin guardar en esta página.",
    "admin.survey.addTagline": "Crear nueva encuesta",
    "admin.survey.allSurveyStatus": "Todos Estado de la encuesta",
    "admin.survey.allSurveyStyles": "Todos los estilos de encuesta",
    "admin.survey.allSurveyTypes": "Todos los tipos de encuesta",
    "admin.survey.anonMessage": "Los líderes podrán responder los comentarios de los empleados",
    "admin.survey.anons": "Habilitar conversaciones anónimas",
    "admin.survey.audience-mode": "Audiencia",
    "admin.survey.audience-mode.helper-text": "Tenga en cuenta que esta configuración no se puede cambiar",
    "admin.survey.audience-mode.individual.description": "Invite a empleados específicos. Cada participante recibe su propio enlace y puede responder una vez.",
    "admin.survey.audience-mode.individual.title": "Enlace individual",
    "admin.survey.audience-mode.shared.description": "Publique un único enlace que cualquiera pueda abrir. Las respuestas son anónimas y no hay límite en la cantidad que se puede enviar.",
    "admin.survey.audience-mode.shared.title": "Enlace compartido",
    "admin.survey.build.add-recipient.alert.inprogress": "Una vez que lo confirmes, se enviará enseguida un correo electrónico a {{count}} empleado(s).",
    "admin.survey.build.add-recipient.alert.scheduled": "Una vez que lo confirmes, se agregarán nuevos destinatarios a esta encuesta.",
    "admin.survey.build.add-recipient.title": "¿Deseas agregar {{count}} nuevo(s) destinatario(s)?",
    "admin.survey.build.add-recipient.title_other": "",
    "admin.survey.build.add-remove.alert.inprogress": "Una vez que lo confirmes, se enviará enseguida un correo electrónico a {{addCount}} empleado(s), los enlaces de encuesta de {{removeCount}} destinatario(s) ya no serán válidos y cualquier resultado será eliminado de la encuesta.",
    "admin.survey.build.add-remove.alert.scheduled": "Una vez que lo confirmes, se agregarán o eliminarán los destinatarios",
    "admin.survey.build.add-remove.title": "¿Deseas agregar {{addCount}} nuevo(s) destinatario(s) y eliminar {{removeCount}} destinatario(s)?",
    "admin.survey.build.archived_invitation": "Se trata de una invitación archivada que se creó automáticamente cuando se volvió a contratar a este empleado. Sirve como representación exacta de la tasa de participación y como enlace a las respuestas de la encuesta, si la persona las envió.",
    "admin.survey.build.automate.activate.success": "La encuesta continua ha pasado a estar en curso",
    "admin.survey.build.automate.deactivate.success": "La encuesta continua ha pasado a Completada",
    "admin.survey.build.automate.save.changes.close": "Guardar cambios y cerrar",
    "admin.survey.build.automate.title": "Automatización de encuestas",
    "admin.survey.build.candidates": "Candidatos a la encuesta",
    "admin.survey.build.candidates.description": "El sistema identificó a los siguientes empleados a los que se invitó a cumplimentar su encuesta en la fecha prevista.",
    "admin.survey.build.candidates.empty": "No hay candidatos esperando a ser invitados en esta encuesta. Los activadores de automatización gestionarán las invitaciones en función de la fecha de inicio o de salida.",
    "admin.survey.build.candidates.outbox-button": "Actualizar candidatos en la bandeja de salida",
    "admin.survey.build.candidates.search": "Filtrar por nombre",
    "admin.survey.build.disable-emails.alert.description": "Esta encuesta no enviará invitaciones ni recordatorios por correo electrónico a los participantes. Asegúrese de configurar el acceso al quiosco, donde los empleados pueden enviar sus respuestas.",
    "admin.survey.build.disable-emails.alert.title": "Envío de correos electrónicos desactivado",
    "admin.survey.build.disable-emails.dialog.confirm": "Desactivar envío de correos electrónicos",
    "admin.survey.build.disable-emails.dialog.description1": "Al desactivar el envío de correos electrónicos no se invitará a los participantes a la encuesta, ni se les recordará que la completen si aún no lo han hecho.",
    "admin.survey.build.disable-emails.dialog.description2": "La única forma de que los empleados puedan acceder a esta encuesta es a través de un enlace de quiosco, así que asegúrese de configurar uno.",
    "admin.survey.build.disable-emails.dialog.description3": "¿Aún desea desactivar el envío de correos electrónicos?",
    "admin.survey.build.disable-emails.dialog.title": "Desactivar envío de correos electrónicos para esta encuesta",
    "admin.survey.build.disable-emails.switch": "Permitir el envío de invitaciones y recordatorios por correo electrónico a los participantes",
    "admin.survey.build.expired": "La encuesta finaliza el:",
    "admin.survey.build.invitation-expires-at": "Las invitaciones para estos empleados expiran el:",
    "admin.survey.build.leave.alert": "Tienes cambios sin guardar en la lista de destinatarios.",
    "admin.survey.build.leave.dialog.body_1": "Ha realizado cambios en las listas de participantes, pero no los ha guardado.",
    "admin.survey.build.leave.dialog.body_2": "¿Estás seguro de que quieres irte sin guardar los cambios?",
    "admin.survey.build.leave.dialog.title": "Actualización de los participantes en la encuesta",
    "admin.survey.build.leave.leave_step": "Abandonar sin guardar",
    "admin.survey.build.leave.stay_step": "Permanezca en este escalón",
    "admin.survey.build.leave.title": "¿Deseas salir de la encuesta? Existen varios cambios sin guardar",
    "admin.survey.build.remove-recipient.alert.inprogress": "Una vez que lo confirmes, los enlaces de la encuesta para {{count}} destinatario(s) ya no serán válidos y cualquier resultado será eliminado de la encuesta.",
    "admin.survey.build.remove-recipient.alert.scheduled": "Una vez que lo confirmes, {{count}} se eliminará(n) destinatario(s) de esta encuesta.",
    "admin.survey.build.remove-recipient.title": "¿Deseas eliminar {{count}} destinatario(s)?",
    "admin.survey.build.save-alert": "Se ha modificado la lista de destinatarios, haga clic en \"Guardar\" para guardar los cambios",
    "admin.survey.build.scheduled": "Encuesta programada desde:",
    "admin.survey.build.triggers": "Activadores de encuestas",
    "admin.survey.build.triggers.description": "Los siguientes activadores están configurados para invitar automáticamente a los empleados a esta encuesta en función de su {{atributo}}",
    "admin.survey.build.triggers.empty": "No hay disparadores configurados para esta encuesta. Haga clic a continuación para configurar el primero.",
    "admin.survey.build.update-alert": "Se modificó la lista de destinatarios, haz clic en ‘Actualizar’ para guardar los cambios",
    "admin.survey.cancelled": "Se canceló la programación de la encuesta",
    "admin.survey.combineLanguages": "Combinar todos los idiomas en un correo electrónico",
    "admin.survey.combineLanguagesMessage": "Permite enviar las invitaciones en un solo mensaje de correo electrónico en todos los idiomas, independientemente del idioma elegido por el empleado.",
    "admin.survey.configure.title": "Configuración de la encuesta",
    "admin.survey.continuous": "Continuo",
    "admin.survey.duplicated": "Parece que ya hay una encuesta con el mismo nombre. Elija un nombre de encuesta para continuar.",
    "admin.survey.emailLanguage": "Idiomas del correo electrónico",
    "admin.survey.endDate": "Finalización",
    "admin.survey.endTime": "Hora de finalización",
    "admin.survey.endafterstart": "Seleccionar una fecha de finalización posterior a la fecha de envío programada",
    "admin.survey.expired": "Finalizará el:",
    "admin.survey.fromEmail": "Enviar prueba",
    "admin.survey.fromemailnamecheck": "Es necesario que incluya el nombre de la persona que envía el correo electrónico",
    "admin.survey.futureStart": "Seleccionar una fecha futura en función del huso horario indicado",
    "admin.survey.graph.tooltip.total": "Total",
    "admin.survey.languages": "Idioma(s)",
    "admin.survey.leave": "¿Deseas salir del sitio? Puede que los cambios hechos no se guarden",
    "admin.survey.name": "Nombre de la encuesta",
    "admin.survey.name.placeholder": "Introduzca el nombre de la encuesta",
    "admin.survey.new": "Nueva encuesta",
    "admin.survey.notification-dialog.description-1": "La plantilla que ha elegido para crear esta encuesta contenía preguntas destacadas que hacían referencia a factores que no estaban presentes en su configuración.",
    "admin.survey.notification-dialog.description-2": "Como resultado, una o más preguntas requerirán que seleccione manualmente los factores apropiados para guardar correctamente la encuesta.",
    "admin.survey.notification-dialog.title": "A una o más preguntas les faltan factores",
    "admin.survey.numquestions": "Total de preguntas:",
    "admin.survey.numrecipients": "Cantidad total de destinatarios:",
    "admin.survey.option": "Opción {{num}}",
    "admin.survey.pasteEmail": "Pegar correos electrónicos",
    "admin.survey.pasteEmailError": "El siguiente correo electrónico del empleado no existe: {{emails}}",
    "admin.survey.pasteEmailInvalid": "El siguiente correo electrónico tiene un formato erróneo: {{emails}}",
    "admin.survey.pasteEmailSuccess": "{{total}} nuevos destinatarios agregados",
    "admin.survey.preferTimezone": "Huso horario preferido",
    "admin.survey.preview": "Vista previa",
    "admin.survey.scheduled": "Programado para:",
    "admin.survey.searchName": "Ingresar nombre de la encuesta",
    "admin.survey.selected": "Seleccionado",
    "admin.survey.send.test.btn.title": "Envíese un correo electrónico de prueba",
    "admin.survey.sentDate": "Fecha de envío",
    "admin.survey.showResults": "Mostrar resultados de la encuesta",
    "admin.survey.showResultsMessage": "Muestra todos los resultados a los empleados después de completar la encuesta",
    "admin.survey.standard": "Estándar",
    "admin.survey.startDate": "Fecha de inicio",
    "admin.survey.startTime": "Hora de envío",
    "admin.survey.step1": "Configurar",
    "admin.survey.step2": "Crear",
    "admin.survey.step4": "Compartir",
    "admin.survey.step5": "Automatice",
    "admin.survey.style": "Estilo de encuesta",
    "admin.survey.style.continuous.description": "Esta encuesta no caduca, pero las invitaciones sí, y los participantes sólo pueden responder una vez. Los informes se realizan en función de los plazos seleccionados. Ideal para encuestas de incorporación y salida.",
    "admin.survey.style.continuous.exit-date.description": "Ideal para encuestas de salida. Esta encuesta no caduca, pero las invitaciones sí, y los participantes sólo pueden responder una vez. Los informes se realizan en función de los plazos seleccionados.",
    "admin.survey.style.continuous.exit-date.title": "Encuesta continua basada en la fecha de salida",
    "admin.survey.style.continuous.start-date.description": "Ideal para encuestas de incorporación. Esta encuesta no caduca, pero las invitaciones sí, y los participantes sólo pueden responder una vez. Los informes se realizan en función de los plazos seleccionados.",
    "admin.survey.style.continuous.start-date.title": "Encuesta continua basada en la fecha de inicio",
    "admin.survey.style.continuous.title": "Encuesta continua",
    "admin.survey.style.helper-text": "Nota: Este ajuste no se puede modificar",
    "admin.survey.style.shared-link.description": "Esta encuesta se comparte mediante un único enlace en lugar de invitaciones individuales, por lo que los encuestados no necesitan estar en tu archivo de empleados y pueden responder más de una vez.",
    "admin.survey.style.shared-link.description-limitations": "Como nadie está identificado, no se aplican invitaciones, tasas de respuesta ni recordatorios.",
    "admin.survey.style.shared-link.title": "Encuesta de enlace compartido",
    "admin.survey.style.standard.description": "Esta encuesta tiene fechas fijas de inicio y fin, después de las cuales no puede recibir más respuestas. A efectos de tendencias, puede clonarla y volver a invitar a los participantes.",
    "admin.survey.style.standard.title": "Encuesta estándar",
    "admin.survey.surveyNameMax": "Se permiten {{num}} caracteres como máximo",
    "admin.survey.timezone": "Huso horario",
    "admin.survey.type": "Tipo",
    "admin.survey.type.placeholder": "Elija el tipo",
    "admin.survey.wizard.next-step": "Siguiente paso",
    "admin.survey.wizard.previous-step": "Paso anterior",
    "admin.survey.wizard.return-to-surveys": "Volver a las encuestas",
    "admin.survey.wizard.save-changes": "Guardar cambios",
    "admin.surveylibrary.count": "# veces enviada",
    "admin.surveylibrary.lastSent": "Última enviada",
    "admin.surveylibrary.supportedLanguages": "Idiomas admitidos",
    "admin.surveylibrary.type": "Tipo de pregunta",
    "admin.surveyquestions.header": "Agregar preguntas a la encuesta",
    "admin.surveys.detail": "Los datos de la encuesta",
    "admin.surveys.header": "Encuestas",
    "admin.title": "Administración",
    "admin.updatesurvey.add": "Agregar",
    "admin.updatesurvey.remove": "Eliminar",
    "admin.updatesurvey.resend": "Reenviar",
    "admin.users.action-planning-perms": "Permisos de planificación de acciones",
    "admin.users.allAttributes": "Todos los atributos",
    "admin.users.attribute.selected": "{{num}} seleccionados",
    "admin.users.attribute.selector": "Atributos que pueden ver los usuarios",
    "admin.users.attributes.compareAttributesDoNotMatchFilterAttributes": "Todos los atributos de la lista \"<0>{{compareAttributesHeader}}</0>\" deben estar también presentes en la lista \"<0>{filterAttributesHeader}}</0>\".",
    "admin.users.attributes.header": "Filtrar atributos",
    "admin.users.customAttributes": "Atributos personalizados",
    "admin.users.dataAccess": "Acceso a los datos",
    "admin.users.dataAccess.all": "Enviando encuestas y mostrando resultados de la encuesta",
    "admin.users.dataAccess.sendingOnly": "Enviando encuestas",
    "admin.users.dataAccess.viewOnly": "Mostrando resultados de la encuesta",
    "admin.users.dataCompare": "Datos comparables en el informe",
    "admin.users.editUser": "Editar el contenido al que tiene acceso otro usuario",
    "admin.users.email": "Correo electrónico",
    "admin.users.exist.email": "El usuario ya existe: {{emails}}",
    "admin.users.header": "Usuarios",
    "admin.users.invite": "Usuarios invitados",
    "admin.users.manage": "Administrar usuario",
    "admin.users.missing.compareValue": "Seleccione atributos para comparar los datos para el tipo de encuesta {{name}}",
    "admin.users.missing.dataAccess": "Seleccione atributos para acceder a los datos del empleado para el tipo de encuesta {{name}}",
    "admin.users.missing.email": "Ingrese un correo electrónico",
    "admin.users.missing.employeeAccess": "Seleccione una opción para acceder a los datos del empleado para el tipo de encuesta {{name}}",
    "admin.users.missing.language": "Seleccione un idioma",
    "admin.users.missing.surveyType": "Se requiere al menos un permiso para el tipo de encuesta",
    "admin.users.missing.visibility": "Seleccione atributos para acceder a los datos de los atributos para el tipo de encuesta {{name}}",
    "admin.users.name": "Nombres",
    "admin.users.no.email": "Para invitar usuarios con acceso basado en jerarquía o en atributos personalizados, es necesario que figuren como empleados: {{email}}",
    "admin.users.permissions": "Permisos globales",
    "admin.users.searchAll": "Buscar por nombre o por correo electrónico",
    "admin.users.selectAttributeValues": "Seleccionar valores de atributo",
    "admin.users.selectAttributes": "Seleccionar atributos",
    "admin.users.selectHierarchies": "Seleccionar jerarquías",
    "admin.users.surveyPermissions": "Permisos de tipo de encuesta",
    "admin.users.tagline": "Invite a otras personas a acceder a la creación de encuestas, a ver todos los resultados de las encuestas o a visualizar los resultados restringidos solo para sus dependientes directos.",
    "admin.users.theirType": "Su {{name}}",
    "admin.users.userActions": "Acciones del usuario",
    "adminExport.advanced": "Versión avanzada",
    "adminExport.confirm.desc": "La versión avanzada contiene información confidencial del usuario.",
    "adminExport.confirm.title": "¿Está seguro de que necesita la versión avanzada?",
    "adminExport.desc": "La exportación sin procesar incluirá todos los datos de atributos de empleados, incluidos los ID de estos y los ID y la dirección de correo electrónico del mánager. Esta es toda la información que se necesita para una regeneración.",
    "adminExport.dialog.confirm": "Descargar archivo exportado",
    "adminExport.includePrivateAttributes": "Incluir los atributos privados del empleado",
    "adminExport.includeResponses": "Incluir respuestas de empleados",
    "adminExport.privateAttributes.warning.confirm": "Sí, necesito los atributos privados del empleado y me comprometo a eliminar esta exportación en cuanto termine con ella.",
    "adminExport.privateAttributes.warning.desc": "Los atributos privados de los empleados son confidenciales y están relacionados directamente con una sola persona. Estos datos no se deben compartir. Se registrará su ID de usuario.",
    "adminExport.privateAttributes.warning.title": "¿Seguro que necesita exportar los atributos privados del empleado?",
    "adminExport.title": "Archivo exportado sin procesar",
    "adminExport.warning.confirm": "Sí. Necesito las respuestas de los empleados y acepto eliminar este archivo exportado cuando deje de usarlo.",
    "adminExport.warning.desc": "Las respuestas de los empleados no son necesarias para regenerar una encuesta. Esta opción solo se debe elegir para el análisis. Se registrará su ID de usuario.",
    "adminExport.warningTitle": "¿Está seguro de que necesita exportar las respuestas de los empleados?",
    "ago": "anterior.",
    "ai.email.next.steps": "Estos conocimientos proporcionan un valioso punto de partida para la conversación y la acción. Para profundizar en los datos y comprender los matices que subyacen a estas cifras, le recomendamos utilizar el asistente de IA directamente en la plataforma WorkTango. Puede contactar con el Coach de WorkTango para que le ayude a analizar los hallazgos y le guíe en estrategias eficaces para responder a los comentarios de su equipo.",
    "ai.email.presentation": "Tu Resumen de la Encuesta ya está disponible en WorkTango. Aquí tienes un breve resumen de los resultados de tu equipo.",
    "allQuestions": "Todas las preguntas",
    "analytics.distribution": "Distribución",
    "analytics.fields": "Campos de empleados",
    "analytics.hierarchy": "Jerarquía",
    "analytics.nps": "eNPS",
    "analyze.attribute.noVisible": "No existe atributo primario visible para la encuesta actual",
    "analyze.hide.empty.rows": "Ocultar las filas vacías",
    "and": "y",
    "anonymouse.protection.message": "Con el fin de proteger el anonimato de los empleados, no podemos mostrar los datos solicitados. Se emplean algoritmos de confidencialidad para garantizar que los empleados se sientan seguros cuando nos envíen sus comentarios. Intente nuevamente cambiando las encuestas o los filtros seleccionados.",
    "ap.actionWasCreatedSuccessfully": "Tu acción se creó y se asignó correctamente.",
    "ap.add.action": "Agregar a acciones",
    "ap.createALibraryTemplate": "Crear una acción de biblioteca",
    "ap.createAnAction": "Crear una acción",
    "ap.edit.template": "Editar acción de biblioteca",
    "ap.error.assignmentRequired": "Es necesario que asigne a alguien",
    "ap.error.titleRequired": "Se requieren títulos para todos los idiomas.",
    "ap.label.addAction": "Agregar acción",
    "ap.label.addQuestion": "Agregar pregunta",
    "ap.label.any": "Todos",
    "ap.label.anyone": "Cualquiera",
    "ap.label.assignedTo": "Asignado por",
    "ap.label.cancel": "Cancelar",
    "ap.label.changeDueDate": "Modificar fecha de finalización",
    "ap.label.close": "Cerrar",
    "ap.label.create": "Crear",
    "ap.label.description": "Descripción",
    "ap.label.dueAt": "Finalizado el",
    "ap.label.effectiveness": "Efectividad",
    "ap.label.factors": "Factores",
    "ap.label.filterBy": "Filtrado por:",
    "ap.label.introduce.question": "Introducir una nueva pregunta",
    "ap.label.me": "Yo",
    "ap.label.modifyAction": "Modificar acción",
    "ap.label.newAction": "Nueva acción",
    "ap.label.reset": "Restablecer",
    "ap.label.save": "Guardar",
    "ap.label.search": "Búsqueda",
    "ap.label.status": "Estado",
    "ap.label.surveyFactor": "Factor de encuesta predeterminado",
    "ap.label.surveyType": "Tipo de encuesta",
    "ap.label.surveys": "Encuestas",
    "ap.label.title": "Título",
    "ap.noActions": "¿Necesita hacer de alguna forma seguimiento de la información estadística de su organización?",
    "ap.noFilterResults": "No se encontraron acciones para los filtros seleccionados. Intente con un nuevo conjunto de filtros.",
    "ap.noLibraryTemplates": "No hay acciones de biblioteca",
    "ap.status.complete": "Completo",
    "ap.status.inProgress": "Marcar como completo",
    "ap.status.todo": "Por hacer",
    "ap.status.unassigned": "No asignado",
    "ap.title.actionAssigned": "Acción agregada",
    "ap.title.actionPlanning": "Planificación de la acción",
    "ap.title.actions": "Acciones",
    "ap.title.assignedTo": "Asignado por",
    "ap.title.createLibraryAction": "Crear acción de biblioteca",
    "ap.title.dueAt": "Finalizado el",
    "ap.title.factors": "Factores",
    "ap.title.isComplete": "Listo",
    "ap.title.library": "Biblioteca",
    "ap.title.libraryAction": "Acción de biblioteca",
    "ap.title.modifyLibraryAction": "Modificar acción de biblioteca",
    "ap.title.name": "Nombres",
    "ap.title.surveys": "Encuestas",
    "ar-sa": "Árabe (Arabia Saudí)",
    "are-you-sure": "Haga clic para confirmar",
    "are.you.sure": "¿Está seguro?",
    "attribute": "Atributo",
    "attribute-list.no-attributes": "No hay atributos para mostrar. Por favor, vuelva a comprobar sus permisos, o entrar en contacto con el soporte.",
    "attribute-list.not-available": "",
    "attribute-list.not-available-tooltip": "",
    "attribute.breakdown": "Desglose de atributos",
    "attribute.click.to.confirm.archive": "Haga clic para confirmar el archivo",
    "attribute.click.to.confirm.unarchive": "Haga clic para confirmar la reactivación",
    "attribute.create": "Crear",
    "attribute.empty.message": "Seleccionar un atributo para continuar",
    "attribute.endDate": "Fecha de finalización",
    "attribute.name": "Nombre del atributo",
    "attribute.startDate": "Fecha de inicio",
    "attribute.unarchive": "Reactivar atributo",
    "attribute.unarchiveConfirmTitle": "¿Reactivar atributo \"{{nombre}}\"?",
    "attributes.all": "Todos los atributos",
    "attributes.label": "Atributo",
    "automated-invitations.add-another-trigger": "Añadir otro activador",
    "automated-invitations.add-trigger": "Añadir activador",
    "automated-invitations.box.switch": "Automatizar envío de invitaciones de encuestas de {{surveyType}}",
    "automated-invitations.box.title": "Encuestas de {{surveyType}}",
    "automated-invitations.confirm-delete-dialog.delete": "sí, eliminar",
    "automated-invitations.confirm-delete-dialog.delete-with-candidates": "Borrar disparador y candidatos",
    "automated-invitations.confirm-delete-dialog.message1": "Si elimina un activador solo afectará a futuras automatizaciones de expedientes de empleados. Esta acción no se puede deshacer.",
    "automated-invitations.confirm-delete-dialog.message2": "Todos los empleados a los que se haya invitado previamente y aquellos que se encuentren actualmente en la bandeja de salida no se verán afectados por esta acción. Además, siempre podrá volver a crear este activador en el futuro.",
    "automated-invitations.confirm-delete-dialog.message3": "Si su intención es detener la automatización, pero quiere conservar la configuración de los activadores, piense en la opción de activar la automatización de la encuesta.",
    "automated-invitations.confirm-delete-dialog.message4": "¿Seguro que quiere eliminar este activador?",
    "automated-invitations.confirm-delete-dialog.message5": "Esta acción afectará a todos los empleados que se encuentren actualmente en la bandeja de salida y que se hayan añadido a través de este activador",
    "automated-invitations.confirm-delete-dialog.title": "¿Eliminar activador \"{{triggerName}}\"?",
    "automated-invitations.confirm-disable-dialog.halt-automation": "sí, detener automatización",
    "automated-invitations.confirm-disable-dialog.message1": "Si detiene este proceso, solo afectará a futuras automatizaciones de expedientes de empleados. Esta acción se puede revertir fácilmente.",
    "automated-invitations.confirm-disable-dialog.message2": "Todos los empleados a los que se haya invitado previamente y aquellos que se encuentren actualmente en la bandeja de salida no se verán afectados por esta acción. Además, siempre podrá volver a activar esta automatización en el futuro.",
    "automated-invitations.confirm-disable-dialog.message3": "Al continuar, se conservarán todos los activadores configurados, pero no estarán activos.",
    "automated-invitations.confirm-disable-dialog.message4": "¿Seguro que quiere detener la automatización?",
    "automated-invitations.confirm-disable-dialog.success": "Automatización detenida correctamente.",
    "automated-invitations.confirm-disable-dialog.title": "¿Detener automatización de encuestas de {{surveyType}}?",
    "automated-invitations.confirm-pause-dialog.pause-message": "Pausar un activador sólo impedirá que se añadan futuros empleados a la lista. Los candidatos que ya estén en la lista no se verán afectados. Esta acción se puede revertir fácilmente. <0/> Puede anular la pausa de un activador en cualquier momento para reanudar la automatización, que buscará empleados coincidentes. <0/> ¿Está seguro de que desea pausar este activador?",
    "automated-invitations.confirm-pause-dialog.pause-title": "¿Disparador de pausa \"{{triggerName}}\"?",
    "automated-invitations.confirm-pause-dialog.unpause-message": "Al desactivar un activador se reanudará la automatización, que buscará empleados coincidentes para invitarles a participar en la encuesta. <0/> ¿Está seguro de que desea desactivar este activador?",
    "automated-invitations.confirm-pause-dialog.unpause-title": "¿Desactivar disparador \"{{triggerName}}\"?",
    "automated-invitations.rehiring.attribute-containing-rehire-date": "Atributo que contiene la fecha de recontratación",
    "automated-invitations.rehiring.description": "El sistema puede identificar si un empleado se ha reincorporado a la empresa, y permitirá múltiples participaciones en las encuestas de Incorporación y Salida. Se conservarán la invitación original a la encuesta y las respuestas.",
    "automated-invitations.rehiring.rehire-date-save-failed": "No se ha podido guardar la configuración de la fecha de recontratación, inténtelo de nuevo.",
    "automated-invitations.rehiring.rehire-date-saved": "La configuración de la fecha de recontratación se ha guardado correctamente.",
    "automated-invitations.rehiring.rehire-warning": "Tenga en cuenta que este cambio sólo afectará a los futuros cambios de Fecha de Recontratación, y no actualizará a los empleados existentes. En caso de que este atributo deje de estar disponible en el futuro (archivado o eliminado), el sistema volverá automáticamente a la Fecha de inicio.",
    "automated-invitations.rehiring.title": "Recontratación",
    "automated-invitations.these-triggers": "Estos activadores son...",
    "automated-invitations.trigger-form.actions": "Acciones desencadenantes",
    "automated-invitations.trigger-form.admin-users-helper": "Se trata de un campo interno visible sólo para los administradores de la plataforma",
    "automated-invitations.trigger-form.all-users-error": "Elige a un usuario o administrador de la plataforma. Al menos una persona debe ser notificada antes y después de que se envíen las invitaciones",
    "automated-invitations.trigger-form.attribute": "Atributo que contiene {{attribute}}",
    "automated-invitations.trigger-form.attribute-error": "Fecha requerida para calcular el momento adecuado para enviar una invitación",
    "automated-invitations.trigger-form.attribute-placeholder": "Elija un atributo",
    "automated-invitations.trigger-form.attributes-audience-error": "Seleccione al menos un filtro si utiliza público basado en atributos",
    "automated-invitations.trigger-form.automation-level": "Nivel de automatización",
    "automated-invitations.trigger-form.automation-level.automatic": "La invitación por correo electrónico se debe enviar automáticamente",
    "automated-invitations.trigger-form.automation-level.manual": "El administrador debe aprobar a los destinatarios",
    "automated-invitations.trigger-form.cancel": "Cancelar",
    "automated-invitations.trigger-form.custom": "A medida",
    "automated-invitations.trigger-form.custom-date.description.exit": "{{days}} días antes de la salida",
    "automated-invitations.trigger-form.custom-date.description.onboarding": "{{días}} días en la tenencia",
    "automated-invitations.trigger-form.custom-invitation-date": "Fecha de invitación personalizada",
    "automated-invitations.trigger-form.custom-view": "Personalizado ({{description}})",
    "automated-invitations.trigger-form.delete": "eliminar activador",
    "automated-invitations.trigger-form.delete-success": "Activador eliminado correctamente.",
    "automated-invitations.trigger-form.edit": "Editar activador",
    "automated-invitations.trigger-form.invitation-date": "Fecha prevista para la invitación",
    "automated-invitations.trigger-form.invitation-date.30-days-after": "A los 30 días de la posesión del cargo",
    "automated-invitations.trigger-form.invitation-date.60-days-after": "A los 60 días de la posesión del cargo",
    "automated-invitations.trigger-form.invitation-date.90-days-after": "A los 90 días de la posesión del cargo",
    "automated-invitations.trigger-form.invitation-date.exit-15-days-before": "15 días antes de la salida",
    "automated-invitations.trigger-form.invitation-date.exit-7-days-before": "7 días antes de la salida",
    "automated-invitations.trigger-form.invitation-date.exit-asap": "Lo antes posible",
    "automated-invitations.trigger-form.invitation-date.exit-date": "En la fecha de salida",
    "automated-invitations.trigger-form.invitation-date.start-date": "En la fecha de inicio",
    "automated-invitations.trigger-form.invitation-date.week-before": "Semana antes de la fecha de inicio",
    "automated-invitations.trigger-form.invitation-time": "Hora del día a la que enviar la invitación",
    "automated-invitations.trigger-form.invitation-time.end-of-day": "Al final del día (16:00-18:00 horas)",
    "automated-invitations.trigger-form.invitation-time.lunch": "Entre el medio día y la hora de la comida (12:00-14:00 horas)",
    "automated-invitations.trigger-form.invitation-time.morning": "A primera hora de la mañana (6:00-8:00 horas)",
    "automated-invitations.trigger-form.invitation-time.night": "Tarde en la noche (20:00-22:00 horas)",
    "automated-invitations.trigger-form.invitation-time.tooltip": "Esto ocurre cuando tus invitaciones entran en la cola de envío, no necesariamente cuando los destinatarios las reciben. Ten en cuenta que la entrega puede tardar hasta 3 horas después de que comience el plazo para mantener los estándares de entrega de correo electrónico.",
    "automated-invitations.trigger-form.name": "Nombre del activador",
    "automated-invitations.trigger-form.name-error": "Se requiere un nombre interno único",
    "automated-invitations.trigger-form.name-placeholder": "Introduzca un nombre de activador interno",
    "automated-invitations.trigger-form.new-trigger-title": "Nuevo activador",
    "automated-invitations.trigger-form.notified-admin-users": "Administradores de plataforma que deben recibir notificaciones por correo electrónico",
    "automated-invitations.trigger-form.notified-users": "Usuarios que deben recibir notificaciones por correo electrónico",
    "automated-invitations.trigger-form.pause": "Disparador de pausa...",
    "automated-invitations.trigger-form.pause-confirmation": "Sí, ponlo en pausa",
    "automated-invitations.trigger-form.pause-success": "Disparador pausado con éxito.",
    "automated-invitations.trigger-form.save": "Guardar activador",
    "automated-invitations.trigger-form.survey": "Encuesta de {{surveyType}} para invitar a",
    "automated-invitations.trigger-form.survey-error": "Seleccione una encuesta a la que se deba invitar a los empleados",
    "automated-invitations.trigger-form.survey-placeholder": "Elija una encuesta",
    "automated-invitations.trigger-form.target-audience": "Público objetivo",
    "automated-invitations.trigger-form.target-audience.attribute": "Basado en atributos",
    "automated-invitations.trigger-form.target-audience.everyone": "Todos",
    "automated-invitations.trigger-form.timezone": "{{timezone}}, según encuesta",
    "automated-invitations.trigger-form.unpause": "Desactivar gatillo...",
    "automated-invitations.trigger-form.unpause-confirmation": "Sí, desactívalo",
    "automated-invitations.trigger-form.unpause-success": "Disparo desbloqueado con éxito.",
    "automated-invitations.trigger-form.users-error": "Se debe avisar al menos a una persona antes y después de enviar las invitaciones",
    "back.to.login": "Volver al inicio de sesión",
    "benchmark.attribute.country": "país",
    "benchmark.attribute.industry": "industria",
    "benchmark.attribute.region": "región",
    "benchmark.attribute.sector": "sector",
    "benchmark.attribute.size": "tamaño",
    "benchmark.comment.insufficient-data": "Datos insuficientes (N={{companiesCount}})",
    "benchmark.comment.question-not-benchmarked": "Pregunta no comparada",
    "benchmark.compare.menu-item": "WorkTango Benchmark {{benchmarkPeriod}}",
    "benchmark.dropdown.label": "Comparación con",
    "benchmark.option-group.different-organization": "Diferente a tu organización",
    "benchmark.option-group.same-organization": "Igual que tu organización",
    "benchmark.option.all-companies": "Todas las empresas",
    "benchmark.option.other-country": "Otro país...",
    "benchmark.option.other-industry": "Otro sector...",
    "benchmark.option.other-region": "Otra región...",
    "benchmark.option.other-sector": "Otro sector...",
    "benchmark.option.other-size": "Otro tamaño...",
    "benchmark.option.same-country": "Mismo país ({{countryName}})",
    "benchmark.option.same-industry": "Misma industria ({{industryName}})",
    "benchmark.option.same-region": "Misma región ({{regionName}})",
    "benchmark.option.same-sector": "Mismo sector ({{sectorName}})",
    "benchmark.option.same-size": "Mismo tamaño ({{sizeName}})",
    "benchmark.option.top25-companies": "Cuartil superior de empresas con mayor puntuación",
    "benchmark.question-mapping.all-companies": "Todas las empresas",
    "benchmark.question-mapping.all-questions": "Todas las preguntas",
    "benchmark.question-mapping.all-survey-types": "Todos los tipos de encuesta",
    "benchmark.question-mapping.all-years": "Todos los años",
    "benchmark.question-mapping.empty": "No hay ninguna pregunta que coincida con sus filtros.",
    "benchmark.question-mapping.filter-question": "Filtrar por pregunta",
    "benchmark.question-mapping.library-question": "Pregunta de la biblioteca",
    "benchmark.question-mapping.not-tagged-msg": "Pregunta no utilizada para comparación",
    "benchmark.question-mapping.number-of-surveys": "N.º de encuestas",
    "benchmark.question-mapping.only-untagged": "Solo sin etiquetar",
    "benchmark.question-mapping.period": "Período",
    "benchmark.question-mapping.question-scope": "Alcance de la pregunta",
    "benchmark.question-mapping.survey-question": "Pregunta de la encuesta",
    "benchmark.question-mapping.survey-questions.title": "Etiquetar pregunta de la biblioteca con preguntas de la encuesta",
    "benchmark.question-mapping.survey-years": "Años de la encuesta",
    "benchmark.question-mapping.surveyType.dei": "Diversidad, equidad e inclusión",
    "benchmark.question-mapping.surveyType.engagement": "Compromiso",
    "benchmark.question-mapping.surveyType.exit": "Salida",
    "benchmark.question-mapping.surveyType.onboarding": "Incorporación",
    "benchmark.question-mapping.switch-mode": "Cambiar al etiquetado por pregunta de la encuesta",
    "benchmark.question-mapping.tagged": "Preguntas etiquetadas",
    "benchmark.question-mapping.tagged-survey-questions": "Preguntas de la encuesta etiquetadas",
    "benchmark.question-mapping.tagged-with-count": "Preguntas etiquetadas ({{count}})",
    "benchmark.question-mapping.title": "Etiquetar preguntas de la encuesta para comparación",
    "benchmark.question-mapping.untagged": "Preguntas no etiquetadas",
    "benchmark.question-mapping.update-mappings": "Guardar con {{selectedCount}} preguntas etiquetadas",
    "benchmark.question.indicator-tooltip": "Esta pregunta forma parte de WorkTango Benchmarking",
    "benchmark.title": "Punto de referencia",
    "benchmark.title.attribute": "Referencia de {{attributeName}}",
    "benchmark.title.attribute-value": "{{attributeName}}: {{valueName}}",
    "benchmark.title.same-country": "mismo-país",
    "benchmark.title.same-industry": "Mismo sector industrial",
    "benchmark.title.same-region": "Misma región",
    "benchmark.title.same-sector": "Mismo sector",
    "benchmark.title.same-size": "Mismo tamaño",
    "benchmark.title.top-quartile": "Cuartil superior",
    "benchmark.tooltip.disabled-option": "WorkTango no ha recogido esta información para su organización. Póngase en contacto con su representante de éxito del cliente para obtener ayuda.",
    "benchmark.tooltip.na": "En este momento solo se están comparando las preguntas",
    "benchmark.tooltip.no-other-values": "No hay suficientes organizaciones con un/a {{attributeName}} diferente con las que compararse.",
    "benchmark.unknown": "Desconocido",
    "benchmark.value-dropdown.label": "Otro/a {{attributeName}}",
    "benchmark.value-dropdown.placeholder": "Elegir {{attributeName}}",
    "boolean.no": "No",
    "boolean.yes": "Sí",
    "bottom.attributes": "Los cinco último atributos",
    "bounced.emails.list": "Algunos empleados no recibieron un correo electrónico. Revise la lista de errores a continuación para obtener más detalles.",
    "btc_sliding_05-07-2018": "Bitcoin",
    "button.add-filters": "Añadir filtros...",
    "button.add-selected": "Añadir seleccionados",
    "button.addRule": "Agregar segunda regla",
    "button.analyze": "Analizar",
    "button.apply": "Aplicar",
    "button.approve-all": "Aprobar todo",
    "button.automate.activate.survey": "Activar encuesta",
    "button.automate.deactivate.survey": "Desactivar encuesta",
    "button.back": "Volver",
    "button.back-attribute": "Volver a todos los atributos",
    "button.cancel": "Cancelar",
    "button.clone": "Clonar",
    "button.close": "Cerrar",
    "button.confirm": "Confirmar",
    "button.create": "Crear",
    "button.debug": "Depurar",
    "button.delete": "Eliminar",
    "button.download-template": "Descargar plantilla",
    "button.edit": "Editar",
    "button.edit-prompt": "Editar aviso",
    "button.export": "Exportar",
    "button.filter-results": "Filtrar resultados",
    "button.filters": "Filtros",
    "button.got-it": "Entendido",
    "button.hide": "Esconder",
    "button.launch": "Programar una encuesta",
    "button.launchNow": "Confirmar",
    "button.launchlater": "Cancelar",
    "button.leave": "Salir",
    "button.next-step": "Siguiente paso",
    "button.ok": "Aceptar",
    "button.override": "Sobrescribir",
    "button.previous-step": "Paso anterior",
    "button.re-analyze": "Volver a analizar",
    "button.remove": "Eliminar",
    "button.removeRule": "Eliminar segunda regla",
    "button.reset": "Restablecer",
    "button.retry-analysis": "Análisis de reintentos",
    "button.return": "Continuar editando",
    "button.return-templates": "Volver a las plantillas",
    "button.save": "Guardar",
    "button.save-changes": "Guardar cambios",
    "button.save-prompt": "Guardar aviso",
    "button.saveAndClose": "Guardar y cerrar",
    "button.saveAndSchedule": "Guardar cambios y programar",
    "button.search": "Búsqueda",
    "button.select.all.matches": "Seleccionar todas las {{count}} coincidencias",
    "button.select.all.visible": "Seleccionar todo lo visible",
    "button.send.test": "Enviar correo de prueba...",
    "button.show": "Espectáculo",
    "button.start": "Inicio",
    "button.start-import": "Iniciar importación",
    "button.start-migration": "Iniciar migración",
    "button.tag.all.matches": "Etiquetar todas las {{count}} coincidencias",
    "button.tag.all.visible": "Etiquetar todo lo visible",
    "button.tooltip.migration-failure": "Busque el motivo del fallo en el correo electrónico que se le ha enviado a {{email}}",
    "button.tooltip.pending-for-approval": "Aprobar migración y marcar encuesta como Completada",
    "button.unselect.all": "Deseleccionar todo",
    "button.unselect.visible": "Deseleccionar lo visible",
    "button.untag.all.matches": "Desetiquetar todas las {{count}} coincidencias",
    "button.untag.all.visible": "Desetiquetar todo lo visible",
    "button.update": "Actualizar",
    "button.upload-survey": "Cargar datos de la encuesta",
    "button.yes-remove": "Sí, eliminar",
    "categories.all": "Seleccionar factor",
    "category.enName": "Nombre del factor (En)",
    "category.frName": "Nombre del factor (Fr)",
    "category.name": "Nombre del factor",
    "change": "Cambiar",
    "clear.content.type": "Eliminar tipo de contenido",
    "clibrary.navigation.read": "Leído",
    "clibrary.navigation.starred": "Marcado",
    "clibrary.navigation.unread": "No leído",
    "close": "Cerrar",
    "coach.end.summary.qestion": "¿Hay algo concreto que quiera que le aclare o profundice en relación con esta encuesta?",
    "coach.present.summary.header": "Aquí tienes el resumen de la encuesta generado por la inteligencia artificial:",
    "colorpicker.title": "Elegir color",
    "comment.idea": "¡Gran idea!",
    "comment.like": "Me gusta",
    "comment.reply": "Responder el comentario",
    "comment.working": "Trabajando en ello",
    "comments.attributeFiltersIgnored": "Los filtros que has aplicado no se reflejan en los comentarios que aparecen a continuación.",
    "comments.filter.sentiment": "Filtrar por sentimiento",
    "comments.filter.theme": "Filtrar por tema",
    "common.approved": "Aprobar",
    "common.bottom": "Abajo",
    "common.field.isDisabled": "No se puede editar este campo",
    "common.nameUsed": "Ya se utilizó ese nombre",
    "common.none": "Ninguno",
    "common.not-approved": "No aprobado",
    "common.notify": "Notificar",
    "common.other": "Otro",
    "common.select": "Seleccionar",
    "common.selected": "seleccionado",
    "common.top": "Arriba",
    "company.add": "Agregar Empresa",
    "company.error.duplicateSalesforceId": "Ya existe una empresa con el mismo ID de Salesforce",
    "company.industry.assetIntensive": "Intensivo en activos",
    "company.industry.financialService": "Servicios financieros",
    "company.industry.healthcare": "Cuidado de la salud",
    "company.industry.technology": "Tecnología",
    "company.region.APAC": "APAC",
    "company.region.Canada": "Canadá",
    "company.region.EMEA": "EMEA",
    "company.region.NorthAmerica": "América del Norte",
    "company.region.UnitedStates": "Estados Unidos",
    "company.sector.private": "Privado",
    "company.sector.public": "Público",
    "compare-with": "Comparar con",
    "compare.attribute": "Comparación de atributos",
    "compare.attributes": "Atributo(s)",
    "compare.dropdown.benchmarks-group": "Punto de referencia, no utiliza filtros aplicados",
    "compare.dropdown.current-survey-group": "Encuestas actuales, no utiliza filtros aplicados",
    "compare.dropdown.different-timeframe": "Plazos diferentes",
    "compare.dropdown.other-surveys-group": "Otra encuesta, utiliza filtros aplicados",
    "compare.none": "Ninguno",
    "compare.organization": "En toda la organización",
    "compare.survey": "Encuesta",
    "compare.timeframe": "Comparación temporal",
    "compare.to": "Comparar con: {{name}}",
    "compare.toSurvey": "Comparar encuesta",
    "completed": "Completo",
    "contact.us": "Contáctenos",
    "continuous-survey.triggers.add-trigger": "Configurar nuevo disparador para esta encuesta...",
    "continuous-survey.triggers.configure-automation": "Configurar la automatización",
    "continuous-survey.triggers.no-triggers-subtitle": "No hay disparadores activos configurados para esta encuesta. Para que la automatización funcione, se necesita al menos un activador activo. ",
    "continuous-survey.triggers.no-triggers-warning": "No hay activadores configurados",
    "continuous-survey.triggers.trigger-type-disabled-button": "Ir a la configuración de automatización de encuestas",
    "continuous-survey.triggers.trigger-type-disabled-subtitle": "El sistema no añadirá automáticamente nuevos candidatos a esta encuesta.",
    "continuous-survey.triggers.trigger-type-disabled-warning": "Automatización desactivada",
    "continuous-survey.triggers.view-all": "Ver los desencadenantes de todas las encuestas",
    "conversations.placeholder": "Escribiendo un mensaje...",
    "courier.general.click.here": "Restablecer mi contraseña",
    "courier.password.reset.email": "alguien solicitó un enlace para restablecer la contraseña de la plataforma de WorkTango.",
    "create.reminder.button": "Crear un nuevo recordatorio…",
    "createSurvey.logicEditor": "Editor lógico",
    "createSurvey.questionEditor": "Editor de preguntas",
    "created": "Creado",
    "created.by": "Creado por",
    "cs-cz": "Checo",
    "da-dk": "Danés",
    "date.operator.greater": "mayor o igual que",
    "date.operator.less": "menor o igual que",
    "date.unit.day": "día(s)",
    "date.unit.month": "mes(es)",
    "date.unit.year": "año(s)",
    "dateStatus0": "Creado:",
    "dateStatus1": "Programado:",
    "dateStatus2": "Finaliza:",
    "dateStatus3": "Completo el:",
    "de-de": "Alemán",
    "deactivated": "Desactivado",
    "debug.header": "Depurar",
    "default": "defecto",
    "detractor.2": "Detractor",
    "disabled": "Inactivo",
    "dmin.survey.build.add-recipient.title_one": "",
    "doNotContact.add.success": "Empleado añadido correctamente a la lista.",
    "doNotContact.adding-reason": "Motivo de la adición",
    "doNotContact.adding-reason.placeholder": "Introduzca el motivo por el que se añade este empleado o empleados",
    "doNotContact.automaticEmailTriggers.tab": "",
    "doNotContact.button.addEmployee": "Añadir empleado a la lista",
    "doNotContact.dialog.add.noEmployees": "No hay ningún empleado que coincida con sus filtros.",
    "doNotContact.dialog.add.title": "Seleccione los empleados que desea añadir",
    "doNotContact.dialog.delete.message1": "Eliminar a una persona de esta lista significa que ya no se la ignorará en las invitaciones automáticas a encuestas.",
    "doNotContact.dialog.delete.message2": "Si usted no colocó inicialmente a {{name}} en la lista, el sistema enviará también una notificación al usuario que lo hizo.",
    "doNotContact.dialog.delete.message3": "¿Seguro que desea eliminar a {{name}} de la lista?",
    "doNotContact.dialog.delete.title": "¿Eliminar a {{name}} de la lista?",
    "doNotContact.filterEmployee": "Filtrar empleados",
    "doNotContact.page.title": "Lista \"No contactar\"",
    "doNotContact.reason.required": "Este campo no puede estar vacío",
    "doNotContact.remove.success": "Empleado eliminado correctamente de la lista.",
    "doNotContact.selectedEmployees.required": "Debe seleccionar al menos un empleado de la lista.",
    "doNotContact.smsOptOuts.addEmployee": "",
    "doNotContact.smsOptOuts.addedBySystem": "",
    "doNotContact.smsOptOuts.description": "",
    "doNotContact.smsOptOuts.remove.message1": "",
    "doNotContact.smsOptOuts.tab": "",
    "doNotContact.table.addedAtTimeUTC": "Añadido a la lista",
    "doNotContact.table.addedByUserName": "Añadido por",
    "doNotContact.table.email": "Correo electrónico",
    "doNotContact.table.name": "Nombre del empleado",
    "doNotContact.table.noData": "No hay ningún empleado que coincida con sus filtros.",
    "doNotContact.table.reason": "Motivo",
    "draft": "Borrador",
    "el-gr": "Griego",
    "email": "Correo electrónico",
    "email.account.locked.body.if.you.did.not.attempt": "Si no es usted quien está intentando iniciar sesión, incluya esta información en la solicitud que le envíe a nuestro equipo de asistencia.",
    "email.account.locked.body.please.reach.out": "Restablezca su contraseña para desbloquear la cuenta.",
    "email.account.locked.body.someone.have.attempted": "Alguien intentó iniciar sesión en WorkTango varias veces con esta dirección de correo electrónico, pero no lo logró.",
    "email.account.locked.reset.password": "Restablecer la contraseña",
    "email.account.locked.subject": "Cuenta de WorkTango bloqueada",
    "email.activate.account.btn": "Active su cuenta",
    "email.anon.convo.employee.have.replied": "un empleado respondió a una conversación anónima de la que usted es parte.",
    "employee.addNewEmployee": "Agregar nuevo empleado",
    "employee.duplicatedEmployeeId": "Existen varias filas con el mismo ID de empleado: {{employeeId}}",
    "employee.export.exportEmployees": "Exportar Empleados",
    "employee.export.loading": "Estamos procesando la solicitud. Aguarde un momento.",
    "employee.import.activationWarning.agreementMessage": "Entiendo que se activará 1 nuevo usuario",
    "employee.import.activationWarning.agreementMessage.plural": "Entiendo que se activarán {{count}} nuevos usuarios",
    "employee.import.activationWarning.description": "Si procede con esta importación, los siguientes empleados tendrán acceso al sistema según su rol que aparece entre paréntesis:",
    "employee.import.activationWarning.title": "Aviso de activación",
    "employee.import.email.failed.error.label": "Detalles del error:",
    "employee.import.email.failed.message": "La importación de empleados de {{companyName}} no se ha podido completar. No se realizaron cambios en los datos de sus empleados durante el procesamiento de {{fileName}}.",
    "employee.import.email.failed.next.steps": "Corrija el problema en {{fileName}} e inicie la importación de nuevo.",
    "employee.import.email.failed.subject": "No se ha podido importar el empleado",
    "employee.import.email.succeeded.message": "La importación de empleados de {{companyName}} ha terminado de procesar {{fileName}}. Los datos de sus empleados están ahora actualizados.",
    "employee.import.email.succeeded.subject": "Importación de empleados completada",
    "employee.import.error.attributeTypeErrors": "Tipo de valor de atributo incorrecto",
    "employee.import.error.customPermissionsRows": "No es posible establecer \"permisos personalizados\" (fila {{rows}}). Los permisos personalizados solo se pueden añadir en la plataforma y solo se admite la concesión de roles con nombre en el archivo.",
    "employee.import.error.duplicateUniqueValues": "Duplicar valor único",
    "employee.import.error.fileValidation": "Corrija los siguientes errores en su archivo y vuelva a intentarlo",
    "employee.import.error.fileValidationDescription": "Corríjalos y cargue un nuevo archivo.",
    "employee.import.error.fileValidationTitle": "El archivo cargado tiene problemas.",
    "employee.import.error.invalidType": "el empleado '{{employeeId}}' tiene un tipo de valor incorrecto para el campo {{attrType}} '{{attrName}}'",
    "employee.import.error.invitingDisabledEmployee": "No es posible invitar a un nuevo usuario y desactivar su acceso al mismo tiempo. Borre el valor $SurveyRole o establezca Activado en \"Sí\" en las filas {{rows}}",
    "employee.import.error.missingField": "al empleado '{{employeeId}}' le falta el campo obligatorio '{{attrName}}'",
    "employee.import.error.missingRequiredErrors": "Faltan campos requeridos",
    "employee.import.error.modifiedEmployeeId": "ID de {{employeeName}} cambiado de {{oldEmployeeId}} a {{newEmployeeId}}",
    "employee.import.error.modifiedEmployeeIdErrors": "ID de empleados modificados (NO debe cambiar aquí)",
    "employee.import.error.noHeaders": "Falta el encabezado del atributo",
    "employee.import.error.unableToImport": "No se pueden importar empleados",
    "employee.import.error.unableToReadFile": "Imposible leer el archivo. Pruebe con un archivo diferente o solucione el problema con el archivo seleccionado.",
    "employee.import.error.unknownAttributeNames": "Nombre de atributo desconocido",
    "employee.import.error.unknownRoleNamesRows": "Se ha proporcionado un nombre de rol desconocido (fila {{rows}}). Asegúrese de que el nombre del rol proporcionado en el archivo es idéntico al configurado en la plataforma.",
    "employee.import.error.unsupportedLangs": "Idioma no admitido",
    "employee.import.error.userMissingEmailRows": "Falta el correo electrónico del usuario (fila {{rows}}). Asegúrese de que todos los usuarios (empleados con roles) tienen una dirección de correo electrónico.",
    "employee.import.history.column.date": "Fecha de carga",
    "employee.import.history.column.uploader": "Cargado por",
    "employee.import.history.dialog.date": "Fecha de importación",
    "employee.import.history.dialog.dateOriginFile": "Fecha de importación, origen y nombre de archivo original",
    "employee.import.history.dialog.dateOriginFileValue": "{{date}} por {{origin}} ({{fileName}})",
    "employee.import.history.dialog.dateOriginValue": "{{date}} por {{origin}}",
    "employee.import.history.dialog.errors": "Detalles del error",
    "employee.import.history.dialog.errorsCount": "1 error",
    "employee.import.history.dialog.errorsCount.plural": "{{count}} errores",
    "employee.import.history.dialog.issueRow": "Fila {{rowNumber}}: {{message}}",
    "employee.import.history.dialog.issues": "Errores y advertencias de importación",
    "employee.import.history.dialog.loadError": "Se produjo un error al cargar los detalles de la importación. Inténtelo de nuevo.",
    "employee.import.history.dialog.notFound": "No se encontró esta importación.",
    "employee.import.history.dialog.title": "Detalles de la importación",
    "employee.import.history.dialog.warningsCount": "1 advertencia",
    "employee.import.history.dialog.warningsCount.plural": "{{count}} advertencias",
    "employee.import.history.empty": "Aún no hay importaciones.",
    "employee.import.history.loadError": "Se produjo un error al cargar el historial de importación. Inténtelo de nuevo.",
    "employee.import.history.status.error": "Error",
    "employee.import.history.status.processing": "Procesando",
    "employee.import.history.title": "Historial de importaciones",
    "employee.import.history.viewDetails": "Ver detalles...",
    "employee.import.importEmployees": "Importar empleados",
    "employee.import.importFile": "Importar archivo",
    "employee.import.importType": "Tipo de importación",
    "employee.import.instructions": "Esta acción actualizará los datos de los empleados según el contenido del archivo de importación y su configuración del tipo de importación.",
    "employee.import.instructions.generated-file": "Utilice el <0>archivo de muestra generado</0> para darle el formato adecuado.",
    "employee.import.is-valid": "El archivo cargado no tiene problemas.",
    "employee.import.override": "Esta acción sobrescribirá el archivo del empleado actual y lo reemplazará con el archivo que se está cargado. NOTA: Se marcará como INACTIVO al empleado que no figure en la nueva lista.",
    "employee.import.override.description": "Además de añadir nuevos y actualizar los existentes, los empleados que no figuren en el archivo de importación serán desactivados",
    "employee.import.scheduled.message": "Te enviaremos un correo electrónico cuando haya finalizado la importación de tu expediente de empleado.",
    "employee.import.scheduled.title": "Se ha iniciado la importación",
    "employee.import.selectFile": "Seleccione un archivo (.xlsx o .csv)",
    "employee.import.success": "Datos de empleados importados correctamente",
    "employee.import.title": "Importar datos de empleados",
    "employee.import.update": "Esta acción actualizará el archivo existente con la nueva información del archivo que se está cargando",
    "employee.import.update.description": "Los datos de los empleados en el archivo se utilizarán para crear nuevos empleados y actualizar los datos de los empleados existentes",
    "employee.import.validating-file": "Comprobando si hay problemas con los archivos...",
    "employee.import.warning.accept-deactivated.employees": "Entiendo que se desactivarán $t(empleados, {\"count\": {{employees}} })",
    "employee.import.warning.accept-deactivated.users": "Entiendo que se activarán $t(usuarios, {\"count\": {{users}} })",
    "employee.import.warning.accept-deactivated.users-and-employees": "Entiendo que se desactivarán $t(usuarios, {\"count\": {{users}} }) y $t(empleados, {\"count\": {{employees}} })",
    "employee.import.warning.deactivatedEmployees": "Si continúa con esta importación, se desactivarán los siguientes empleados:",
    "employee.import.warning.deactivatedUsers": "Si continúa con esta importación, se desactivarán los siguientes usuarios:",
    "employee.import.warning.title": "Aviso de desactivación",
    "employee.list.lastUpdated": "Última actualización: {{date}}",
    "employee.update-ids.description": "Esta acción actualizará irreversiblemente la identificación del empleado para todos los incluidos en el archivo.",
    "employee.update-ids.employee-id": "ID de empleado",
    "employee.update-ids.error.blankCurrentIds": "Faltan los ID actuales",
    "employee.update-ids.error.blankNewIds": "Faltan los nuevos ID",
    "employee.update-ids.error.duplicatedCurrentIds": "ID actuales duplicados",
    "employee.update-ids.error.duplicatedNewIds": "Nuevos ID duplicados",
    "employee.update-ids.error.empty-new-id": "El nuevo ID de empleado no puede estar vacío",
    "employee.update-ids.error.file-validation": "El archivo cargado tiene problemas, corríjalos y vuelva a cargarlo",
    "employee.update-ids.error.invalidCurrentIds": "Los ID actuales no existen",
    "employee.update-ids.error.occupied-new-id": "El nuevo ID de empleado ya está ocupado. Introduzca uno único.",
    "employee.update-ids.error.occupiedNewIds": "Nuevos ID ya ocupados",
    "employee.update-ids.error.row-no": "N.º de fila",
    "employee.update-ids.error.unable-update": "No es posible actualizar el ID de empleado de la empresa",
    "employee.update-ids.individual.title": "Actualizar ID de empleado",
    "employee.update-ids.sampleFile1": "Por favor use el",
    "employee.update-ids.sampleFile2": "para un formato adecuado.",
    "employee.update-ids.success": "ID de empleados actualizado correctamente.",
    "employee.update-ids.success-completed": "ID de empleados actualizado correctamente.",
    "employee.update-ids.title": "Actualización masiva de ID de empleados",
    "employee.update-ids.updating": "Actualizando ID de empleados",
    "employee.update-ids.upload-file": "Cargar archivo",
    "employee.upload-ids.validate.loading": "Comprobando si hay problemas con los archivos",
    "employee.upload-ids.validate.pass": "El archivo cargado no tiene problemas.",
    "employee.upload.employeeData": "Datos del empleado",
    "employee.upload.mismatch": "Hay campos que no coinciden en el archivo.",
    "employee.upload.uniqueConflict": "Empleado: {{ firstEmployee }} y empleado: {{ lastEmployee }} usan el mismo valor: {{ value }} para el atributo: {{ name }}",
    "employee.upload.updateEmployeeIds": "Actualización de ID de empleados",
    "employees.accessChange.attributeFrom": "{{attribute}} cambia de",
    "employees.accessChange.attributeTo": "a",
    "employees.accessChange.begin": "Empleados cuyo acceso a los datos cambiará:",
    "employees.accessChange.desc": "Los siguientes empleados también son usuarios y tienen acceso a los datos de la encuesta en función de sus atributos de empleado. Continuar con este cambio modificará el acceso que tienen a los datos de la encuesta. ¿Deseas continuar?",
    "employees.accessChange.title": "Advertencia: El acceso a datos de la encuesta cambiará para algunos usuarios",
    "employees.export.success": "Empleados exportados al archivo '{{filename}}'.",
    "employees_one": "{{count}} empleado",
    "employees_other": "{{count}} empleados",
    "en-ca": "Inglés",
    "en-us": "Inglés (US)",
    "entities.table.entity": "Entidad",
    "entities.table.frequency": "Frecuencia",
    "entities.table.sentiment": "Opinión",
    "entities.table.type": "Tipo",
    "error.create.roleName.required": "Se requiere el nombre del rol",
    "error.invite.all.emails.valid": "todos los correos electrónicos deben ser válidos",
    "error.invite.at.least.one.email": "se necesita al menos un correo electrónico",
    "error.invite.at.least.one.survey.type.permission": "se requiere al menos un permiso para el tipo de encuesta",
    "error.invite.from.required": "se requiere el nombre del remitente",
    "error.invite.include.all.compare.attributes.in.filter.attributes.list": "Añade los atributos de la lista \"{{compareAttributesHeader}}\" que no estén en la lista \"{{filterAttributesHeader}}\".",
    "error.invite.language.required": "se requiere el idioma",
    "error.invite.oops": "Lo sentimos, parece que falta información",
    "error.invite.please.check.validations": "Verifica las siguientes validaciones:",
    "error.lockedOut": "Ha superado el número máximo permitido de intentos de inicio de sesión. Para desbloquear su cuenta, restablezca su contraseña.",
    "error.msg.invalid.employee": "ID de empleado no válida",
    "error.msg.you.have.exceeded.max.login.attempts": "Ha superado el número máximo permitido de intentos de inicio de sesión. Para desbloquear su cuenta, restablezca su contraseña haciendo clic en \"¿Olvidó su contraseña?\" enlace debajo.",
    "error.no.employee.matching.hierarchy.user": "Para invitar usuarios con acceso basado en jerarquía o en atributos personalizados, es necesario que figuren como empleados",
    "error.roleName.duplicated": "El nombre de rol ya existe",
    "error.somethingWentWrong": "Se ha producido un error",
    "error.validationError": "Error de validación",
    "errorBoundary.errorPreDescription": "Detalles del error que pueden ayudar a nuestros técnicos a diagnosticar el problema:",
    "errorBoundary.headImageAltText": "A la derecha hay un servidor, mientras que en el centro está la toma de corriente desenchufada.",
    "errorBoundary.resetButton": "Recargar esta página",
    "errorBoundary.subtitle": "El sistema ha encontrado un error inesperado. Por favor, intente recargar la página.",
    "errorBoundary.title": "¡Ups!",
    "errors.tokenExpired": "inicie sesión",
    "es-es": "Español",
    "export.all": "Todos los datos",
    "export.attributeType": "Tipo de atributo",
    "export.attributesSelected": "Atributos seleccionados:",
    "export.comment": "Comentario",
    "export.compareTo": "Comparar con:",
    "export.favourable": "Favorable",
    "export.filterSelected": "Filtro seleccionado:",
    "export.header": "Exportar",
    "export.neutral": "Neutro",
    "export.outof": "De",
    "export.overallResponseRate": "Tasas de respuesta general",
    "export.qualitative": "Datos cualitativos",
    "export.quantitative": "Datos cuantitativos",
    "export.question": "Pregunta:",
    "export.surveySelected": "Encuesta seleccionada:",
    "export.themes": "Temas de IA",
    "export.title.timeframe-selected": "Plazo seleccionado:",
    "export.unfavourable": "Desfavorable",
    "exportMenu.errorDialog.message": "Error al generar un resumen de la exportación",
    "exportMenu.export": "Exportar",
    "exportMenu.loadingDialog.message": "Se está creando la exportación en estos momentos. Se espera que comience la descarga en un minuto.",
    "exportMenu.loadingDialog.title": "La exportación estará lista en breve.",
    "factor": "Factor",
    "factor.score": "Puntuación de factores",
    "factors": "Factores",
    "factors.filter.prompt": "Seleccionar factores",
    "factors.questions": "Pregunta de factores",
    "favorable.button.text": "FAV",
    "feedback.email.subject.anon.reaction": "Se recibieron correctamente los comentarios confidenciales.",
    "fi-fi": "Finés",
    "field.isRequired": "{{field}} es un campo obligarotio",
    "fieldType.boolean": "Sí/No",
    "fieldType.date": "Fecha",
    "fieldType.email": "Correo electrónico",
    "fieldType.number": "Número",
    "fieldType.string": "Texto",
    "fieldType.time": "Hora",
    "filter.attributes.main": "Seleccionar atributo",
    "filter.attributes.values": "Seleccionar los valores del atributo",
    "filter.by.factors": "Filtrar por factores",
    "filter.byAttribute": "Filtrar por atributo",
    "filter.date.startMessage": "Mostrar todos los destinatarios con",
    "filter.date.title": "Filtrar por fecha de inicio",
    "filter.dateRange.clear": "Eliminar rango de fechas",
    "filter.dateRange.title": "Seleccionar rango de fechas",
    "filter.filterBy": "Filtrado por",
    "filter.message": "Buscando un mensaje...",
    "filter.question": "Filtrar por pregunta",
    "fixed_eyes": "Ojos",
    "fixed_faces_1": "Caras 1",
    "fixed_faces_2": "Caras 2",
    "fixed_flowers": "Flores",
    "fixed_gas_tank": "Tanque de gasolina",
    "fixed_generation": "Generación",
    "fixed_glasses_of_water": "Vasos de agua",
    "fixed_growing_wheels": "Evolución de ruedas",
    "fixed_hands": "Manos",
    "fixed_hearts_gradient": "Corazones (degradado)",
    "fixed_hurdles": "Obstáculos",
    "fixed_ice_cream_emoji": "Emoji de helado",
    "fixed_mad_happy_emoji": "Emoji enojado y feliz",
    "fixed_magnifying_glass": "Lupa",
    "fixed_mood_weather": "Avatares del clima",
    "fixed_office": "Oficina",
    "fixed_overwhelmed_happy_emoji": "Emoji feliz desbordado",
    "fixed_poo_emoji": "Emoji de popó",
    "fixed_rockets": "Cohetes",
    "fixed_sad_happy_emoji": "Emoji triste y feliz",
    "fixed_stairs": "Escaleras",
    "fixed_teal_rose": "Rosa floreciendo",
    "fixed_technology": "Tecnología",
    "fixed_thumbs_rotating": "Pulgares giratorios",
    "fixed_trophies": "Trofeos",
    "fixed_type_of_work": "Tipo de trabajo",
    "fixed_workplace_flexibility": "Flexibilidad del lugar de trabajo",
    "forgot.password.dialog.description": "Ya se le envío el enlace para restablecer su contraseña.",
    "forgot.password.dialog.title": "Verifique su casilla de entrada.",
    "forgot.password.instruction": "No se preocupe. Le pasa hasta a los mejores. Agregue su correo electrónico más abajo, y le enviaremos un enlace para restablecer su contraseña.",
    "form.dependsOn": "Este campo {{label}} es obligatorio",
    "form.exit": "Cerrar",
    "form.fileError": "Verifique los siguientes campos del archivo.",
    "form.fileSelected": "Archivo seleccionado:",
    "form.invalid": "Lo sentimos. Verifique la información ingresada.",
    "form.invalidAttribute": "El atributo '{{name}}' no es válido",
    "form.isBoolean": "Es necesario que este campo sea verdadero/falso",
    "form.isDate": "Es necesario que este campo sea AAAA-MM-DD",
    "form.isEmail": "Ingrese una dirección de correo electrónico válida",
    "form.isNotA": "'{{value}}' no es un {{type}}",
    "form.isNumber": "Es necesario que este campo sea un número",
    "form.isRequired": "Este campo es obligatorio",
    "form.isUnique": "Este campo debe ser único",
    "form.row": "Fila",
    "fr-ca": "Francés (CA)",
    "fr-fr": "Francés (FR)",
    "gemAI.dialog.title": "Aviso y respuesta de IA generativa",
    "genAI.button.awaiting-response": "Esperando respuesta de la IA",
    "genAI.button.export-ai-data": "Empezar a exportar datos de IA",
    "genAI.button.send-prompt": "Volver a enviar el aviso y guardar la nueva respuesta",
    "genAI.commentAnalysis.deleteDialog.confirmButton": "Sí, eliminar",
    "genAI.commentAnalysis.deleteDialog.confirmText": "¿Seguro que quiere eliminar este análisis?",
    "genAI.commentAnalysis.deleteDialog.descriptionText": "Esta acción eliminará el <0>resumen de comentarios</0> generado por la IA de forma permanente y le permitirá generar uno nuevo. Tenga en cuenta que el nuevo resumen de comentarios puede diferir del original, ya sea estilísticamente o en su contenido. Esto es así, sobre todo, en los casos en los que el aviso de la IA o el algoritmo de la IA se hayan actualizado entre este momento y la última vez que se generó.",
    "genAI.commentAnalysis.deleteDialog.error": "Error al borrar el análisis de IA. Inténtelo de nuevo.",
    "genAI.commentAnalysis.deleteDialog.success": "Análisis de IA eliminado correctamente.",
    "genAI.commentAnalysis.deleteDialog.title": "Eliminar análisis de IA",
    "genAI.comments.analysis": "Análisis de IA",
    "genAI.comments.analysis-available": "El análisis de IA está disponible",
    "genAI.comments.analysis-negatives": "Los negativos",
    "genAI.comments.analysis-next-steps": "Acciones recomendadas",
    "genAI.comments.analysis-not-performed": "¿Quiere pedir a la IA que interprete los resultados?",
    "genAI.comments.analysis-positives": "Los positivos",
    "genAI.comments.analysis-summary": "En pocas palabras",
    "genAI.comments.analyzing": "La IA está analizando los resultados...",
    "genAI.comments.continuous-survey.analyze": "¿Pedir a la IA que interprete los resultados para este plazo?",
    "genAI.comments.continuous-survey.failed-load": "Se ha producido un problema al procesar tu solicitud. Pida a la IA que vuelva a intentar interpretar los resultados para este periodo de tiempo",
    "genAI.comments.failed-load": "Se ha producido un problema al procesar tu solicitud. ¿Pedir a la IA que vuelva a intentar interpretar los resultados?",
    "genAI.debug-mode": "Modo de depuración de IA",
    "genAI.dialog.context-label": "Contexto utilizado para preparar la IA",
    "genAI.dialog.prompt-label": "Aviso utilizado para generar la respuesta",
    "genAI.dialog.response-label": "Respuesta sin procesar de la IA",
    "genAI.dialog.sentiment-label": "Opinión analizada",
    "genAI.dialog.theme-label": "Temas clave analizados",
    "genAI.export.AI-generated-data": "Datos generados por IA",
    "genAI.export.AI-report-dialog.title": "Descargar datos generados por IA",
    "genAI.export.ai-report.text1": "Esta acción iniciará la recopilación de todos los datos generados por la IA para esta encuesta y los compilará en un archivo de Excel. El archivo estará disponible para una <0>descarga única</0> a través de un enlace de correo electrónico que se enviará a la siguiente dirección:",
    "genAI.export.ai-report.text2": "Antes de solicitar el inicio de la exportación, asegúrese de que la dirección de correo electrónico que se indica es correcta.",
    "genAI.label.find-in-comments": "Buscar en los comentarios",
    "genAI.not-available": "No disponible",
    "genAI.question.analysis-generated": "Análisis de IA generado",
    "genAI.question.analysis-not-performed": "Análisis de IA no realizado",
    "genAI.surveys.analysis-areas-of-opportunity": "Áreas de oportunidad",
    "genAI.surveys.analysis-areas-to-watch": "Áreas a tener en cuenta",
    "genAI.surveys.analysis-overall-summary": "Resumen breve general de los hallazgos",
    "genAI.surveys.analysis-participation-rate": "Tasa de participación",
    "genAI.surveys.analysis-qualitative-feedback": "Resumen de la retroalimentación cualitativa",
    "genAI.surveys.analysis-recommended-actions": "Acciones recomendadas",
    "genAI.surveys.analysis-strengths": "Fortalezas",
    "genAI.title.key-theme": "Tema clave",
    "genAi.comments.error.rate-limit": "Ha superado nuestro límite de tarifa para esta funcionalidad de AI. El límite actual permite un máximo de 20 resúmenes en un periodo de 10 minutos. El acceso se restablecerá en los próximos 10 minutos. Gracias por su paciencia.",
    "genAi.comments.translationNotification": "Tenga en cuenta que el siguiente resumen ha sido traducido del inglés.",
    "genai.": "",
    "genai.analysis-type.comment-analysis": "Análisis de sentimiento de comentarios",
    "genai.analysis-type.comments-summary": "Resumen de comentarios",
    "genai.analysis-type.rating-question-summary": "Resumen de preguntas de calificación",
    "genai.analysis-type.theme-association": "Asociación temática",
    "genai.analysis-type.theme-extraction": "Extracción de temas",
    "genai.button.config-prompts": "Configurar avisos",
    "genai.prompt-custom.token-label": "Tóquenes disponibles:",
    "general.clearAll": "Eliminar todo",
    "general.here": "aquí",
    "global.error.500": "Lo sentimos. Se ha producido un error. ",
    "graph.average": "Promedio",
    "graph.detractors": "Detractores",
    "graph.favorable": "Favorable",
    "graph.neutral": "Neutro",
    "graph.passives": "Pasivos",
    "graph.promoters": "Promotores",
    "graph.respondents": "{{answered}} de {{total}} personas respondieron",
    "graph.unfavorable": "Desfavorable",
    "group.delete": "Eliminar",
    "has.suggestions.description": "Aquí le mostramos las medidas y las acciones recomendadas según los resultados de las encuestas.",
    "header.actionContent": "Planificación del Contenido",
    "header.help": "Ayuda",
    "header.learning-content": "Contenido de aprendizaje",
    "header.logout": "Cerrar sesión",
    "header.profile": "Perfil",
    "header.signin": "Iniciar sesión",
    "header.surveyTemplates": "Plantillas",
    "header.switch": "Cambiar de empresa",
    "heatmap.allAnonymized.tooltip": "La opción \"Totalmente anónimo\" consta de un máximo de {{ fully }} respuestas de empleados totalmente anónimas y {{ partial }} preguntas parcialmente anónimas debido a condiciones de atributos o lógica de la pregunta. Consulte el artículo para obtener más información.",
    "heatmap.compare.empty": "No se muestra ningún dato porque no hay {{ filter }} en {{ compare }}",
    "heatmap.header": "Mapa térmico",
    "heatmap.hide.empty.columns": "Ocultar las columnas vacías",
    "heatmap.legend.highest": "Más alto",
    "heatmap.legend.least.favorable": "Más bajo Favorable",
    "heatmap.legend.lowest": "Más bajo",
    "heatmap.legend.most.favorable": "Más favorable",
    "heatmap.legend.negative": "Desfavorable",
    "heatmap.legend.positive": "Favorable",
    "heatmap.legend.text": "los datos reflejan los valores mínimos y máximos para las respuestas de la encuesta",
    "heatmap.overall": "en general",
    "heatmap.responses": "Cantidad de respuestas",
    "heatmap.score": "Puntaje",
    "heatmap.show.categories": "Factores",
    "heatmap.show.questions": "Preguntas",
    "help.email.header": "Envíenos un correo electrónico",
    "help.email.message": "Envíenos un correo electrónico a",
    "help.guides.header": "Guía de uso",
    "help.guides.linkText": "Haga clic aquí para consultar nuestra guía de uso",
    "help.guides.message": "Consulte nuestra guía de uso, que brinda información acerca de todas las secciones de esta plataforma.",
    "help.header": "Ayuda",
    "help.intercom.header": "Chat en vivo",
    "help.intercom.message": "Chatee con nosotros en nuestro horario de atención. Haga clic en la burbuja de diálogo ubicada en la parte inferior izquierda (si no la ve, actualice su navegador).",
    "help.roadmap.title": "Nuestra hoja de ruta actual",
    "hi-in": "Hindi",
    "hide": "Ocultar",
    "hierarchy.turnedOffReason": "WorkTango Hierarchy Heatmap no estará disponible temporalmente a partir del martes 25 de noviembre de 2025 a las 5:00 PM EST mientras realizamos las actualizaciones. El servicio se reanudará inmediatamente una vez completadas las actualizaciones. Disculpen las molestias.",
    "highest.label": "El más alto",
    "hour": "hora",
    "hours": "horas",
    "hu-hu": "Húngaro",
    "id-id": "Indonesia",
    "image.aspect": "La relación de aspecto de la imagen debe ser aproximadamente de {{x}}:{{y}}",
    "importing": "Importando...",
    "in.progress": "En progreso",
    "inbox.header": "Conversaciones",
    "insights.bad": "EL MALO",
    "insights.explainertext.bad": "A continuación, encontrará áreas en las que es necesario mejorar.",
    "insights.explainertext.good": "Hace un buen trabajo en estas áreas y sus empleados lo notan.",
    "insights.explainertext.ugly": "Se requiere atención inmediata en estas áreas.",
    "insights.good": "EL BUENO",
    "insights.ugly": "EL FEO",
    "invalid.email.format": "Hay un error en el formato del correo electrónico. Vuelva a intentarlo",
    "invite.new": "Nueva invitación",
    "invites.pending.delete": "Eliminar invitaciones pendientes",
    "invites.pending.delete.confirm": "¿Desea eliminar estas invitaciones pendientes?",
    "is.platform.user.export.column.name": "Es usuario",
    "it-it": "Italiano",
    "jp-jp": "Japonés",
    "keyFactor": "Factor principal",
    "keyFactors": "Factores principales",
    "keyQuestions": "Preguntas sobre los factores principales",
    "ko-kr": "Coreano",
    "kw.custom.access.not.set.up.check.back.later": "Vuelva más tarde.",
    "kw.custom.access.not.set.up.yet": "Su administrador aún está configurando su acceso y puede ponerse en contacto con él para obtener una actualización del estado.",
    "kw.permission.setup.in.progress": "Configuración de permisos en curso",
    "label.invite.users": "Invitar a nuevos usuarios",
    "label.no.filters": "No se encontraron resultados para los filtros seleccionados. Pruebe con un conjunto diferente de filtros.",
    "language": "Idioma",
    "language.code.desc": "Use el código de idioma de WorkTango correspondiente para la columna Idioma cuando importe nuevos empleados",
    "languageCode": "Código de idiomas",
    "layout.cardview": "Vista de la tarjeta",
    "layout.listview": "Vista de la lista",
    "learning": "Aprendizaje",
    "less.than.an.hour": "menos de una hora",
    "lifecycle.survey.email.access.outbox": "Ir a la bandeja de salida",
    "lifecycle.survey.email.access.outbox.weekly.digest": "Vea a quién se invitará pronto",
    "lifecycle.survey.email.digest.explainer": "Se ha añadido a los siguientes empleados automáticamente a una encuesta de WorkTango",
    "lifecycle.survey.email.digest.subject": "Informe de invitaciones automatizadas a encuestas de la semana pasada",
    "lifecycle.survey.outbox.candidate.was.invited": "El %targetInvitationDate% se invitó a %employeeName% a %surveyName%",
    "lifecycle.survey.outbox.candidate.will.be.invited": "Se invitará a %employeeName% el %targetInvitationDate% a %surveyName%",
    "lifecycle.survey.outbox.employees.added.exit": "Los siguientes empleados han sido identificados como candidatos para una encuesta de salida y se han colocado en la bandeja de salida. Puede consultar la lista completa siguiendo el siguiente enlace.",
    "lifecycle.survey.outbox.employees.added.onboarding": "Los siguientes empleados han sido identificados como candidatos para una encuesta de incorporación y se han colocado en la bandeja de salida. Puede consultar la lista completa siguiendo el siguiente enlace.",
    "lifecycle.survey.outbox.updated.header.exit": "Bandeja de salida de encuesta de salida actualizada",
    "lifecycle.survey.outbox.updated.header.onboarding": "Bandeja de salida de encuesta de incorporación actualizada",
    "lifecycle.survey.outbox.updated.subject.exit": "Bandeja de salida \"de salida\" actualizada",
    "lifecycle.survey.outbox.updated.subject.onboarding": "Bandeja de salida \"de incorporación\" actualizada",
    "lifecycle.survey.weekly.digest.email.header": "Resumen semanal de la encuesta sobre el ciclo de vida",
    "loading": "Cargando... Espere",
    "login.error": "Nombre de usuario o contraseña inválidos",
    "login.expired.desc": "Vuelva a iniciar sesión para acceder a WorkTango.",
    "login.expired.title": "La encuesta finalizó",
    "login.improve.question": "¿Quiere mejorar el compromiso de su organización?",
    "login.instruction.email": "Ingrese su correo electrónico para continuar",
    "login.instruction.password": "Ingrese su contraseña para iniciar sesión",
    "login.migrated.desc.first": "Use",
    "login.migrated.desc.last": "para acceder a WorkTango.",
    "login.migrated.success": "¡Buenas noticias! ¡Su empresa forma ahora parte de la nueva plataforma de WorkTango!",
    "login.sso.failed.desc": "El inicio de sesión a través del SSO de tu empresa no se completó. Ponte en contacto con tu administrador de TI o con el soporte de WorkTango y comparte esta referencia: {{reference}}",
    "lowest.label": "El más bajo",
    "mailing-list.automatic-invitations": "Invitaciones automáticas",
    "mailing-list.automatic-invitations.add-not-contact.modal.confirm-button": "Añadir a la lista",
    "mailing-list.automatic-invitations.add-not-contact.modal.confirm-label": "Motivo de la adición",
    "mailing-list.automatic-invitations.add-not-contact.modal.confirm-placeholder": "Introduzca el motivo por el que se añade este empleado",
    "mailing-list.automatic-invitations.add-not-contact.modal.description": "Al añadir a una persona a esta lista ya no formará parte de ninguna invitación automatizada a encuestas, sin embargo, aún se le podrá invitar de forma manual.",
    "mailing-list.automatic-invitations.add-not-contact.modal.description2": "Si fuera necesario, usted u otro administrador con acceso podrá revertir esta acción accediendo a la lista y eliminándolo de ella posteriormente. Se indicará el motivo de la adición.",
    "mailing-list.automatic-invitations.add-not-contact.modal.title": "¿Añadir a {{user}} a la lista \"No contactar\"?",
    "mailing-list.automatic-invitations.approve-all.modal.confirm-button": "Sí, aprobar todo",
    "mailing-list.automatic-invitations.approve-all.modal.description": "Esta acción aprobará el envío de la invitación a todos los candidatos en su fecha de invitación individual.",
    "mailing-list.automatic-invitations.approve-all.modal.description2": "¿Seguro que desea aprobar estas invitaciones?",
    "mailing-list.automatic-invitations.approve-all.modal.title": "¿Aprobar 1 candidato?",
    "mailing-list.automatic-invitations.approve-all.modal.title-plural": "¿Aprobar {{count}} candidatos?",
    "mailing-list.automatic-invitations.bulk-actions": "Acciones masivas",
    "mailing-list.automatic-invitations.bulk-actions-with-count": "Acciones masivas ({{cuenta}} seleccionadas)",
    "mailing-list.automatic-invitations.bulk-actions.disabled": "Seleccione primero los candidatos para los que desea realizar acciones masivas",
    "mailing-list.automatic-invitations.bulk-add-not-contact.modal.title": "¿Añadir {{count}} usuarios a la lista No Contactar?",
    "mailing-list.automatic-invitations.button.add-to-not-contact": "Añadir a la lista \"No contactar\"",
    "mailing-list.automatic-invitations.button.approve": "Aprobar",
    "mailing-list.automatic-invitations.button.approve-and-invite": "Aprobar e invitar de inmediato",
    "mailing-list.automatic-invitations.button.bulk-approve": "Aprobar seleccionados",
    "mailing-list.automatic-invitations.button.bulk-approve-and-invite": "Aprobado seleccionado e invitar inmediatamente ",
    "mailing-list.automatic-invitations.button.bulk-remove": "Eliminar de la lista",
    "mailing-list.automatic-invitations.button.invite": "Invitar de inmediato",
    "mailing-list.automatic-invitations.button.remove": "Eliminar de la lista",
    "mailing-list.automatic-invitations.button.undo-approval": "Deshacer aprobación",
    "mailing-list.automatic-invitations.column.addedToList": "Añadido a la lista",
    "mailing-list.automatic-invitations.column.candidateName": "Nombre del candidato",
    "mailing-list.automatic-invitations.column.exitDate": "Fecha de salida",
    "mailing-list.automatic-invitations.column.startDate": "Fecha de inicio",
    "mailing-list.automatic-invitations.column.status": "Estado",
    "mailing-list.automatic-invitations.column.surveyName": "Nombre de la encuesta",
    "mailing-list.automatic-invitations.column.targetInvitationDate": "Fecha de invitación prevista",
    "mailing-list.automatic-invitations.onboarding-survey.description": "El sistema identifica a los siguientes empleados a los que se invitará a completar su encuesta en la fecha prevista.",
    "mailing-list.automatic-invitations.onboarding-survey.description2": "Revise la lista y elimine a cualquier persona que no desee que reciba una invitación o muévala a la lista \"No contactar\" si desea posponer la invitación de forma indefinida.",
    "mailing-list.automatic-invitations.onboarding-survey.filter-candidates": "Filtrar candidatos",
    "mailing-list.automatic-invitations.onboarding-survey.filter-surveys": "Filtrar encuestas",
    "mailing-list.automatic-invitations.onboarding-survey.title": "Candidatos a la encuesta",
    "mailing-list.automatic-invitations.snackbar.add-to-not-contact": "Persona añadida correctamente a la lista \"No contactar\"",
    "mailing-list.automatic-invitations.snackbar.approve": "Estado actualizado correctamente",
    "mailing-list.automatic-invitations.snackbar.approve-all": "Invitaciones aprobadas correctamente",
    "mailing-list.automatic-invitations.snackbar.error": "Se ha producido un error al añadir a esta persona a la encuesta. Actualice la pantalla e inténtelo de nuevo.",
    "mailing-list.automatic-invitations.snackbar.invite": "Invitación enviada correctamente",
    "mailing-list.automatic-invitations.snackbar.remove": "Persona eliminada correctamente",
    "mailing-list.automatic-invitations.table.no-data": "No hay ningún candidato que coincida con sus filtros.",
    "mailing-list.automatic-invitations.tooltip.approved": "Ha optado por no aprobar las invitaciones manualmente y hacer que se envíen automáticamente al día siguiente de añadir al empleado. Si desea cambiar esta configuración, vaya a los ajustes de Automatización de encuestas de empresa.",
    "mailing-list.automatic-invitations.trigger-type.exit": "Solo encuestas de salida",
    "mailing-list.automatic-invitations.trigger-type.onboarding": "Solo encuestas de incorporación",
    "mailing-list.blocked-recipients": "Destinatarios bloqueados",
    "mailing-list.do-not-contact": "No contactar",
    "mailing-list.title": "Gestión de listas de correo",
    "message.deleteSurveyWarning": "¿Está seguro de que desea eliminar esta encuesta?",
    "message.stopSurveyWarning": "¿Está seguro de que desea cancelar el envío de esta encuesta?",
    "minute": "minuto",
    "minutes": "minutos",
    "month": "Meses",
    "ms-my": "Malayo (latín)",
    "my-mm": "Birmano",
    "nav.leave.surveys.and.insights": "Salir de encuestas e información",
    "nav.sidebar.title.surveys.and.insights": "Encuestas e información",
    "nb-no": "Noruego Bokmål",
    "next": "Siguiente",
    "nl-nl": "Neerlandés",
    "no.base.survey.type": "Desconocido",
    "no.common.questions": "No hay preguntas comunes en las encuestas seleccionadas.",
    "no.conversations": "No existen conversaciones en este momento.",
    "no.employee": "No se encontró ningún empleado",
    "no.libraryActions": "No hay acciones de biblioteca.",
    "no.reminders": "Actualmente no hay recordatorios programados para esta encuesta",
    "no.reponseRate.text": "No hay respuestas aún o no son suficientes según el umbral de confidencialidad establecido. Vuelva a consultar más tarde.",
    "no.results.filter": "No hay resultados para los filtros seleccionados",
    "no.suggestions.description": "Lo sentimos. No tenemos acciones recomendadas para las encuestas o los filtros que está viendo en estos momentos.",
    "no.survey.instructions": "Ajuste el conjunto de datos para analizar los resultados",
    "no.survey.text": "Seleccione un tipo de encuesta",
    "no.surveyData.text": "No existen datos cuantitativos para las encuestas seleccionadas o no hay suficientes respuestas disponibles según el umbral de confidencialidad establecido. Vuelva a consultar más tarde.",
    "no.trend.text": "Seleccionar más de una encuesta para visualizar los resultados de la tendencia.",
    "noAttributeValues": "No se encontraron valores para este atributo",
    "noCanvasSupport": "El navegador no admite el elemento canvas. No se puede mostrar el gráfico de barras.",
    "note.survey.question.active.between": "Nota: Esta pregunta estaba activa de {{added-date}} a {{discontinued-date}}",
    "note.survey.question.added": "Nota: Esta pregunta se introdujo por primera vez en {{added-date}}",
    "note.survey.question.discontinued": "Nota: Esta pregunta se interrumpió el {{discontinued-date}}",
    "notice.leave.title": "¿Confirmas que deseas salir?",
    "notifications.current.password.incorrect": "La contraseña actual proporcionada es incorrecta.",
    "notifications.message.actionCreated": "Se creó correctamente la acción",
    "notifications.message.actionRemoved": "Se eliminó correctamente la acción",
    "notifications.message.actionUpdated": "Se actualizó correctamente la acción",
    "notifications.message.categoryCreated": "Se creó correctamente el factor",
    "notifications.message.categoryRemoved": "Se eliminó correctamente el factor",
    "notifications.message.categoryUpdated": "Se actualizó correctamente el factor",
    "notifications.message.companyDeleted": "Se eliminaron la empresa y los datos relacionados",
    "notifications.message.companyUpdated": "Se actualizó correctamente la empresa",
    "notifications.message.employeeCreated": "Empleado creado con éxito",
    "notifications.message.employeeUpdates": "Empleada actualizada con éxito",
    "notifications.message.surveyTypeCreated": "Se creó correctamente el tipo de encuesta",
    "notifications.message.surveyTypeUpdated": "Se actualizó correctamente el tipo de encuesta",
    "notifications.message.templateCreated": "Se creó correctamente la acción de biblioteca",
    "notifications.message.templateRemoved": "Se eliminó correctamente la acción de biblioteca",
    "notifications.message.templateUpdated": "Se actualizó correctamente la acción de biblioteca",
    "notifications.message.userPermissionsUpdated": "Permisos de usuario actualizados con éxito",
    "notifications.profile.updateSuccessful": "Se actualizó correctamente el perfil.",
    "notifications.title.done": "Listo",
    "notifications.title.newAction": "Nueva acción",
    "notifications.title.survey-migration": "Migración de datos iniciada",
    "nps.delta": "Puntaje eNPS",
    "on": "El",
    "oops.something.went.wrong": "Lo sentimos. Se ha producido un error.",
    "openEnded": "PREGUNTA ABIERTA",
    "origin.source": "Fuente",
    "overview.aboveOrgWide": "Puntaje por encima de la media de toda la organización",
    "overview.anonymized": "Anónimo",
    "overview.attributeAnonymized": "No hay suficientes respuestas disponibles para alcanzar el umbral de anonimato establecido",
    "overview.attributeBetterOrg": "Los atributos primarios registran un rendimiento superior al registrado en toda la organización",
    "overview.attributeCantDisplay": "No se pueden mostrar los atributos primarios",
    "overview.attributeDecrease": "Atributos primarios con las mayores disminuciones",
    "overview.attributeIncrease": "Atributos primarios con los mayores incrementos",
    "overview.attributeWorseOrg": "Los atributos primarios registran un rendimiento inferior al registrado en toda la organización",
    "overview.belowOrgWide": "Puntaje por debajo de la media de toda la organización",
    "overview.bottom25org": "¡Este {{name}} se posiciona dentro del rango del 25% inferior de la organización!",
    "overview.compareToEmpty": "No se aplica el Valor Comparado con la última encuesta",
    "overview.emptyPage": "No existen datos cuantitativos para las encuestas seleccionadas o no hay suficientes respuestas disponibles según el umbral de confidencialidad establecido. Vuelva a consultar más tarde.",
    "overview.enps": "Los puntajes de eNPS van de -100 a 100",
    "overview.factorSummary": "Resumen del factor",
    "overview.from": "de",
    "overview.highlights": "Destacados",
    "overview.label": "Resumen",
    "overview.lastMeasured": "Desde la última encuesta",
    "overview.lastSurvey": "última encuesta",
    "overview.noLastSurvey": "¡Ánimo! Es la primera encuesta de este tipo, por lo que no verás ningún tipo de información comparativa respecto de puntajes anteriores.",
    "overview.noPreviousSurvey": "No hay encuesta anterior con la que se pueda realizar la comparación",
    "overview.orgDifferEnabled": "¡Ánimo! Los puntajes comprendidos dentro del 25% superior y el 25% inferior solo están disponibles para que los puedan consultar los líderes sin aplicar ningún otro filtro. Agregamos información útil adicional como reemplazo.",
    "overview.orgRankDisabled": "¡Ánimo! Utilice filtros para realizar la comparación de los datos en toda la organización; filtre líderes específicos para ver las estadísticas con el 25% superior y el 25% inferior.",
    "overview.orgWideBottom": "Puntajes dentro del rango del 25% inferior en toda la organización",
    "overview.orgWideEmpty": "No se aplica el Valor comparado con toda la organización",
    "overview.orgWideIsSame": "El puntaje es igual al de toda la organización",
    "overview.orgWideTop": "Puntajes dentro del rango del 25% superior en toda la organización",
    "overview.orgwideCompare": "Comparado con toda la organización",
    "overview.permissionGroup": "Según su acceso, los siguientes grupos forman parte de los resultados: {{label}}",
    "overview.questionSummary": "Resumen de preguntas",
    "overview.responseRate": "Tasa de respuesta",
    "overview.scoreDecrease": "Se redujo significativamente este puntaje",
    "overview.scoreDifferDisabled": "¡Ánimo! No podemos mostrarle los datos comparativos de encuestas anteriores si se consultan datos de varias encuestas.",
    "overview.scoreHugeDecrease": "Disminución considerable en el puntaje",
    "overview.scoreHugeIncrease": "Aumento considerable en el puntaje",
    "overview.scoreIncrease": "Aumentó significativamente este puntaje",
    "overview.scoreIsSame": "No se produjo ningún cambio en el puntaje desde la última medición",
    "overview.seeAllFactors": "Ver todos los factores",
    "overview.seeAllQuestions": "Ver todas las preguntas",
    "overview.seeAllScores": "Ver todos los detalles de los puntajes",
    "overview.since": "desde",
    "overview.top25Org": "¡Este {{name}} se posiciona dentro del rango del 25% superior de la organización!",
    "overview.vsOrgWide": "en comparación con el promedio de toda la organización",
    "participants-dialog.cancel": "Cancelar",
    "participants-dialog.column.employee": "Empleado",
    "participants-dialog.column.invited-date": "Fecha de invitación",
    "participants-dialog.column.submitted-date": "Fecha de envío",
    "participants-dialog.confirm": "mostrar sólo las respuestas de esta persona",
    "participants-dialog.not.yet.invited": "",
    "participants-dialog.not.yet.submitted": "No presentado",
    "participants-dialog.search.placeholder": "Filtrar participantes",
    "participants-dialog.title": "Seleccionar participante en la encuesta",
    "participants.actions": "Acciones",
    "participants.actions.removeFromList": "Eliminar de la lista",
    "participants.actions.resend": "Reenviar invitación",
    "participants.actions.revoke": "Revocar el acceso y eliminar datos",
    "participants.addButton": "AÑADIR PARTICIPANTES...",
    "participants.channel.failed": "",
    "participants.channel.name.email": "",
    "participants.channel.name.sms": "",
    "participants.channel.none": "",
    "participants.channel.pending": "",
    "participants.channel.sent": "",
    "participants.channel.sms.noPhone": "",
    "participants.channel.sms.optedOut": "",
    "participants.chip.addedNotInvited": "",
    "participants.chip.alreadyInvited": "YA INVITADO",
    "participants.chip.deactivated": "DESACTIVADO",
    "participants.chip.invited": "Invitado el {{date}}",
    "participants.chip.notInvited": "AÚN NO ESTÁ INVITADO",
    "participants.chip.onTheList": "EN LA LISTA",
    "participants.emptyFilter": "Ningún participante coincide con los filtros actuales.",
    "participants.emptyState": "No hay destinatarios seleccionados para esta encuesta.",
    "participants.filter.search": "Filtrar por nombre, correo electrónico o ID de participante",
    "participants.filter.status": "Filtrar por estado del participante",
    "participants.filter.status.all": "Todos los estados",
    "participants.filter.status.invited": "Invitación recibida",
    "participants.filter.status.notInvited": "Aún no está invitado",
    "participants.groupAction": "Acción de grupo para {{count}} seleccionado",
    "participants.groupAction.all": "Todos los participantes",
    "participants.groupAction.invited": "Empleados que ya participan",
    "participants.groupAction.notInvited": "Empleados aún no invitados",
    "participants.groupAction.remove": "Eliminar de la lista de participantes",
    "participants.groupAction.resend": "Reenviar invitaciones",
    "participants.groupAction.revoke": "Revocar el acceso y eliminar datos",
    "participants.groupAction.unselectAll": "Deseleccionar todo",
    "participants.modal.disabledCheckbox": "La casilla deshabilitada significa que el empleado ya está participando en la encuesta",
    "participants.modal.disabledRowTooltip": "No puede eliminar de la lista a los empleados ya invitados. Si ha sido invitado por error, revoque su acceso y elimine los datos de la encuesta de la lista de participantes.\nnTenga en cuenta que los empleados invitados no reciben otro correo electrónico de invitación cada vez que añade más destinatarios.",
    "participants.modal.email": "Correo electrónico",
    "participants.modal.employeeId": "ID",
    "participants.modal.employeeList": "Lista de empleados",
    "participants.modal.employeeName": "Nombre del empleado",
    "participants.modal.filterByAttribute": "Filtrar por atributo",
    "participants.modal.filterByDate": "Filtrar por fecha",
    "participants.modal.filterByDate.add": "AÑADIR FILTRO DE FECHA DE INICIO",
    "participants.modal.filterByDate.after": "Después de la fecha",
    "participants.modal.filterByDate.before": "Antes de la fecha",
    "participants.modal.filterByDate.beforeIncluding": "Antes de la fecha",
    "participants.modal.filterByDate.between": "Entre dos fechas",
    "participants.modal.filterByDate.custom": "Fecha personalizada o intervalo de fechas...",
    "participants.modal.filterByDate.includingAndAfter": "Incluida la fecha y después",
    "participants.modal.filterByDate.label": "La fecha de inicio del empleado es...",
    "participants.modal.filterByDate.lastWeek": "La semana pasada",
    "participants.modal.filterByDate.notBetween": "No entre dos fechas",
    "participants.modal.filterByDate.notOn": "No en la fecha",
    "participants.modal.filterByDate.onExact": "En la fecha exacta",
    "participants.modal.filterByDate.remove": "Quitar filtro",
    "participants.modal.filterByDate.select": "Seleccione...",
    "participants.modal.filterByDate.shortcuts": "Atajos",
    "participants.modal.filterByDate.sinceYesterday": "Desde ayer",
    "participants.modal.filterByDate.thisMonth": "Este mes",
    "participants.modal.filterByDate.thisWeek": "Esta semana",
    "participants.modal.filterByEmployee": "Filtrar por empleado",
    "participants.modal.filterByEmployee.placeholder": "Introduzca su nombre, correo electrónico o ID",
    "participants.modal.filterByEmployee.remove": "Quitar filtro",
    "participants.modal.filterSubtitle": "La lista de empleados responderá a todos los filtros seleccionados",
    "participants.modal.filterTitle": "Filtrar la lista de empleados",
    "participants.modal.newParticipants_one": "{{cuenta}} nuevo participante",
    "participants.modal.newParticipants_other": "{{count}} nuevos participantes",
    "participants.modal.removed": "{{count}} eliminado",
    "participants.modal.save": "GUARDAR",
    "participants.modal.saveWith": "GUARDAR CON {{detalles}}",
    "participants.modal.selectAll": "SELECCIONAR TODO",
    "participants.modal.title": "Añadir participantes de la lista de empleados",
    "participants.modal.unselectAll": "DESELECCIONAR TODO",
    "participants.revoke.confirm.body.multiple": "Al eliminar participantes se revocará su invitación y acceso a la encuesta, y se eliminarán sus datos de la encuesta, en caso de que ya los hubieran enviado. Esta acción no se puede deshacer.\\NPodrás invitarles de nuevo a la encuesta, pero sus datos se borrarán.\\N¿Estás seguro de que quieres eliminar a estos participantes?",
    "participants.revoke.confirm.body.single": "Al eliminar participantes se revocará su invitación y acceso a la encuesta, y se eliminarán sus datos de la encuesta, en caso de que ya los hubieran enviado. Esta acción no se puede deshacer.\nPodrás volver a invitarles a la encuesta, pero sus datos se borrarán.\n¿Estás seguro de que quieres eliminar a este participante?",
    "participants.revoke.confirm.button.multiple": "SI, ELIMINA TODO {{count}}",
    "participants.revoke.confirm.button.single": "SÍ, ELIMINAR",
    "participants.revoke.confirm.title.multiple": "¿Quitar {{count}} participantes?",
    "participants.revoke.confirm.title.single": "Eliminar participante {{firstName}} {{lastName}}?",
    "participants.revoke.success.multiple": "Participantes eliminados con éxito",
    "participants.revoke.success.single": "Participante eliminado con éxito",
    "participants.table.email": "Correo electrónico",
    "participants.table.invitationChannel": "",
    "participants.table.name": "Nombre",
    "participants.table.status": "Estado",
    "participants.unsavedChanges": "Tiene cambios sin guardar en la lista de participantes. Asegúrese de guardarlos antes de salir de esta pantalla.",
    "passive": "Neutro",
    "passive.2": "Pasivo",
    "password.reset.email": "Alguien solicitó un enlace para restablecer la contraseña de la plataforma de WorkTango.",
    "password.reset.error": "Este enlace para restablecer la contraseña es inválido, venció o ya se utilizó una vez.",
    "password.strength.tooltip": "Se comparó la contraseña con una biblioteca de más de 30.000 contraseñas, nombre y apellidos, palabras comunes en inglés de Wikipedia, la televisión estadounidense y películas, y otros patrones habituales como, por ejemplo, fechas, repeticiones (aaa), secuencias (abcde), patrones de teclado ((qwertyuiop) y lenguaje \"leet\" (p4ssw0rd).",
    "pending": "Pendiente",
    "people": "personas",
    "percentage": "Porcentaje",
    "permission.accessAiAssistant": "Usuario",
    "permission.aiAssistant": "Entrenador WorkTango",
    "permission.aiAssistantPermissionLevel": "WorkTango Coach Nivel de permiso",
    "permission.manageActionsForAll": "Planificación de acciones: todos los usuarios",
    "permission.manageActionsUnderHierarchy": "Planificación de acciones: solo jerarquía",
    "permission.manageAiAssistant": "Administrador",
    "permission.manageCompany": "Configuración de la empresa",
    "permission.manageEmployees": "Administrar empleados",
    "permission.manageUsers": "Administrar usuarios",
    "permission.manageUsersAndEmployees": "Usuarios y empleados",
    "permission.receivesSummaryEmail": "WorkTango Coach: Resumen de la encuesta posterior",
    "permission.task.attributes": "También acciones de vistas y directivos para los siguientes atributos:",
    "permission.task.main": "Ver y administrar acciones para:",
    "permission.task.self": "Solo ellos",
    "permissions.canFilterSurveyComments": "",
    "permissions.canManageSurveys": "Administrar encuestas ",
    "permissions.canSeeComments": "Ver comentarios",
    "permissions.canSeeConversations": "Conversaciones anónimas",
    "permissions.canSeeInProgressResults": "",
    "permissions.canSeeReporting": "Ver informes",
    "permissions.canUpdateCommentSentiment": "Actualizar opinión de comentario",
    "permissions.canViewBenchmarks": "Ver puntos de referencia",
    "permissions.loading.hierarchy": "Cargando jerarquías..",
    "person": "persona",
    "picker.noOption": "No hay opciones disponibles",
    "pl-pl": "Polaco",
    "positive.sentiment": "Opinión positiva",
    "ppt.questions.breakdown": "Pregunta(s) Desglose",
    "ppt.score": "Puntaje",
    "presentaionExport.spreadChart.favorable": "Favorable",
    "presentaionExport.spreadChart.neutral": "Neutro",
    "presentaionExport.spreadChart.unfavorable": "Desfavorable",
    "presentationExport.appendix": "Apéndice",
    "presentationExport.appendix.allQuestionsSlide.title": "Todas las preguntas cuantitativas",
    "presentationExport.appendix.breakdown": "Desglose",
    "presentationExport.attributeDisclaimer": "Solo se muestra a los encuestados con las siguientes condiciones de atributos:",
    "presentationExport.bottomFiveQuestions": "Las últimas cinco preguntas",
    "presentationExport.compareType.attribute": "Comparado con el atributo de comparación\n",
    "presentationExport.compareType.organization": "Comparado con toda la organización",
    "presentationExport.compareType.survey": "Comparado con la encuesta de comparación",
    "presentationExport.comparedWith": "Comparado con",
    "presentationExport.comparisonAttributes": "Atributos de comparación",
    "presentationExport.comparisonSurveys": "Encuestas de comparación",
    "presentationExport.confidential": "Registrado y confidencial. © 2021 WorkTango Inc.",
    "presentationExport.dropdownQuestionSlide.title": "Preguntas con opciones desplegables",
    "presentationExport.enps": "eNPS",
    "presentationExport.enpsSlide.description.compareValue.comparisonAttribute": "cambio comparado con atributo de comparación",
    "presentationExport.enpsSlide.description.compareValue.comparisonSurvey": "cambio comparado con encuesta de comparación",
    "presentationExport.enpsSlide.description.compareValue.orgWide": "cambio comparado con toda la organización",
    "presentationExport.enpsSlide.description.compareValue.timeframe": "Cambio frente a plazo",
    "presentationExport.enpsSlide.detractors": "Detractores",
    "presentationExport.enpsSlide.detractorsDescription": "empleados que son ”detractores”",
    "presentationExport.enpsSlide.employeeBreakdown": "Desglose de empleados",
    "presentationExport.enpsSlide.enpsDescription": "El indicador \"Employee Net Promoter Score\" (eNPS) proporciona una métrica general que establece el compromiso del empleado, ya que mide su predisposición a recomendar su lugar de trabajo a sus propios amigos o miembros de su familia.",
    "presentationExport.enpsSlide.enpsFormula": "*El eNPS se calcula restando la proporción de detractores de la proporción de promotores",
    "presentationExport.enpsSlide.passives": "Pasivos",
    "presentationExport.enpsSlide.promoters": "Promotores",
    "presentationExport.enpsSlide.promotersDescription": "empleados que son ”promotores”",
    "presentationExport.factorsSlide.byFactor": "Por factor",
    "presentationExport.factorsSlide.keyFactors": "Factores principales",
    "presentationExport.factorsSlide.otherFactors": "Factores",
    "presentationExport.filters": "Filtros",
    "presentationExport.mcqSlide.title": "Preguntas de opciones múltiples",
    "presentationExport.openEndedCommentsSlide.frequency": "Frecuencia",
    "presentationExport.openEndedCommentsSlide.keyword": "Palabra clave",
    "presentationExport.openEndedCommentsSlide.majoritySentiment": "Opinión mayoritaria",
    "presentationExport.openEndedCommentsSlide.respondents": "encuestados",
    "presentationExport.openEndedCommentsSlide.sentimentDescription": "*Nota: Las opiniones reflejan palabras clave con comentarios mayormente positivos, neutros o negativos que determinan el motor de procesamiento de lenguajes naturales (NLP) de Amazon; visite la plataforma de WorkTango para consultar las opiniones y los comentarios detallados para cada comentario.​",
    "presentationExport.openEndedCommentsSlide.title": "Comentarios abiertos",
    "presentationExport.overallFindings": "Resultados generales",
    "presentationExport.question": "Pregunta:",
    "presentationExport.questionThemes": "Temas de las preguntas",
    "presentationExport.resultsSlide.factorCompareAttr": "Diferencia de porcentaje del siguiente factor cuando se realiza la comparación con los atributos seleccionados",
    "presentationExport.resultsSlide.factorCompareOrgWide": "Diferencia de porcentaje del siguiente factor cuando se realiza la comparación con toda la organización",
    "presentationExport.resultsSlide.factorCompareSurvey": "Diferencia de porcentaje del siguiente factor cuando se realiza la comparación con las encuestas de comparación",
    "presentationExport.resultsSlide.factorCompareTimeframe": "Diferencia porcentual del factor anterior al comparar los plazos",
    "presentationExport.resultsSlide.highestFactor": "Factor con mayor puntaje",
    "presentationExport.resultsSlide.highestQuestion": "Pregunta con mayor puntaje",
    "presentationExport.resultsSlide.keyResults": "Resultados clave",
    "presentationExport.resultsSlide.lowestFactor": "Factor con menor puntaje",
    "presentationExport.resultsSlide.lowestQuestion": "Pregunta con menor puntaje",
    "presentationExport.resultsSlide.questionCompareAttr": "Diferencia de porcentaje para la siguiente pregunta cuando se realiza la comparación con los atributos seleccionados",
    "presentationExport.resultsSlide.questionCompareOrgWide": "Diferencia de porcentaje para la siguiente pregunta cuando se realiza la comparación con toda la organización",
    "presentationExport.resultsSlide.questionCompareSurvey": "Diferencia de porcentaje para la siguiente pregunta cuando se realiza la comparación con la encuesta de comparación",
    "presentationExport.resultsSlide.questionCompareTimeframe": "Diferencia porcentual del factor anterior al comparar los plazos",
    "presentationExport.resultsSlide.respondents": "Empleados que respondieron",
    "presentationExport.resultsSlide.responseRate": "Tasa de respuesta",
    "presentationExport.resultsSlide.responseRateCompareAttr": "Diferencia de porcentaje en la tasa de respuesta\nde los atributos de comparación",
    "presentationExport.resultsSlide.responseRateCompareOrgWide": "Diferencia de porcentaje en la tasa de respuesta\nen toda la organización",
    "presentationExport.resultsSlide.responseRateCompareSurvey": "Diferencia de porcentaje en la tasa de respuesta\nde la encuesta de comparación",
    "presentationExport.resultsSlide.responseRateCompareTimeframe": "Diferencia porcentual con respecto al plazo de respuesta comparado",
    "presentationExport.resultsSlide.responseRate_plural": "Tasas de respuesta",
    "presentationExport.resultsSlide.title": "Resumen de resultados",
    "presentationExport.summaryGeneratedWithResponses": "Este resumen fue generado por IA analizando {{responses}} respuestas.",
    "presentationExport.title.report-timeframe": "Calendario del informe",
    "presentationExport.title.report-timeframe.empty": "Sin plazo seleccionado",
    "presentationExport.topFiveQuestions": "Las primeras cinco preguntas",
    "presentationExport.yesNoQuestionSlide.title": "Preguntas por sí o por no",
    "privacy.notice": "Aviso de privacidad",
    "privacy.policy": "Política de privacidad",
    "profile.avatar": "Avatar",
    "profile.avatarErrorSize": "Tamaño de archivo inválido de {{fileSize}} KB. Máximo {{maxFileSize}} KB.",
    "profile.avatarErrorType": "Archivo de imagen no válido.",
    "profile.confirmPassword": "Confirmar contraseña",
    "profile.currentpassword": "Contraseña actual",
    "profile.fname": "Nombres",
    "profile.lname": "Apellidos",
    "profile.newpassword": "Nueva contraseña",
    "profile.password": "Contraseña",
    "profile.picture": "Imagen de perfil",
    "profile.saved": "Guardado",
    "profile.selectLanguage": "Seleccionar idioma",
    "profile.updateSuccessful": "Se actualizó correctamente el perfil.",
    "promoter.2": "Promotor",
    "pt-br": "Portugués",
    "pt-pt": "Portugués (PT)",
    "published": "Publicado",
    "question.add-to-library": "Añadir a la biblioteca",
    "question.cannotDiscontinue": "Esta pregunta no se puede interrumpir porque forma parte de la lógica de la pregunta. Por favor, desasocie la pregunta en el editor de lógica y, a continuación, interrúmpala.",
    "question.cannotDiscontinue.title": "Esta pregunta no puede interrumpirse",
    "question.confirmDiscontinue": "Sí, suspender",
    "question.delete": "Eliminar",
    "question.discontinue": "Pregunta sobre la interrupción",
    "question.discontinueDesc": "Al confirmar esta acción eliminará irreversiblemente esta pregunta de la encuesta. Todos los informes seguirán estando disponibles para ella. ¿Está seguro de que desea proceder con este cambio?",
    "question.discontinueThisQuestion": "¿Descartar esta pregunta?",
    "question.discontinuingQuestion": "Interrumpiendo la pregunta...",
    "question.duplicate": "Duplicar",
    "question.issue.attrEmpty": "Seleccione los valores del atributo",
    "question.issue.attributeFilterEmpty": "Selecciona un atributo para el filtro de atributo",
    "question.issue.categoryEmpty": "Se debe seleccionar el factor",
    "question.issue.descEmpty": "Ingrese la descripción de la pregunta para todos los idiomas",
    "question.issue.isPrevious": "No se puede editar una pregunta de tendencia",
    "question.issue.leftEmpty": "Ingrese la etiqueta izquierda para todos los idiomas",
    "question.issue.openSurveyAttributeNameEmpty": "",
    "question.issue.optionsEmpty": "Ingrese las opciones de contenido para todos los idiomas",
    "question.issue.questionFilterLabelEmpty": "Introduce una etiqueta para el filtro de pregunta",
    "question.issue.rightEmpty": "Ingrese la etiqueta derecha para todos los idiomas",
    "question.issue.titleEmpty": "Ingrese el título de la pregunta para todos los idiomas",
    "question.lock.attributeBased": "Se requiere que todos los empleados accedan para editar la pregunta basada en atributos",
    "question.locked": "Esta pregunta no puede editarse porque se trata ahora de una pregunta de tendencia. Si desea hacerlo, puede duplicar la pregunta y editar la versión duplicada.",
    "question.multiple.error": "Cambia \"Selecciones permitidas\" a 2 o más para continuar.",
    "question.order": "Arrastrar",
    "question.remove-from-library": "Eliminar de la biblioteca",
    "question.saved.success": "Pregunta guardada correctamente.",
    "question.showDiscontinued": "Mostrar preguntas discontinuas ({{count}})",
    "question.toast.success.discontinue": "Éxito La pregunta ya no se realizará en esta encuesta.",
    "question.upload": "Agregar a la biblioteca de preguntas",
    "question.uploaded": "Esta pregunta está disponible en la biblioteca. Haga clic para eliminarla",
    "questionExport.Description": "Descripción",
    "questionExport.FactorName": "Factor",
    "questionExport.Question": "Pregunta",
    "questionExport.benchmarkedQuestion": "Pregunta comparada",
    "questionExport.commentsTurnedOn": "¿están activados los comentarios?",
    "questionExport.isBenchmarked": "Se ha comparado",
    "questionExport.isConditionalOnAttribute": "¿Se muestra condicionalmente en función de un atributo?",
    "questionExport.isConditionalOnPreviousQuestion": "¿Se muestra condicionalmente en función de una pregunta previa?",
    "questionExport.isQuestionRequired": "¿se requiere respuesta?",
    "questionExport.isTrend": "¿seguirá la pregunta la tendencia de otras encuestas?",
    "questionExport.questionNumber": "N.° de pregunta",
    "questionExport.questionType": "Tipo de pregunta",
    "questionExport.responseOptions": "Opciones de respuesta",
    "questions": "Preguntas",
    "questions.none": "Agregue la primera pregunta",
    "questions.none.message": "Haga clic en el botón \"+\" para agregar una pregunta a esta encuesta.",
    "questions.select.attributesAndValue": "Seleccionar campo y valor",
    "recipients": "Destinatarios",
    "recipients.added_one": "añadir {{cuenta}} nuevo participante",
    "recipients.added_other": "añadir {{cuenta}} nuevos participantes",
    "recipients.all": "Todos los empleados",
    "recipients.change-confirmation": "¿Estás seguro de que quieres proceder con este cambio?",
    "recipients.changed.dialog.button.confirm": "Confirmar cambio",
    "recipients.changed.dialog.title": "Resumen actualizado de los participantes en la encuesta",
    "recipients.description.added": "Al confirmar esta actualización se <0>{{addedText}}</0>, y enviarles un correo electrónico de invitación a la encuesta.",
    "recipients.description.both": "Al confirmar esta actualización se <0>{{addedText}}</0>, y <0>{removedText}}</0>. Los participantes añadidos recibirán un correo electrónico de invitación.",
    "recipients.description.removed": "Al confirmar esta actualización usted <0>{{removedText}}</0>. ",
    "recipients.removed-warning": "El acceso a la encuesta de los participantes eliminados dejará de ser válido y <0>se borrarán todas sus respuestas enviadas.</0>",
    "recipients.removed_one": "eliminar {{count}} participante existente",
    "recipients.removed_other": "eliminar {{count}} participantes existentes",
    "reminder.schedule.already.sending.error": "Se están enviando en estos momento las invitaciones para esta encuesta. ¿Ya se programó algún recordatorio?",
    "reminder.title.date.time": "Fecha y hora del recordatorio",
    "reminder.title.status": "Estado",
    "reminders.invitation-time.tooltip": "Esto ocurre cuando tus recordatorios entran en la cola de envío, no necesariamente cuando los destinatarios los reciben. Ten en cuenta que la entrega puede tardar hasta 3 horas después de que comience el plazo para mantener los estándares de entrega de correo electrónico.",
    "remove.all.compare.attributes": "Esta acción eliminará todos los atributos comparables personalizados.",
    "remove.all.custom.response.attributes": "Esta acción eliminará todos los atributos de datos de respuesta personalizados.",
    "remove.all.filter.attributes": "Esta acción eliminará todos los atributos de filtrado personalizados.",
    "remove.all.other.hierarchies": "Esta acción eliminará a todos los responsables de personal seleccionados.",
    "reporting.compare.withFilterNotice": "También se filtraron los datos comparativos con los filtros aplicados",
    "reporting.compare.withoutFilterNotice": "Los datos comparativos no se filtraron con los filtros aplicados",
    "reporting.export.fullResponses": "Resultados (individual)",
    "reporting.export.raw-export": "Exportación de los datos sin procesar de la encuesta",
    "reporting.filter.or": "o",
    "reporting.nonRespondents": "No encuestados",
    "reporting.outOf": "de",
    "reporting.participant.filter.reset.button": "informe de reinicio a todos los participantes",
    "reporting.participant.filter.select.button": "seleccione un participante...",
    "reporting.participant.filter.selectAnother.button": "seleccione otro participante...",
    "reporting.participant.filter.selected": "El informe se limita a <0>respuestas enviadas por {{name}}</0>",
    "reporting.responded": "respondido",
    "reporting.respondents": "Encuestados",
    "reporting.timeframeCompare.dialog.aMonthPriorToReport": "Un mes antes del informe",
    "reporting.timeframeCompare.dialog.aWeekPriorToReport": "Una semana antes del informe",
    "reporting.timeframeCompare.dialog.custom": "Calendario personalizado",
    "reporting.timeframeCompare.dialog.description1": "Esta acción elegirá un marco temporal diferente para comparar los datos con el marco temporal del Informe",
    "reporting.timeframeCompare.dialog.description2": "Comparar con la selección de plazos",
    "reporting.timeframeCompare.dialog.quarterPriorToReport": "Trimestre anterior al informe",
    "reporting.timeframeCompare.dialog.samePeriodLastYear": "Mismo periodo del año anterior",
    "reporting.timeframeCompare.dialog.threeMonthsPriorToReport": "3 meses antes del informe",
    "reporting.timeframeCompare.dialog.title": "Seleccione Comparar con plazo",
    "reporting.timeframeCompare.option.aMonthPriorToReport": "Un mes antes del informe",
    "reporting.timeframeCompare.option.aWeekPriorToReport": "Una semana antes del informe",
    "reporting.timeframeCompare.option.custom": "Calendario personalizado",
    "reporting.timeframeCompare.option.quarterPriorToReport": "Trimestre anterior al informe",
    "reporting.timeframeCompare.option.samePeriodLastYear": "Mismo periodo del año anterior",
    "reporting.timeframeCompare.option.threeMonthsPriorToReport": "3 meses antes del informe",
    "reporting.timeframeFilter.button": "Cambiar plazo...",
    "reporting.timeframeFilter.dialog.description1": "Esta acción limitará el informe para considerar sólo las respuestas enviadas en el plazo seleccionado.",
    "reporting.timeframeFilter.dialog.description2": "Selección del plazo del informe",
    "reporting.timeframeFilter.dialog.filterLabel": "Calendario seleccionado",
    "reporting.timeframeFilter.dialog.title": "Cambiar el plazo del informe",
    "reporting.timeframeFilter.label": "El plazo del informe se limita a",
    "reporting.timeframeFilter.option.AllTime": "Todos los tiempos",
    "reporting.timeframeFilter.option.Custom": "A medida",
    "reporting.timeframeFilter.option.Last30Days": "Últimos 30 días",
    "reporting.timeframeFilter.option.Last7Days": "Últimos 7 días",
    "reporting.timeframeFilter.option.Last90Days": "Últimos 90 días",
    "reporting.timeframeFilter.option.PreviousQuarter": "Trimestre anterior",
    "reporting.timeframeFilter.option.SinceBeginningOfYear": "Desde principios de año",
    "reporting.timeframeFilter.option.ThisQuarter": "Este trimestre",
    "resend.emails.in.progress": "Ya está en curso una solicitud para reenviar invitaciones a la encuesta a los participantes. Espere a que se complete esta solicitud antes de volver a intentarlo.",
    "reset.filters": "Restablecer la contraseña",
    "reset.password.dialog.description": "Ya puede utilizar su nueva contraseña.",
    "reset.password.dialog.title": "Se completó la configuración de la nueva contraseña",
    "reset.password.instruction": "Configure la nueva contraseña",
    "response.comment": "Ingresar comentario opcional",
    "response.entities.sentiment": "Opinión",
    "response.entities.sentimentscore": "Puntaje",
    "responseRate.responses": "{{detail}} respuestas",
    "responseRates": "Tasas de respuesta",
    "responserates.answered": "Respondidas",
    "responserates.total": "Total",
    "responses.count": "Cantidad de respuestas",
    "responses.count.compare-timeframe": "Comparar el recuento de respuestas",
    "result.commentSentiment.negative": "Negativo",
    "result.commentSentiment.neutral": "Neutro",
    "result.commentSentiment.positive": "Positivo",
    "result.commentSentiment.unknown": "Desconocido",
    "result.noPositiveSentiment": "Opinión no positiva",
    "results.moreDetails": "Más detalles",
    "results.responded": "Respondido",
    "results.see": "Ver",
    "return.home": "Volver a la página de inicio",
    "role.current.direct.reports": "Informe directo actual",
    "role.current.hierarchy": "Informe de jerarquía actual",
    "role.directReport": "Informe directo",
    "role.hierarhcyReport": "Informe de jerarquía",
    "role.peopleleader": "Líder",
    "roles.actionPlanning.all": "Todas las acciones",
    "roles.actionPlanning.default": "Solo sus acciones",
    "roles.actionPlanning.hierarchy": "Solo jerarquía",
    "roles.addRole": "Agregar rol",
    "roles.column.actionPlanning": "Acceso a planificación de acciones",
    "roles.column.other": "Otros permisos",
    "roles.column.role": "Rol",
    "roles.column.surveyType": "Acceso a tipo de encuesta",
    "roles.column.users": "N° de usuarios",
    "roles.create.desc": "Crea un rol mediante la definición de un conjunto de permisos que los usuarios de determinado grupo requieran para acceder a la plataforma. Una vez creado el rol, asígnalo a los respectivos usuarios a través de la sección Usuarios.",
    "roles.create.error": "Lo sentimos, parece que falta información",
    "roles.create.errorDesc": "Verifica las siguientes validaciones:",
    "roles.create.successDesc": "{{name}} se guardó correctamente.",
    "roles.create.successTitle": "Nuevo rol creado",
    "roles.create.title": "Crear un nuevo rol",
    "roles.delete.preventDesc": "Asigna a todos los usuarios que tienen un rol de socio comercial de RR. HH. un rol diferente antes de eliminar este rol.",
    "roles.delete.preventDesc.automaticallyCreated": "Se trata de un rol del sistema y no se puede eliminar.",
    "roles.delete.preventKazooDefaultRole": "Este es un rol predeterminado y no se puede eliminar desde el módulo Encuestas e información. Póngase en contacto con su administrador del servicio de atención al cliente para obtener más información sobre los roles predeterminados.",
    "roles.delete.preventTitle": "Este rol tiene usuarios asignados.",
    "roles.delete.preventTitle.default": "Este rol no se puede eliminar",
    "roles.delete.preventTitle.kazooDefaultRole": "No es posible eliminar el rol",
    "roles.delete.successDesc": "{{name}} se eliminó correctamente.",
    "roles.delete.successTitle": "Rol eliminado",
    "roles.empty": "No hay nada aquí por el momento... ¡hagamos algo al respecto!",
    "roles.input.name": "Nombre del rol",
    "roles.mainTitle": "Roles",
    "roles.other.none": "Ninguno",
    "roles.searchLabel": "Buscar por rol",
    "roles.surveyType.all": "Todo",
    "roles.surveyType.attribute": "Basada en atributos",
    "roles.surveyType.hierarchy": "Jerarquía",
    "roles.update.alertConfirm": "Confirmar cambios",
    "roles.update.alertDesc": "Si continúas, se actualizarán los permisos de todos los usuarios con este rol en función de los nuevos permisos",
    "roles.update.alertTitle": "Actualizar este rol afectará a los usuarios que actualmente tienen ese rol",
    "roles.update.successDesc": "{{name}} se guardó correctamente.",
    "roles.update.successTitle": "Rol actualizado",
    "roles.update.title": "Editar rol",
    "rows.per.page": "Filas por página:",
    "ru-ru": "Ruso",
    "schedule.time.early-morning": "A primera hora de la mañana (6-8 h)",
    "schedule.time.eod": "Fin de la jornada (16.00 a 18.00 horas)",
    "schedule.time.evening": "Tarde (de 20:00 a 22:00)",
    "schedule.time.noon": "De mediodía a la comida (de 12.00 a 14.00 horas)",
    "scheduled": "Programado",
    "scoreByAttrSpread": "Despliegue del puntaje por atributo",
    "search.for.content": "Buscar contenido ...",
    "search.placeholder": "Buscando...",
    "search.question.title": "Buscar una pregunta",
    "see.all": "Ver todos",
    "see.more.something": "Seleccionar más {{something}}",
    "select": "Seleccionar",
    "select.all": "Seleccionar todo",
    "select.an.attribute": "Seleccionar un atributo",
    "select.choosesurvey": "Filtrar por encuesta",
    "selected.survey.status.header": "Estado",
    "selected.survey.styles.header": "Estilos de encuesta",
    "selected.survey.types.header": "Tipos de encuesta",
    "send.password.reset.email": "Enviar correo electrónico",
    "sentimentCloud.noAvailableData": "No hay datos disponibles",
    "sentimentCloud.slider.title": "Mostrar frases clave: ",
    "sentiments.set": "Haz clic para cambiar el sentimiento {{sentiment}}.",
    "sentiments.set.negative": "Fijar en negativo",
    "sentiments.set.neutral": "Poner en neutro",
    "sentiments.set.positive": "Positivo",
    "sentiments.set.unknown": "Restablecer a Desconocido",
    "settings.add.survey.type": "Agregar tipo de encuesta",
    "settings.alert.baseCategory.warningDescription": "Puede recibir las recomendaciones de WorkTango vinculando su factor personalizado con un factor de WorkTango arriba y personalizando el nombre.",
    "settings.alert.baseCategory.warningTitle": "No habrá sugerencias recomendadas para los factores personalizados.",
    "settings.alert.recommendation": "Las sugerencias para este factor se basarán en las recomendaciones de WorkTango relacionadas con <strong>{{categoryName}}</strong>.",
    "settings.company.genai-dialog-body": "Nuestra plataforma emplea capacidades de inteligencia artificial de terceros para realizar las siguientes acciones:\n<0>Análisis de sentimiento de comentarios de texto</0> <0>Extracción y asociación de temas de comentarios de texto</0> <0>Resumen breve de comentarios de texto</0> <0>Recomendar acciones basadas en comentarios de texto</0> <0>Generar entidades de comentarios de texto</0> <1>Crear nube de palabras de comentarios de texto</1> Sus datos no son almacenados por terceros, ni son utilizados para el entrenamiento de ningún modelo de IA. Para obtener más información sobre las políticas de IA de WorkTango, sigue <2>este enlace.</2>",
    "settings.company.genai-dialog-title": "Acerca de las funciones de IA de WorkTango",
    "settings.company.genai-settings": "Configuración de la IA generativa",
    "settings.company.genai-settings-tooltip": "Más información sobre las funciones de inteligencia artificial de WorkTango",
    "settings.company.genai.comment-analysis": "Habilite las funciones de IA",
    "settings.company.language-settings": "Ajustes de idioma",
    "settings.company.open-surveys-settings": "Encuestas abiertas",
    "settings.company.open-surveys.enabled": "Habilitar encuestas de enlace compartido",
    "settings.company.open-surveys.response-limit": "",
    "settings.company.open-surveys.response-limit.helperText": "",
    "settings.company.open-surveys.response-limit.invalid": "",
    "settings.company.open-surveys.response-limit.save-error": "",
    "settings.company.salesforceId": "SalesForce ID",
    "settings.company.salesforceId.helperText": "",
    "settings.customFactor": "Factor personalizado",
    "settings.customizeName": "Personalizar nombre",
    "settings.desc.baseSurveyType": "Seleccione la categoría para acceder a una lista recomendada de factores y sugerencias automáticas y mejorar sus puntajes.",
    "settings.desc.factors": "Con los factores se agrupan preguntas similares, lo que le permite ver el puntaje general para el grupo de preguntas. Recomendamos nuestros factores aprobados por el sector, que le brindarán recomendaciones automáticas sobre cómo mejorar sus puntajes.",
    "settings.desc.surveyTypes": "Los tipos de encuesta le permiten agrupar encuestas similares con la misma estructura de permisos y compartir el mismo umbral de anonimato.",
    "settings.done": "Listo",
    "settings.done.message": "Se actualizó correctamente la configuración.",
    "settings.edit.survey.type": "Editar tipo de encuesta",
    "settings.employee-attribute.deletion": "¡Atributo de empleado eliminado correctamente!",
    "settings.employeeAttribute.archiveAttribute": "Archivar atributo",
    "settings.employeeAttribute.archiveAttributeConfirmTitle": "¿Atributo de archivo \"{{nombre}}\"?",
    "settings.employeeAttribute.archiveImpact.bucket.compare": "",
    "settings.employeeAttribute.archiveImpact.bucket.dataset": "",
    "settings.employeeAttribute.archiveImpact.bucket.visible": "",
    "settings.employeeAttribute.archiveImpact.confirm": "",
    "settings.employeeAttribute.archiveImpact.intro": "",
    "settings.employeeAttribute.archiveImpact.loading": "",
    "settings.employeeAttribute.archiveImpact.role": "",
    "settings.employeeAttribute.archiveImpact.title": "",
    "settings.employeeAttribute.archiveModalBody": "Al archivar un atributo, este se ocultará en el sistema, pero se conservarán todos los datos de los empleados almacenados en él, en caso de que decida reactivarlo más adelante.\n\nTodas las encuestas anteriores permanecerán intactas, pero en adelante ya no podrá ver ni filtrar los resultados de las nuevas encuestas que utilicen este atributo.\n\nSi su intención es eliminar permanentemente este atributo, incluidos los datos de los empleados y los datos históricos de las encuestas, considere eliminarlo en su lugar.\n\n¿Está seguro de que desea archivar este atributo?",
    "settings.employeeAttribute.confirmYesArchive": "Sí, archivar",
    "settings.employeeAttribute.confirmYesDelete": "Sí, eliminar",
    "settings.employeeAttribute.confirmYesReactivate": "Sí, reactivar",
    "settings.employeeAttribute.deleteAttribute": "Eliminar atributo",
    "settings.employeeAttribute.deleteAttributeConfirmTitle": "¿Borrar atributo \"{{nombre}}\"?",
    "settings.employeeAttribute.deleteModalBody": "Eliminar un atributo lo eliminará permanentemente del sistema y borrará todos los datos de empleados almacenados en él. Esta acción no se puede deshacer.\n\nTodas las encuestas actuales y anteriores también se verán afectadas por esta acción, y ya no podrá ver ni filtrar los resultados de las encuestas utilizando este atributo.\n\nSi su intención es dejar de usar este atributo, pero conservar los datos históricos, considere archivarlo en su lugar.\n\n¿Está seguro de que desea eliminar este atributo?",
    "settings.employeeAttribute.reactivateModalBody": "Al reactivar un atributo archivado, este será visible en el sistema y estará presente en todas las encuestas nuevas, pero no se agregará a ninguna encuesta en curso.\n\n¿Está seguro de que desea reactivar este atributo?",
    "settings.employeeAttributes.duplicateError": "Parece que ya existe un atributo con el mismo nombre. Elija un nombre diferente para continuar.",
    "settings.error.baseFactorRequired": "Es obligatorio un factor válido de WorkTango.",
    "settings.error.baseSurveyTypeRequired": "Es obligatoria una categoría de encuesta.",
    "settings.error.enNameRequired": "El nombre en inglés no debe quedar incompleto",
    "settings.error.invalidSize": "Tamaño no válido de archivo de {{fileSizeKB}} KB. Máximo: {{maxUploadSizeKB}} KB.",
    "settings.error.maxedPrimary": "Ya se seleccionaron los atributos primarios máximos",
    "settings.error.notValidImage": "Archivo de imagen no válido.",
    "settings.error.thresholdRequired": "Se requiere seleccionar un umbral de anonimato válido",
    "settings.error.validTypeRequired": "Tipo de atributo del empleado no válido",
    "settings.integrations.channel.slack.description": "",
    "settings.integrations.channel.slack.label": "",
    "settings.integrations.channel.sms.description": "",
    "settings.integrations.channel.sms.label": "",
    "settings.integrations.channel.teams.description": "",
    "settings.integrations.channel.teams.label": "",
    "settings.integrations.configure": "",
    "settings.integrations.description": "",
    "settings.integrations.error": "",
    "settings.integrations.heading": "",
    "settings.integrations.notConnectedHint": "",
    "settings.integrations.setup": "",
    "settings.integrations.setup.comingSoon": "",
    "settings.integrations.slack.connectError": "",
    "settings.integrations.slack.connected": "",
    "settings.integrations.status.connected": "",
    "settings.integrations.status.notConnected": "",
    "settings.integrations.toggle.error": "",
    "settings.kiosk.attributes": "Identificador de quiosco",
    "settings.kiosk.download-qr-code": "Descargar código QR",
    "settings.kiosk.language": "Información adicional",
    "settings.kiosk.language.tooltip": "Este texto se mostrará en la página de inicio de sesión del quiosco como texto de bienvenida",
    "settings.kiosk.none": "Ninguno",
    "settings.kiosk.qr-code": "Código QR del quiosco",
    "settings.label.archived": "Archivada",
    "settings.label.baseAttribute": "Sistema",
    "settings.label.createAttribute": "Crear atributo",
    "settings.label.factor": "Factor de WorkTango",
    "settings.label.key.factor": "Factor principal",
    "settings.label.modifyAttribute": "Modificar atributo",
    "settings.label.name": "Nombre",
    "settings.label.newAttribute": "Nuevo atributo",
    "settings.label.phone": "Teléfono",
    "settings.label.phoneAlt": "Número de teléfono",
    "settings.label.phoneDisabled": "Los números de teléfono solo se pueden configurar para atributos de tipo texto.",
    "settings.label.prepopulateFactors": "Completar previamente este tipo de encuesta con los factores actuales",
    "settings.label.primary": "Primario",
    "settings.label.primaryAlt": "Primario (se muestra siempre de manera predeterminada; se permiten hasta 10)",
    "settings.label.private": "Privado",
    "settings.label.privateAlt": "Privado (oculto en la lista de empleados)",
    "settings.label.required": "Obligatorio",
    "settings.label.setup.suggestions": "Hacer clic para configurar sugerencias",
    "settings.label.suggestions.content": "Recomendaciones de {{categoryName}} de WorkTango",
    "settings.label.suggestions.powered.by": "Sugerencias basadas en",
    "settings.label.survey.types": "Tipos de encuesta",
    "settings.label.type": "Tipo",
    "settings.label.unique": "Único",
    "settings.message.categoryUpdated": "Se actualizó correctamente el factor.",
    "settings.message.surveyTypesUpdated": "Se actualizó correctamente el tipo de encuesta.",
    "settings.primaryAttributeCannotBeModified": "Este es un atributo del sistema y no se puede modificar. ",
    "settings.selected.baseSurveyType": "Categoría de la encuesta",
    "settings.title": "Configuración",
    "settings.title.automatedInvitations": "Invitaciones automatizadas",
    "settings.title.categoryUpdated": "Guardado",
    "settings.title.company": "Empresa",
    "settings.title.employee-attributes": "Atributos del empleado",
    "settings.title.error": "Error",
    "settings.title.integrations": "",
    "settings.title.kiosk": "Quiosco",
    "settings.title.surveyTypes": "Tipos de encuesta y factores",
    "settings.title.surveyTypesUpdated": "Guardado",
    "settings.title.surveys": "Encuestas",
    "settings.useRecommendedName": "Usar el nombre recomendado",
    "show": "Mostrar",
    "show.all": "Ver todos",
    "show.all.suggestions": "Mostrar las {{count}} sugerencias",
    "show.less": "Mostrar menos",
    "sidebar.action-planning": "Planificación de la acción",
    "sidebar.admin.branding": "Información de la empresa",
    "sidebar.admin.data": "Configuración",
    "sidebar.admin.employees": "Empleados",
    "sidebar.content.library": "Tutor de aprendizaje",
    "sidebar.inbox": "Conversaciones",
    "sidebar.mailing-lists": "Listas de correo",
    "sidebar.surveys": "Encuestas",
    "skip.disabled.when.required": "Omitir no está disponible cuando se requiere una pregunta",
    "sliding_accessible_ms_custom_blue": "Azul numérico (cuadrado), accesible",
    "sliding_accessible_squares": "Numérico (cuadrado), accesible",
    "sliding_apples": "Manzanas",
    "sliding_blush": "Emoji de la cara sonrojada",
    "sliding_boat": "Barco",
    "sliding_canada": "Banderas canadienses",
    "sliding_computer": "Computadoras",
    "sliding_cpa_custom_emoji": "Solo calificación de 5 con emojis",
    "sliding_crown": "Coronas",
    "sliding_desk": "Escritorios",
    "sliding_double_phones": "Dos teléfonos",
    "sliding_eyes_closed_happy_emoji": "Emoji feliz con los ojos cerrados",
    "sliding_flags": "Banderas",
    "sliding_hands_up": "Manos arriba",
    "sliding_headphones_happy_face_emoji": "Emoji feliz con auriculares",
    "sliding_hearts": "Corazones",
    "sliding_hearts_united_way": "Corazones de United Way",
    "sliding_lemur": "Lémur",
    "sliding_lightbulb": "Bombilla",
    "sliding_music_note": "Notas musicales",
    "sliding_office_chair": "Sillas de oficina",
    "sliding_otter": "Nutria",
    "sliding_panda": "Panda",
    "sliding_pencil": "Lápices",
    "sliding_penguin": "Pingüino",
    "sliding_phone_in_hand": "Teléfono en la mano",
    "sliding_pint_glasses": "Vasos de una pinta",
    "sliding_pizza": "Rebanada de pizza",
    "sliding_puppy": "Cara de cachorro",
    "sliding_single_phone": "Teléfono solo",
    "sliding_speech_bubbles": "Burbujas de diálogo",
    "sliding_stars": "Estrellas",
    "sliding_teal_square": "Numérico (cuadrado)",
    "sliding_thumbs_up": "Pulgares arriba",
    "sliding_tiff_stars": "Estrellas Tiff",
    "sliding_wifi": "Señal de Wi-Fi",
    "snapshots.update.unknown.error": "",
    "snapshots.updated.successfully": "",
    "source": "Fuente",
    "spread": "Desplegar",
    "spread.of.responses.by.attribute": "Despliegue de las tasas de respuesta por atributo",
    "sq-al": "Albanés",
    "sr-rs": "Serbian",
    "sso.loginFailed": "Error de inicio de sesión",
    "sso.loginFailed.invalidToken": "Token inválido",
    "sso.user.not.found.description": "No se encontró ningún usuario para {{email}}",
    "star.this": "Comenzar esta",
    "starred": "Marcado",
    "status.all": "Todos",
    "suggestions": "Sugerencias",
    "summary": "Resumen",
    "summaryReport": "Resumen del informe",
    "support.failure.message": "Se ha producido un error inesperado al intentar iniciar sesión en Zendesk con SSO. Por favor, póngase en contacto con soporte.",
    "survey": "Encuesta",
    "survey-template.dialog.confirm": "Crear encuesta utilizando la plantilla seleccionada",
    "survey-template.dialog.confirm-multiple": "Crear encuesta utilizando la plantilla seleccionada como",
    "survey-template.dialog.description": "Si desea poner de moda una encuesta, clone una ya existente.",
    "survey-template.dialog.empty-state": "No hay ninguna plantilla que coincida con sus filtros.",
    "survey-template.dialog.error": "Debe seleccionar al menos un idioma",
    "survey-template.dialog.select-language.helper-text": "Nota importante: una vez que se haya creado la encuesta, ya no será posible cambiar los idiomas disponibles.",
    "survey-template.dialog.select-language.label": "Compartir la encuesta en los siguientes idiomas",
    "survey-template.dialog.title": "Elija una plantilla de encuesta",
    "survey-template.dialog.tooltip.missing-factors": "Faltan uno o más factores requeridos en este tipo de encuesta. Tendrá que elegir manualmente los factores para una o más preguntas.",
    "survey-template.dialog.warning": "Estas plantillas crearán una nueva encuesta neta.",
    "survey-template.preview.empty-state": "Seleccione una encuesta para obtener una vista previa de la lista de preguntas incluidas",
    "survey-template.preview.loading": "Cargando preguntas...",
    "survey-template.preview.no-content": "No hay contenido",
    "survey-template.preview.title": "Vista previa de \"{{name}}\"",
    "survey.ai-summary.ask-to-interpret-results": "¿Pedirle a la IA que interprete los resultados de una encuesta?",
    "survey.ai-summary.fetch-error": "Error al cargar el resumen de IA. Inténtalo de nuevo.",
    "survey.ai-summary.footer-actions.regenerate": "Regenerado",
    "survey.ai-summary.footer-actions.regenerate-loading": "Regenerando...",
    "survey.ai-summary.generate-error": "Error al generar el resumen de IA. Inténtalo de nuevo.",
    "survey.ai-summary.generate-success": "Resumen de IA generado con éxito",
    "survey.ai-summary.generating": "La IA está analizando los resultados de la encuesta. Esto podría tardar un poco...",
    "survey.ai-summary.generating-summary": "Generar un resumen de los resultados de la encuesta",
    "survey.ai-summary.not-performed-with-filters": "No se ha realizado ningún análisis de IA utilizando los filtros aplicados.",
    "survey.aiSummary.noAreasToWatch": "A partir de los datos procesados no se pudo determinar ninguna zona a observar.",
    "survey.aiSummary.noNegativeSentiment": "A partir de los datos procesados no se pudieron determinar áreas de oportunidad.",
    "survey.aiSummary.noParticipationRate": "No se pudo determinar ninguna tasa de participación a partir de los datos procesados.",
    "survey.aiSummary.noPositiveSentiment": "No hay conclusiones positivas de los datos procesados.",
    "survey.aiSummary.noRecommendations": "No hay recomendaciones a partir de los datos procesados.",
    "survey.analyze": "Análisis",
    "survey.approveMigration": "Aprobar migración",
    "survey.audience.missing.applicable.questions.intro": "Todas las preguntas de esta encuesta se dirigen a un grupo concreto, y los siguientes empleados invitados no cumplen los requisitos para responder a ninguna de ellas:",
    "survey.audience.missing.applicable.questions.outro": "Ajusta el público o los criterios de selección de la encuesta antes de guardarla.",
    "survey.automatic-reminder.validation.email-content": "Introduzca un contenido de correo electrónico para todos los idiomas",
    "survey.automatic-reminder.validation.email-subject": "Introduzca un asunto para todos los idiomas",
    "survey.automatic-reminder.validation.reminder-frequency": "Introduzca una frecuencia de recordatorio",
    "survey.automatic-reminder.validation.reminder-time": "Seleccione una hora de recordatorio",
    "survey.build.dialog.email-recipients": "",
    "survey.build.dialog.email-to-employees_one": "",
    "survey.build.dialog.email-to-employees_other": "",
    "survey.build.dialog.once-confirmed-schedule": "",
    "survey.build.dialog.sms-no-phone_one": "",
    "survey.build.dialog.sms-no-phone_other": "",
    "survey.build.dialog.sms-opted-out_one": "",
    "survey.build.dialog.sms-opted-out_other": "",
    "survey.build.dialog.sms-recipients": "",
    "survey.build.dialog.sms-to-employees_one": "",
    "survey.build.dialog.sms-to-employees_other": "",
    "survey.build.new.title": "¿Deseas guardar y programar?",
    "survey.build.questions.information.about.benchmarks.text": "WorkTango Benchmarks le permite comparar los resultados de sus preguntas con los resultados de empresas similares a la suya. Las preguntas de la biblioteca con un icono verde están incluidas por defecto en el programa WorkTango Benchmark. Si desea comparar los resultados de una de sus preguntas personalizadas con los de un punto de referencia de WorkTango, trabaje con el equipo de éxito del cliente de WorkTango para encontrar una pregunta de la biblioteca de WorkTango apropiada con la que realizar la comparación.",
    "survey.build.questions.information.about.benchmarks.title": "Información sobre puntos de referencia",
    "survey.build.schedule.invitation-date.1-week-after": "La invitación caduca al cabo de 1 semana",
    "survey.build.schedule.invitation-date.2-week-after": "La invitación caduca a las 2 semanas",
    "survey.build.schedule.invitation-date.custom-number-of-days": "Número de días personalizado",
    "survey.build.schedule.invitation-date.custom-number-of-days.label": "Días",
    "survey.build.schedule.invitation-date.label": "Invitación válida hasta el",
    "survey.build.schedule.invitation-date.same-as-survey": "Igual que la encuesta",
    "survey.build.schedule.invitation-date.tooltip": "Las invitaciones individuales pueden configurarse para que caduquen después de ser enviadas. Si activa o desactiva esta función, sólo se verán afectadas las invitaciones futuras.",
    "survey.build.update.title": "Resumen de actualización de encuesta",
    "survey.button.cancel": "Cancelar",
    "survey.button.edit": "Editar encuesta",
    "survey.button.hideReminders": "Ocultar recordatorios",
    "survey.button.remind": "Enviar recordatorio",
    "survey.button.view-reminders": "Ver recordatorios",
    "survey.button.viewReminders": "Ver recordatorios",
    "survey.button.viewReports": "Ver los informes",
    "survey.button.viewReports.noInProgressPermission": "",
    "survey.cancel": "Cancelar encuesta",
    "survey.choose-from-template": "Elija entre las plantillas...",
    "survey.clone": "Encuesta de clones",
    "survey.convert-continuous": "Convertir en encuesta continua",
    "survey.convert.dialog.action-text-1": "Esta acción no puede deshacerse.",
    "survey.convert.dialog.action-text-2": "¿Estás seguro de que quieres proceder con este cambio?",
    "survey.convert.dialog.desc-1": "Esta acción cambiará el estilo de la encuesta de \"Estándar\" a \"Continuo\", como se describe a continuación. Esto significa:",
    "survey.convert.dialog.desc-2": "La encuesta no caduca, y las invitaciones son automáticas",
    "survey.convert.dialog.desc-3": "Las respuestas enviadas siguen estando disponibles y pueden notificarse en función de la fecha de invitación",
    "survey.convert.dialog.desc-4": "Todas las invitaciones existentes permanecen activas",
    "survey.convert.dialog.desc-5": "Es necesario configurar los disparadores de automatización después de la conversión",
    "survey.convert.dialog.option-1": "Encuesta continua basada en la fecha de inicio",
    "survey.convert.dialog.option-2": "Encuesta continua basada en la fecha de salida",
    "survey.convert.dialog.option-help-text-1": "Ideal para encuestas de incorporación. Esta encuesta no caduca, pero las invitaciones sí, y los participantes solo pueden responder una vez.",
    "survey.convert.dialog.option-help-text-2": "Los informes se elaboran en función de los plazos seleccionados.",
    "survey.convert.dialog.option-help-text-3": "Ideal para encuestas de salida. Esta encuesta no caduca, pero las invitaciones sí, y los participantes sólo pueden responder una vez.",
    "survey.convert.dialog.option-help-text-4": "Los informes se elaboran en función de los plazos seleccionados.",
    "survey.convert.dialog.option-title": "Por favor, elija un nuevo estilo de encuesta:",
    "survey.convert.dialog.submit-button": "Sí, Iniciar conversión",
    "survey.convert.dialog.success-message": "Encuesta convertida con éxito.",
    "survey.convert.dialog.title": "Convertir encuesta estándar en continua",
    "survey.create-new-survey": "Crear una nueva encuesta",
    "survey.custom-survey": "Encuesta personalizada",
    "survey.delete": "Eliminar",
    "survey.delete2": "Eliminar encuesta",
    "survey.descPlaceholder": "Ingresar la descripción de la pregunta aquí",
    "survey.duplicate": "Duplicar",
    "survey.edit": "Editar",
    "survey.edit2": "Editar encuesta",
    "survey.emails.off": "Esta encuesta está configurada para NO enviar invitaciones ni recordatorios por correo electrónico",
    "survey.emptyEmailContent": "Ingrese el contenido del correo electrónico para todos los idiomas",
    "survey.emptyEmailSubject": "Ingrese la referencia del correo electrónico para todos los idiomas",
    "survey.emptyExpiryTime": "Seleccione la fecha de finalización",
    "survey.emptySendTime": "Seleccione la hora de envío",
    "survey.emptyTimezone": "Seleccione el huso horario",
    "survey.error.manageNotAllowed": "",
    "survey.filterByCategory": "Factor",
    "survey.list.no.active.triggers": "No hay activadores activos configurados. \nPara que la automatización funcione, se necesita al menos un activador activo.",
    "survey.list.trigger.type.disabled": "La automatización está desactivada. El sistema no añadirá automáticamente nuevos candidatos a esta encuesta.",
    "survey.messaging.error.disableInProgress": "",
    "survey.messaging.error.languageNotConfigured ": "",
    "survey.messaging.error.saveFailed": "",
    "survey.messaging.error.smsAttributeNotPhone": "",
    "survey.messaging.error.smsAttributeRequired": "",
    "survey.messaging.error.smsAttributeWrongCompany": "",
    "survey.messaging.error.textRequired": "",
    "survey.messaging.error.variationRequired": "",
    "survey.migrate.description.first": "Esta acción toma el archivo de datos de su encuesta y rellena la encuesta con esas respuestas.",
    "survey.migrate.description.second": "Asegúrese de recrear primero todas las preguntas de la encuesta original. A continuación, puede utilizar el archivo de la plantilla de migración de la encuesta para darle el formato adecuado.",
    "survey.migrate.error.commentsWithoutAnswer": "Las preguntas tienen comentario, pero no respuesta",
    "survey.migrate.error.duplicatedQuestions": "Preguntas duplicadas",
    "survey.migrate.error.employeesWithWrongCompletedSurvey": "Empleado que no completa la encuesta, pero tiene datos de respuesta en el archivo de la encuesta",
    "survey.migrate.error.invalidEmployeeIds": "Los ID de los empleados no existen",
    "survey.migrate.error.invalidRatingAnswers": "Preguntas de escala con respuestas de calificación no válidas",
    "survey.migrate.error.missingInvitationTimes": "Empleados sin tiempo de preaviso",
    "survey.migrate.error.missingMultipleChoiceOptions": "No existen opciones en la pregunta de la encuesta (opción múltiple)",
    "survey.migrate.error.missingSubmissionDates": "Empleados que han respondido a una pregunta pero no tienen fecha de envío",
    "survey.migrate.error.noCompletedSurveyColumn": "Falta la columna \"Encuesta completada\"",
    "survey.migrate.error.noEmployeeIdColumn": "Falta la columna \"ID de empleado\"",
    "survey.migrate.error.noInvitationTimeColumn": "Falta la columna \"Hora de invitación",
    "survey.migrate.error.noSubmissionDateColumn": "Falta la columna «Fecha de presentación»",
    "survey.migrate.error.nonExistingQuestions": "No existen preguntas en esta encuesta",
    "survey.migrate.error.rejoinedEmployeeIds": "El empleado volvió a participar en la misma encuesta",
    "survey.migrate.error.unsupportedCompletedSurvey": "Formato incorrecto del título \"Encuesta completada\"",
    "survey.migrate.error.unsupportedEmployeeId": "Formato incorrecto del título \"ID de empleado\"",
    "survey.migrate.error.unsupportedTitles": "Títulos desconocidos comparados con los atributos de la empresa",
    "survey.migrate.message.scheduled": "El sistema trabajará en la migración de las respuestas de la encuesta. Puede cerrar esta ventana y seguir el progreso en la pestaña \"Migrando\" para consultar el progreso y los errores. Una vez que la migración se haya completado con éxito, podrá encontrar la encuesta en la pestaña \"Completada\".",
    "survey.migrate.select-file": "Seleccione un archivo (.xlsx o .xls)",
    "survey.migrate.template": "Generar plantilla",
    "survey.nochanges": "Tenga en cuenta que no puede modificar las preguntas una vez que se haya enviado la encuesta.",
    "survey.open-survey.attribute-value-not-disclosed": "",
    "survey.optionPlaceholder": "Ingresar el título de la opción aquí",
    "survey.preview": "Vista previa de la encuesta",
    "survey.recipients.changed": "Tiene cambios sin guardar en la lista de participantes. Asegúrese de guardarlos antes de salir de esta pantalla.",
    "survey.recipients.save.button": "Guardar los cambios en los participantes",
    "survey.reminder": "Personaliza tu mensaje de recordatorio",
    "survey.reminder.button.create": "Programar recordatorio",
    "survey.reminder.button.edit": "Guardar cambios",
    "survey.reminder.button.view": "Programar recordatorio",
    "survey.reminder.confirm.description.delete": "¿Estás seguro de que deseas eliminar de forma permanente este recordatorio y su contenido? No podrás deshacer esta acción.",
    "survey.reminder.confirm.title.delete": "Eliminar recordatorio programado",
    "survey.reminder.create.success": "Se creó correctamente el recordatorio.",
    "survey.reminder.delete.success": "Se eliminó correctamente el recordatorio.",
    "survey.reminder.scheduled-date-time": "Fecha y hora programadas",
    "survey.reminder.scheduled-date-time.error": "La hora debería ser de {{minDateTime}} a {{maxDateTime}} en ({{gmt}}) {{timezone}}.",
    "survey.reminder.scheduled-date-time.error.min-only": "",
    "survey.reminder.status.ERROR": "Error",
    "survey.reminder.status.PROCESSING": "Procesando",
    "survey.reminder.status.SCHEDULED": "Programado",
    "survey.reminder.status.SENDING": "Enviando",
    "survey.reminder.status.SENT": "Enviado",
    "survey.reminder.timezone-desc": "Todos los horarios están en ({{gmt}}) {{timezone}}",
    "survey.reminder.title.create": "Programar un nuevo recordatorio",
    "survey.reminder.title.edit": "Editar recordatorio",
    "survey.reminder.title.view": "Ver recordatorio",
    "survey.reminder.update.success": "Se actualizó correctamente el recordatorio.",
    "survey.resend.employee.emails": "¿Reenviar la invitación a la encuesta a los siguientes correos?",
    "survey.responserates": "Tasas de respuesta",
    "survey.responses": "Respuestas",
    "survey.results": "Resultados",
    "survey.schedule.email.choose-language-to-edit": "Elija el idioma que desea editar",
    "survey.schedule.email.from-email": "Dirección de correo electrónico del remitente",
    "survey.schedule.email.subject": "Asunto del correo electrónico",
    "survey.schedule.frequency.custom": "Número de días personalizado",
    "survey.schedule.frequency.custom-label": "Días",
    "survey.schedule.frequency.errors.out-of-range": "Debe ser un número entre 1 y 99",
    "survey.schedule.frequency.errors.required": "Se requiere el número de días",
    "survey.schedule.frequency.every-x-days": "Cada {{count}} días",
    "survey.schedule.frequency.info": "Los recordatorios se enviarán automáticamente en función de cuándo se haya invitado al participante. Dejarán de enviarse cuando el participante complete la encuesta o expire su acceso a la misma.",
    "survey.schedule.from.max.length": "Longitud máxima de 255 caracteres",
    "survey.schedule.messaging.channel.email": "",
    "survey.schedule.messaging.channel.slack": "",
    "survey.schedule.messaging.channel.sms": "",
    "survey.schedule.messaging.channel.teams": "",
    "survey.schedule.messaging.content-label.slack": "",
    "survey.schedule.messaging.content-label.sms": "",
    "survey.schedule.messaging.content-placeholder": "",
    "survey.schedule.messaging.enable-label.slack": "",
    "survey.schedule.messaging.enable-label.sms": "",
    "survey.schedule.messaging.enable-label.teams": "",
    "survey.schedule.messaging.invitation-card-title": "",
    "survey.schedule.messaging.not-connected": "",
    "survey.schedule.messaging.not-enabled": "",
    "survey.schedule.messaging.sms.attribute-helper": "",
    "survey.schedule.messaging.sms.attribute-label": "",
    "survey.schedule.messaging.sms.attribute-placeholder": "",
    "survey.schedule.messaging.sms.tcpa-warning": "",
    "survey.schedule.messaging.tabs-aria-label": "",
    "survey.schedule.messaging.variation": "",
    "survey.schedule.remarks.survey-expiry": "Los participantes que no hayan enviado sus respuestas permanecerán en la encuesta, pero no podrán participar",
    "survey.schedule.reminder-content.label": "Contenido del correo electrónico recordatorio",
    "survey.schedule.reminder-frequency.label": "Frecuencia de recordatorio",
    "survey.schedule.reminder-subject.label": "Asunto del correo electrónico recordatorio",
    "survey.schedule.reminder-time.label": "Hora del día para enviar el recordatorio",
    "survey.schedule.switch.survey_reminders": "Activar recordatorios automáticos",
    "survey.schedule.switch.survey_reminders_callout": "Además de automáticos, los recordatorios programados pueden programarse con un texto personalizado desde la página Encuestas para las encuestas que tengan un estado \"Programada\" o \"En curso\".",
    "survey.schedule.title": "Programación de encuestas",
    "survey.schedule.title.continuous-survey": "Configuración de la encuesta continua",
    "survey.schedule.title.invitation": "Invitación a la encuesta",
    "survey.schedule.title.survey-expiry": "Fecha de caducidad del enlace de la encuesta",
    "survey.schedule.title.survey_reminders": "Recordatorios de encuestas",
    "survey.selectMore": "Seleccionar más encuestas",
    "survey.selection": "Seleccione las encuestas que desee agregar a la vista actual",
    "survey.send.test.success": "Se le envió un correo electrónico de prueba. Verifique su casilla de mensajes.",
    "survey.sending.estimate": "Se enviará un correo electrónico a {{ total }} empleados en los próximos {{ minutes }} minutos",
    "survey.set.survey.completed": "Mover encuesta a Completada",
    "survey.set.survey.in.progress": "Mover encuesta a En curso",
    "survey.share.bypass-link": "Enlace directo a la encuesta para omitir el código de acceso",
    "survey.share.bypass-qr-code": "Código QR directo de la encuesta para omitir el código de acceso",
    "survey.share.copied": "Copiado en el portapapeles.",
    "survey.share.copy-bypass-link": "Copiar enlace directo",
    "survey.share.copy-failed": "No se ha podido copiar. Selecciónalo en la página y cópialo manualmente.",
    "survey.share.copy-link": "Copiar enlace",
    "survey.share.copy-passcode": "Copiar código de acceso",
    "survey.share.device-count-one-device_other": "{{count}} respuestas de 1 dispositivo",
    "survey.share.device-count_one": "{{count}} respuesta de {{deviceCount}} dispositivo",
    "survey.share.device-count_other": "{{count}} respuestas de {{deviceCount}} dispositivos",
    "survey.share.download-bypass-qr-code": "Descargar código QR directo",
    "survey.share.download-qr-code": "Descargar código QR",
    "survey.share.link": "Enlace de la encuesta",
    "survey.share.passcode": "Código de acceso",
    "survey.share.passcode-failed": "No se ha podido actualizar el código de acceso. Inténtalo de nuevo.",
    "survey.share.passcode-hint": "Elige una palabra que sea fácil de pronunciar y evita caracteres que puedan confundirse fácilmente, como el cero y la letra O mayúscula",
    "survey.share.passcode-invalid": "Un código de acceso puede tener hasta 32 letras y números, y no puede contener I, L, O, 0 ni 1.",
    "survey.share.passcode-saved": "Código de acceso actualizado.",
    "survey.share.passcode-toggle": "Proteger el enlace con un código de acceso",
    "survey.share.qr-code": "Código QR de la encuesta",
    "survey.share.title": "Configuración de la encuesta",
    "survey.stage.1": "Creado y programado",
    "survey.stage.2": "Completo y en progreso",
    "survey.stage.all": "Todos los estados",
    "survey.status": "Estado",
    "survey.status0": "Creado",
    "survey.status1": "Programado",
    "survey.status2": "En progreso",
    "survey.status3": "Completo",
    "survey.status4": "Enviando",
    "survey.status5": "Procesando",
    "survey.status6": "Migrado",
    "survey.status7": "Migración fallida",
    "survey.stop": "Cancelar",
    "survey.tab.migrating": "Migrando",
    "survey.title.report-for": "Informe para",
    "survey.titlePlaceholder": "Ingresar el título de la pregunta aquí",
    "survey.trend": "Tendencia",
    "survey.type.disabled": "Desactivado",
    "survey.view": "Vista previa",
    "surveyEdit.addLogic": "Agregar lógica",
    "surveyEdit.admin.unlockButton": "Editar pregunta",
    "surveyEdit.admin.unlockDesc": "Estás a punto de editar una pregunta que ya se respondió en esta encuesta o en otra.\n\nEditar este tipo de preguntas puede invalidar todas las demás respuestas. Editar esta pregunta afectará además a esta pregunta en todas las demás encuestas en la que se haya formulado.\n\n¿Confirmas que deseas editar esta pregunta?",
    "surveyEdit.admin.unlockTitle": "Prosigue con precaución",
    "surveyEdit.conditional": "Condicional",
    "surveyEdit.conditional.attribute": "Esta pregunta se muestra de forma condicional a los encuestados cuyas respuestas cumplan con los siguientes atributos: {{attributes}}",
    "surveyEdit.conditional.logic": "Esta pregunta se muestra en función de determinadas condiciones de lógica",
    "surveyEdit.conditional.logicAndAttribute": "Esta pregunta se mostró en función de determinadas condiciones de lógica y porque las respuestas de los encuestados cumplieron con los siguientes atributos: {{attributes}}",
    "surveyEdit.deleteLogic": "Eliminar lógica",
    "surveyEdit.deleteLogicConfirm": "¿Está seguro de que desea eliminar este bloque de lógica?",
    "surveyEdit.logic.addCondition": "Agregar condición",
    "surveyEdit.logic.affectedQuestion": "Preguntas para mostrar",
    "surveyEdit.logic.broken": "Este bloque lógico hace referencia a una pregunta que ya no figura en esta encuesta. Ponte en contacto con el servicio de asistencia si necesitas ayuda o elimínalo a continuación.",
    "surveyEdit.logic.cancel": "Cancelar",
    "surveyEdit.logic.conditionDesc": "De lo contrario, ocultar pregunta {{order}}",
    "surveyEdit.logic.conditionDescMsg": "De lo contrario, puede ocultar \"{{message}}\"",
    "surveyEdit.logic.deleteCondition": "Eliminar esta condición",
    "surveyEdit.logic.disableAdd": "¿Necesita agregar más condiciones de lógica? Use los bloques de lógica que se muestran arriba para agregar condiciones",
    "surveyEdit.logic.display": "Mostrar",
    "surveyEdit.logic.if": "Si",
    "surveyEdit.logic.incomplete": "Complete o elimine las condiciones incompletas",
    "surveyEdit.logic.or": "o",
    "surveyEdit.logic.question": "pregunta",
    "surveyEdit.logic.response": "respuesta",
    "surveyEdit.logic.save": "Guardar lógica",
    "surveyEdit.logic.selectAnswer": "Seleccione una respuesta",
    "surveyEdit.logic.selectQuestion": "Seleccione una pregunta",
    "surveyEdit.logic.selectTitle": "Para pregunta",
    "surveyEdit.logicEditor": "Editor de lógica",
    "surveyEdit.logicEditorDesc": "Use el Editor de lógica para decidir qué preguntas se deberían mostrar a los encuestados en función de las respuestas anteriores. Las preguntas se ocultan de forma predeterminada a todos los encuestados hasta que se cumple al menos una de las condiciones.",
    "surveyEdit.logicEditorEmpty": "No tiene preguntas relacionadas con lógica",
    "surveyEdit.message.placeholder": "Escriba su mensaje aquí...",
    "surveyEdit.preventDeleting.desc": "Esta pregunta incluye una condición de lógica. Para poder eliminar la pregunta, primero deberá eliminar la condición de lógica en el Editor de lógica.",
    "surveyEdit.preventDeleting.title": "Esta pregunta no se puede eliminar",
    "surveyEdit.preventOrdering.desc": "Si cambia la respuesta a esta pregunta, deberá volver a responder todas las preguntas siguientes, ya que algunas preguntas pueden estar visibles u ocultas en función de su nueva respuesta.",
    "surveyEdit.preventOrdering.goTo": "Ir al Editor de lógica",
    "surveyEdit.preventOrdering.title": "Esta pregunta no se puede reordenar y colocar en esta posición",
    "surveyEdit.question.selectType": "Elija su tipo de pregunta",
    "surveyEdit.questionEditor": "Editor de preguntas",
    "surveyEdit.updateLogic": "Editar lógica",
    "surveyEdit.yesNoQuestion.no": "No",
    "surveyEdit.yesNoQuestion.yes": "Sí",
    "surveyMigration.button": "Validar migración de la encuesta",
    "surveyMigration.closeButton": "Cerrar",
    "surveyMigration.dialog.title": "Validar archivo de migración de la encuesta",
    "surveyMigration.error.commentsWithoutAnswer": "Comentarios sin respuesta:",
    "surveyMigration.error.duplicatedQuestions": "Preguntas duplicadas:",
    "surveyMigration.error.missingMultipleChoiceOptions.description": "Si las opciones son válidas, verifica si se está utilizando el separador o delimitador correcto. Deben estar divididas por <strong>|||</strong>.",
    "surveyMigration.error.missingMultipleChoiceOptions.label": "Faltan preguntas de opciones múltiples:",
    "surveyMigration.error.missingMultipleChoiceOptions.options": "Faltan opciones",
    "surveyMigration.error.missingRequiredFile": "El archivo no tiene el campo obligatorio {{field}}.",
    "surveyMigration.error.misspelledRequiredField": "El archivo contiene <strong>{{misspelledField}}</strong> en lugar de <strong>{{requiredField}}</strong>.",
    "surveyMigration.error.nonExistingQuestions": "Estas preguntas no existen en la encuesta:",
    "surveyMigration.error.requiredFields.label": "Errores de campo obligatorio:",
    "surveyMigration.error.supportedFile.description": "Solo se admiten archivos “.xlsx” en este momento.",
    "surveyMigration.error.supportedFile.label": "El archivo no es compatible:",
    "surveyMigration.error.unsupportedTitles.description": "Solo se admiten <strong>ID de empleado</strong>, <strong>Encuesta finalizada</strong> y títulos que comienzan con <strong>answer:::</strong> o <strong>comment:::</strong>.",
    "surveyMigration.error.unsupportedTitles.label": "Títulos/cabeceras no admitidos:",
    "surveyMigration.successAlert.description": "Ten en cuenta que aún puede contener errores no detectados.",
    "surveyMigration.successAlert.title": "El archivo aprobó las pruebas.",
    "surveyMigration.upload.label": "Selecciona tu archivo (solo se admite .xlsx)",
    "surveyMigration.validatingFile": "Validación de archivo:",
    "surveyTemplates": "Plantillas de encuestas",
    "surveyTemplates.description": "Todas las empresas pueden acceder a estas plantillas y compartirlas. Mantenga las nuevas plantillas inactivas hasta que estén listas para compartirse universalmente y tenga cuidado al actualizar las plantillas activas, ya que afectan a todos los clientes.",
    "surveyType": "Tipo de encuesta",
    "surveyType.enName": "Nombre del tipo de encuesta (En)",
    "surveyType.exit": "Salida",
    "surveyType.factor.used": "No se puede eliminar este factor porque se utilizó para las preguntas de la encuesta",
    "surveyType.frName": "Nombre del tipo de encuesta (Fr)",
    "surveyType.name": "Nombre del tipo de encuesta",
    "surveyType.onboarding": "Incorporación",
    "surveyTypes": "Tipos de encuesta",
    "surveyTypes.key": "Clave",
    "surveyTypes.threshold": "Umbral de anonimato",
    "surveyTypesAndFactors": "Tipos de encuesta y factores",
    "surveys": "Encuestas",
    "surveys.addMoreSurveys": "Agregar más encuestas",
    "surveys.cloneDialog.error": "Ya existe una encuesta con este nombre. Introduzca un nombre único.",
    "surveys.create.employees": "Lista de empleados",
    "surveys.create.filter": "Buscar lista de empleados y destinatarios",
    "sv-se": "Sueco",
    "swal.confirm.delete": "¿Está seguro de que desea eliminar este elemento?",
    "swal.error.notfound": "Lo sentimos. No reconocemos esta combinación de nombre de usuario y contraseña. Vuelva a intentarlo.",
    "swal.info.launched": "Se programó la encuesta",
    "swal.message.surveySaved": "Se guardó correctamente. ¡Perfecto!",
    "swal.reminders.already.scheduled": "Ya se programaron los recordatorios para esta encuesta y se enviarán en breve.",
    "swal.reminders.send": "Se enviará un recordatorio a todos los empleados que no completaron aún la encuesta. Tomará aproximadamente {{timeToSendMin}} minutos.",
    "swal.saved": "¡Guardado!",
    "swal.survey.emails.no.language.error": "Es necesario que habilite al menos un idioma para el correo electrónico",
    "switch.current": "Empresa actual",
    "system.field.deleted": "[Atributo eliminado]",
    "system.field.disabled": "Desactivada",
    "system.field.email": "Correo electrónico",
    "system.field.enabled": "Activado",
    "system.field.firstname": "Nombres",
    "system.field.language": "Idioma",
    "system.field.lastname": "Apellidos",
    "system.field.manageremail": "Correo electrónico del líder",
    "system.field.permissions": "Permisos",
    "system.field.reportingMax": "Se permite un máximo de 10 atributos de informe",
    "system.field.startdate": "Fecha de inicio",
    "table.nodata": "No hay nada disponible aquí por el momento... ¡cambiémoslo!",
    "table.stop": "Detener",
    "templates.clone": "Clonar plantilla",
    "templates.cloneDialog.description": "Elija un nombre único para la nueva plantilla.",
    "templates.cloneDialog.error": "Ya existe una plantilla con este nombre. Introduzca un nombre único.",
    "templates.cloneDialog.title": "¿Clonar plantilla \"{{name}}\"?",
    "templates.create": "Crear nueva plantilla",
    "templates.deactivate": "Desactivar plantilla",
    "templates.delete": "Eliminar plantilla",
    "templates.deleteDialog.button.cancel": "Cancelar",
    "templates.deleteDialog.button.delete": "Sí, eliminar",
    "templates.deleteDialog.description": "Al eliminar una plantilla, la borrará de la plataforma de forma permanente y ningún cliente podrá verla ni utilizarla en el futuro.",
    "templates.deleteDialog.description2": "Esta acción no se puede deshacer.",
    "templates.deleteDialog.description3": "¿Seguro que quiere eliminar esta plantilla?",
    "templates.deleteDialog.title": "¿Eliminar plantilla \"{{name}}\"?",
    "templates.edit": "Editar plantilla",
    "templates.lastUpdated": "Última actualización",
    "templates.name": "Nombre de la plantilla",
    "templates.status": "Estado de la plantilla",
    "templates.survey-type.no.compatible": "No hay ningún tipo de encuesta configurado que sea compatible con esta plantilla.",
    "templates.survey-type.no.compatible-plural": "No hay ningún tipo de encuesta configurado que sea compatible con las plantillas disponibles.",
    "templates.survey-type.no.permissions": "No tiene permisos para crear una encuesta de este tipo.",
    "templates.surveyStyles": "Estilos de encuesta",
    "templates.type": "Tipo de encuesta",
    "templates.zeroState": "No hay plantillas configuradas.",
    "term.accept": "Acepto las",
    "term.title": "Condiciones de uso",
    "terms.of.use": "Condiciones de uso",
    "th-th": "Tailandés",
    "thanks.for.rating": "¡Gracias por evaluar!",
    "themes.button.generate": "Identificar temas...",
    "themes.button.regenerate": "Volver a generar temas...",
    "themes.description.generate": "¿Pedir a la IA que organice las respuestas por temas?",
    "themes.description.generate.loading": "La IA está generando temas clave...",
    "themes.description.regenerate": "¿Pedir a la IA que vuelva a realizar el análisis temático?",
    "themes.description.regenerate.loading": "La IA está volviendo a generar temas clave...",
    "themes.toast.error.generate": "No se han podido generar los temas. Inténtalo de nuevo.",
    "themes.toast.error.regenerate": "No se han podido volver a generar los temas. Se han conservado los temas anteriores. Inténtalo de nuevo.",
    "themes.toast.success.generate": "Temas generados correctamente.",
    "themes.toast.success.regenerate": "Los temas se han vuelto a generar correctamente.",
    "tiho.test": "",
    "title.lockedOut": "Su cuenta ha sido bloqueada",
    "tooltip.new": "Nuevo",
    "tooltip.upload": "Cargar",
    "top.attributes": "Los cinco primeros atributos",
    "tr-tr": "Turco",
    "trend.annual": "Anual",
    "trend.group": "Agrupado por",
    "trend.month": "Mes",
    "trend.no.survey": "No se encontró ninguna encuesta",
    "trend.quarter": "Trimestre",
    "trend.search.factor": "Buscar por factor",
    "trend.search.question": "Buscar por pregunta",
    "trend.survey": "Encuesta",
    "trending.heatmap.anonymizedAttributes": "Los siguientes atributos son anonimizados, por ello están excluidos del mapa térmico.",
    "trending.heatmap.uniqueAttributes": "Los siguientes atributos se encuentran disponibles solo en una de las dos encuestas y, por esta razón, no se los incluye en el mapa térmico.",
    "trends.addSurvey": "Agregar encuesta",
    "trends.button.change-timeframes": "Cambiar plazos",
    "trends.button.select-surveys": "Selecciona las encuestas para ver las tendencias",
    "trends.button.select-timeframes": "Tendencia de los plazos de la encuesta continua",
    "trends.empty": "Compara hasta 10 encuestas para determinar la tendencia de los factores y las preguntas en tu organización.",
    "trends.errors.missing-date": "Debe introducir tanto la fecha de inicio como la de finalización en los plazos personalizados",
    "trends.selectSurveyType": "Selecciona un tipo de encuesta",
    "trends.subtitle.time-frames": "Tendencia entre {{count}} plazos seleccionados entre",
    "trends.suppressed.label": "",
    "trends.timeframes-dialog.add-timeframe": "Añadir un plazo",
    "trends.timeframes-dialog.submit-button": "Mostrar tendencias para estos plazos",
    "trends.timeframes-dialog.title": "Elija dos o más plazos para la tendencia",
    "trends.title": "Tendencias",
    "trends.title.trends-for": "Tendencias para",
    "trends.view": "Ver",
    "trigger.status.paused": "En pausa",
    "triggers.type.exitDate": "Fecha de salida",
    "triggers.type.startDate": "Fecha de inicio",
    "update.snapshots": "Actualizar instantáneas",
    "user": "Usuario",
    "user.activation.codeNotFound": "Código de activación no encontrado",
    "user.activation.description": "{{ companyName }} lo invita a sumarse a la plataforma de WorkTango por correo electrónico: {{ userEmail }}",
    "user.activation.loginOrGetInvited": "Si ya ha activado su cuenta, inicie sesión aquí. Si aún no ha activado su cuenta, comuníquese con el administrador de su cuenta para recibir una invitación.",
    "user.activation.success": "¡Se activó correctamente la cuenta!",
    "user.activation.title": "Activación",
    "user.invite.message": "recibió una invitación de %inviter% (%company%) para usar WorkTango, una plataforma que brinda voz a los empleados y les ofrece la posibilidad de enviar comentarios en tiempo real sobre nuestra organización. Haga clic a continuación para completar su inscripción.",
    "user.invite.subject": "Ha recibido una invitación para WorkTango",
    "user.login.email": "Correo electrónico",
    "user.login.forgot": "¿Olvidó su contraseña?",
    "user.login.privacy.notice": "Aviso de privacidad",
    "user.login.privacy.policy": "Política de privacidad",
    "user.login.terms.of.use": "Condiciones de uso",
    "user.not.found": "No se encontró el usuario",
    "user.password.reset.email": "Haga clic a continuación para restablecer la contraseña.",
    "user.password.reset.subject": "Restablecer la contraseña",
    "user.remove.customAttributes": "¿Está seguro de que desea eliminar los atributos personalizados seleccionados previamente?",
    "user.reset.header": "Restablecer la contraseña",
    "user.reset.password": "Ingrese la nueva contraseña",
    "user.reset.password.confirmation": "Confirmar contraseña",
    "user.reset.passwordMatch": "No coinciden las contraseñas",
    "users.addButton": "Agregar usuario",
    "users.column.customPermission": "Personalizar permisos",
    "users.column.customPermissionDesc": "Este usuario tiene permisos personalizados que no puede usar ningún otro usuario.",
    "users.invite.email.addresses": "Direcciones de correo electrónico",
    "users.invite.email.csv": "Use valores separados por comas (CSV) al ingresar correos electrónicos manualmente",
    "users.invite.invited.by": "Invitación de",
    "users.invite.loading.employees": "Cargando empleados...",
    "users.invite.name.from": "Nombre de la persona que envió el correo electrónico de invitación",
    "users.invite.search.employees.and.emails": "Buscar empleados o ingresar dirección personalizada",
    "users.mainHeader": "Usuarios y permisos",
    "users.role.checkbox.cannot.select.kw.default.role": "Si desea personalizar los permisos de esta persona de forma más granular, concédale el rol \"ENCUESTA PERSONALIZADA\" en Gestión de usuarios.",
    "users.role.selectDesc": "Asigna un rol existente al usuario o los usuarios anteriores o configura permisos personalizados para ellos.",
    "users.role.selectLabel": "Selecciona un rol o permiso personalizado",
    "users.role.selectTitle": "Role",
    "users.role.selectedNotice": "A continuación, verás los permisos para {{name}}. Puedes editar estos permisos en la sección Roles.",
    "users.role.selectedNoticeIntegrated": "A continuación se muestran los permisos para {{name}}. Puede cambiar el rol del usuario en el área de Gestión de usuarios o puede concederle un rol \"Personalizado\" para desbloquear los permisos granulares de Encuestas e información.",
    "users.rolePermissionType": "Personalizar permisos",
    "users_one": "{{count}} usuario",
    "users_other": "{{count}} usuarios",
    "validating": "Validando...",
    "view.by": "Visto por",
    "view.communication.templates.for.suggestions": "Vea nuestras plantillas de comunicación para sugerencias",
    "view.content": "Ver contenido",
    "welcome": "¡Recibió una invitación para la plataforma de WorkTango!",
    "wizard.next": "Siguiente",
    "wizard.previous": "Anterior",
    "worktango.admin.export": "Archivo exportado sin procesar",
    "worktango.powered": "Con tecnología de WorkTango",
    "yes_no_banana": "Banana abriéndose",
    "yes_no_check_and_x": "Tilde y X",
    "yes_no_faces": "Caras",
    "yes_no_glasses_of_water": "Vasos de agua",
    "yes_no_ice_box": "Cono de helado",
    "yes_no_lightbulb": "Bombilla",
    "yes_no_mood_weather": "Avatares del clima",
    "yes_no_pizza_box": "Caja de pizza",
    "yes_no_red_rose": "Rosa",
    "yes_no_snowman": "Muñeco de nieve",
    "yes_no_thumbs": "Pulgares",
    "yes_no_toilet_paper": "Papel higiénico",
    "zh-cn": "Chino (simplificado)",
    "zh-tw": "Chino (tradicional)",
    "survey.language.ar-sa": "عربي",
    "survey.language.cs-cz": "Čeština",
    "survey.language.da-dk": "Dansk",
    "survey.language.de-de": "Deutsch",
    "survey.language.el-gr": "Ελληνικά",
    "survey.language.en-ca": "English (CA)",
    "survey.language.en-us": "English (US)",
    "survey.language.es-es": "Español",
    "survey.language.fi-fi": "Suomi",
    "survey.language.fr-ca": "Français (CA)",
    "survey.language.fr-fr": "Français (FR)",
    "survey.language.hi-in": "हिन्दी",
    "survey.language.hu-hu": "Magyar",
    "survey.language.id-id": "Indonesia",
    "survey.language.it-it": "Italiano",
    "survey.language.jp-jp": "日本語",
    "survey.language.ko-kr": "한국어",
    "survey.language.ms-my": "Bahasa Melayu",
    "survey.language.my-mm": "မြန်မာဘာသာ",
    "survey.language.nb-no": "Norsk Bokmål",
    "survey.language.nl-nl": "Nederlands",
    "survey.language.pl-pl": "Polski",
    "survey.language.pt-br": "Português (BR)",
    "survey.language.pt-pt": "Português (PT)",
    "survey.language.ru-ru": "Pусский",
    "survey.language.sq-al": "Shqip",
    "survey.language.sv-se": "Svenska",
    "survey.language.th-th": "แบบไทย",
    "survey.language.tr-tr": "Türkçe",
    "survey.language.zh-cn": "简化字",
    "survey.language.zh-tw": "繁體中文"
  }
}
